module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 1280 1024"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "linear-gradient",
      "x1": "458.66",
      "y1": "484.37",
      "x2": "458.66",
      "y2": "458.5",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#bbbccb"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path"
    }
  }, [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "860.7",
      "y": "215.7",
      "width": "299.3",
      "height": "203.17"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-2"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M903.3,365.3c.6-2,2.2-15.9.3-18s1.3-6.6-1-9.7-3.3,1.8-5.4-.8c-.8-1.1-.9-20.2-2.3-20.8s-28.5,51.8-29.7,54.5-5.2,6.4-6.5,10.3c-.6,1.8.3,4.6,2,6.6s3.4,3.4,4.9,5.2,2.3,3.5,3.8,4.7a35.5,35.5,0,0,0,4.1,2.5c4.8,2.9,7.9-.1,9.6-2.5S902.9,366.7,903.3,365.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-3"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M885.6,327.6l4.3-4.7,22.8-25.3L923,285.9c1-1.2,2-2.6,3.1-3.6s1.5-1,1.7-2.4a9.3,9.3,0,0,0-.5-3.9,6.5,6.5,0,0,0-3.6-4.1c-3.2-1.3-7.8-.6-11.3-.6s-9.2-1-14-1c-2.4,0-4.7-.5-7-.3s-5,.7-6.5,1.9-3,3.7-4.3,5.4L872.1,288c-3.3,4.1-7.2,8.2-9.9,12.7s-6.8,6.4-8.5,10.3c-.8,1.8.4,4.6,2.6,6.6s4.4,3.4,6.4,5.2,3.1,3.5,5,4.7a49.5,49.5,0,0,0,5.3,2.5C879.3,333,883.3,329.9,885.6,327.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-4"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1118.2,299c.8-2.5,1.5-5,2.3-7.5q6.1-20.2,11.9-40.6c1.8-6.2-1.2-6,.5-12.2.5-1.9-1.7,1.5-1-.3s-.8-2-1.7-.7c-8.6,13,2.1-.6,1-1.7s1.3-3.5-1-3.3c-4.3.3-7.3-3.6-11.3-1.7s-11.8-5.4-17.2-2.9c-2.7,1.3,1.6,0-.8,1.5s-6-3.5-7-1.3-.1-.3-.7,2.3c-1.3,5.5-7.8,24.5-9,30s-5.3,14-6.6,20.8c-1,5.2-4.2,10.9-4,16,.1,2.4,2.9,4.9,6.4,6.1s6.8,1.5,9.9,2.4,5.3,2.3,8.1,2.6a61.6,61.6,0,0,0,7.3,0C1114.1,308.4,1117,302.8,1118.2,299Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-5"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1121.4,370.5c1.2-2.5,2.2-5,3.2-7.5q8.6-20.2,16.8-40.6c2.5-6.2-1.7-6,.7-12.2.7-1.9-2.4,1.5-1.4-.3s-1.1-2-2.3-.7c-12.1,13,2.9-.6,1.4-1.7s1.9-3.5-1.4-3.3c-6,.3-10.3-3.6-16-1.7-7.5,2.5-16.7-5.4-24.2-2.9-3.7,1.3,2.3,0-1.2,1.5s-8.5-3.5-9.9-1.3-.1-.3-.9,2.3c-1.8,5.5-10.9,24.5-12.7,30s-7.5,14-9.3,20.8c-1.4,5.2-5.9,10.9-5.6,16,.2,2.4,4.1,4.9,9.1,6.1s9.6,1.5,14,2.4,7.4,2.3,11.4,2.6,7.1,0,10.3,0C1115.6,379.9,1119.6,374.3,1121.4,370.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-6"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M961.7,295c.4-1.9-8.7-31.6-10.1-33.6s1.3-4.7-.4-7.7,2.1-6.3.6-8.8-1.3-3-2.3-3.5-20,42.2-20.9,44.8-3.8,6.1-4.7,9.8c-.4,1.7.2,4.4,1.4,6.3s2.5,3.3,3.6,4.9,1.7,3.3,2.8,4.5a25.9,25.9,0,0,0,3,2.4c3.5,2.8,12.1,1.8,13.4-.5S961.4,296.3,961.7,295Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-7"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M957.3,266.4l-.7-4.7a7,7,0,0,0,.8-3.7l1.5-13.4a5.2,5.2,0,1,0-10.4,0l1.5,13.4a7,7,0,0,0,.8,3.7l-.6,4.9c-2.2,6.1-3.6,16.3-3.8,19.6v10.2h15.1v-9.3A84.6,84.6,0,0,0,957.3,266.4Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-8"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M904.2,403.3c-.8,1.8.4,4.6,2.6,6.6s4.4,3.4,6.4,5.2,3.1,3.5,5,4.7a49.5,49.5,0,0,0,5.3,2.5c6.3,2.9,10.3-.1,12.6-2.5,3.9-4.1,15.1-21.4,18.3-24.9,1.3-1.5,3.4-4.2,3.7-6s2.7-2,2.7-4,0-5.7,0-8.6a87,87,0,0,0-2.5-19.1c-.7-3.1-2.9-5.4-4.5-8s1.5-14.7-.7-13.3-3.9-5.4-5-4C942.9,338.3,905.8,399.5,904.2,403.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-9"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M904.2,403.3c-.8,1.8.4,4.6,2.6,6.6s4.4,3.4,6.4,5.2,3.1,3.5,5,4.7a49.5,49.5,0,0,0,5.3,2.5c6.3,2.9,10.3-.1,12.6-2.5,3.9-4.1,16.8-25.7,19.9-29.2,1.3-1.5,4.7.2,5-1.7s-.3-2-.3-4,0-5.7,0-8.6a87,87,0,0,0-2.5-19.1c-.7-3.1-2.9-5.4-4.5-8s1.5-14.7-.7-13.3-3.9-5.4-5-4C942.9,338.3,905.8,399.5,904.2,403.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-10"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M954.3,335.4s8.5,41,9,44.3.5,3.4,1.3,6.6l1.2,5.4a32.2,32.2,0,0,0-4.2-.1c-1,.1-3.5.3-4.1,1.3s3.9,7.7,4,8.7c-.1-.8-7.2,9.5-7.2,9.5s1.4-16.7,1.1-18c-.7-3.4-.9-9.6-1.6-13s-1.1-7.4-1.6-11a140.4,140.4,0,0,1-1.9-18.4c-.1-4.7,1-5.1,2.6-9.1.9-2.2-.9-3.5-.9-5.9s-4.2-3.4-4-4.9S954.3,335.4,954.3,335.4Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-11"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M954.3,334.6s10.9,56.4,11,56.8a25.8,25.8,0,0,0-3.4,0,17.7,17.7,0,0,0-4.5,1.3c-.8.5,4.3,8.4,4.3,8.4-1,3-1.9,5.9-3.2,6.7s-1.6,1.6-2.2,2.1-3.6,2.3-3.6,2.3c-3.5-3-9.7-11.6-9.7-11.6a19.8,19.8,0,0,0,2.4-5.5c.1-.5.7-10.5,1-15.7s.8-10,1.5-19.6c.4-4.8-1.2-10.6,3-14.4,2.3-2.1-1.9-4.6-1.2-6.9s-2.1-6.7-1.2-8.1S954.2,334.8,954.3,334.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-12"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M940.3,373.3h0l.3.3,1.1,1a3.8,3.8,0,0,0,1.1.6l1.7.6c.7.2,1.1-.2,1.3-.9s.3-.6.5-.9a1.9,1.9,0,0,0,0-1.1,3.6,3.6,0,0,0-.3-1.6l-.4-.6a1.9,1.9,0,0,0-.5-.7,3.7,3.7,0,0,0-3-.4l-1.2.7-.5.4a1.2,1.2,0,0,0-.6,1c0,.2-.2.4-.2.6s.2.2.3.4Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-13"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M945,369.6h.1l.7.5c.8.6,1.4,1.4,2.2,2.1a7.7,7.7,0,0,0,2.2,1.1,22.5,22.5,0,0,0,3.5,1.1c1.5.3,2.2-.5,2.7-1.8s.6-1.1.9-1.7a3.8,3.8,0,0,0,.1-2.2c-.1-1,0-2.3-.6-3.2l-.9-1.3a3.9,3.9,0,0,0-1-1.4,7.5,7.5,0,0,0-6-.7,9.2,9.2,0,0,0-2.5,1.4l-1,.8a2.5,2.5,0,0,0-1.2,1.9c-.1.4-.3.9-.4,1.3s.4.5.6.9A10.1,10.1,0,0,0,945,369.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-14"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M948.3,377.3h.1l.7.5c.8.6,1.4,1.4,2.2,2.1a7.7,7.7,0,0,0,2.2,1.1,22.6,22.6,0,0,0,3.5,1.1c1.5.3,2.2-.5,2.7-1.8s.6-1.1.9-1.7a3.8,3.8,0,0,0,.1-2.2c-.1-1,0-2.3-.6-3.2l-.9-1.3a3.9,3.9,0,0,0-1-1.4,7.5,7.5,0,0,0-6-.7,9.2,9.2,0,0,0-2.5,1.4l-1,.8a2.5,2.5,0,0,0-1.2,1.9c-.1.4-.3.9-.4,1.3s.4.5.6.9A10.1,10.1,0,0,0,948.3,377.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-15"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M944.3,389.6h.1l.7.5c.8.6,1.4,1.4,2.2,2.1a7.7,7.7,0,0,0,2.2,1.1,22.5,22.5,0,0,0,3.5,1.1c1.5.3,2.2-.5,2.7-1.8s.6-1.1.9-1.7a3.8,3.8,0,0,0,.1-2.2c-.1-1,0-2.3-.6-3.2l-.9-1.3a3.9,3.9,0,0,0-1-1.4,7.5,7.5,0,0,0-6-.7,9.2,9.2,0,0,0-2.5,1.4l-1,.8a2.5,2.5,0,0,0-1.2,1.9c-.1.4-.3.9-.4,1.3s.4.5.6.9A10.1,10.1,0,0,0,944.3,389.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-16"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1047.7,167.7s-67.9-39.6-73.7-47.1h0s-63.4,97.1-62.9,98.2h104C1020.7,211,1046.5,171.7,1047.7,167.7Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-17"
    }
  }, [_c('circle', {
    staticClass: "cls-1",
    attrs: {
      "cx": "1010.5",
      "cy": "144.3",
      "r": "44"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-18"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1107.9,113.8s-63.5-45.8-69.3-53.2h0s-91.4,141.2-91,142.3l68.8,42.9C1022.1,238.1,1106.8,117.8,1107.9,113.8Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-19"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M633.3,633.5c-68.7.8-137.7-6.1-206.7-6.1-15.4,0-30.3,1.8-45.7,1.6-6.9-.1-11.8,2.4-17.7,6.2s-14.6,6.3-22.8,8.4-14.7,4.2-19.1,7.4c-9.9,7.2-6.5,17,0,24.3,4.6,5.2,9.3,10.1,19.2,14.1,42.1,17.4,87.5,21.3,131.9,24.1,55.5,3.6,107.8,4.1,163.2-5.9,27.1-4.9,54.4-8.5,81.6-12.9,23.8-3.9,51.4-6.2,73.3-18.1,11.7-6.3,33.8-24.2,18.5-39-8-7.8-21.5-4.4-31.2-3.4-27.1,2.7-54.5-1-81.6-1.1C675.2,632.9,654.2,633.2,633.3,633.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-20"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1092,625l-1.1-.2c-8-1-17.5,1.6-25.5,2.2a244.9,244.9,0,0,1-46.6-.9c-20.7-2.3-41.3-2.1-62-4.8s-39.8,0-59.8,0c-14.5,0-28.6,1.6-43.1,1.4-6.5-.1-11.2,2.1-16.7,5.3s-13.8,5.4-21.5,7.2-13.9,3.6-18,6.3c-9.4,6.2-6.1,14.6,0,20.9,4.3,4.5,8.8,8.7,18.1,12.2s15.5,7.6,28.3,9.6c15.8,2.4,36.3,3.3,53.6,4.2,9.5.5,18.5,2.4,28.3,2.4,6.7,0,7.4-.6,13.7.6s10.9,2.1,17.1,2.7c10.5,1,22.6,1.4,33.3,2.4,8.3.7,18.9,2.4,28,2.7,7,.2,15.4-.2,22.4-.4a149.9,149.9,0,0,0,45.2-8.4c10.7-3.6,20.9-4.9,35.1-6.9,10.1-1.4,19.2-2.4,29.9-3.2a435.4,435.4,0,0,0,50.3-6.1c14.8-2.8,29.6-5.8,39.4-10.6s31.9-20.9,17.5-33.6c-7.6-6.7-20.3-3.8-29.5-2.9-25.6,2.3-51.4-.8-77-.9-11.4,0-22.6,1.2-34,1.2-5.9,0-12.5.9-18.3-.2C1096.6,626.6,1094.4,625.5,1092,625Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-21"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "1122.2 485.7 1154.1 467.4 1201.3 467.4 1169.2 485.9 1122.2 486"
    }
  })]), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-2",
      "x1": "1141.29",
      "y1": "478.5",
      "x2": "1161.92",
      "y2": "478.5",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff",
      "stop-opacity": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.13",
      "stop-color": "#fffefc",
      "stop-opacity": "0.02"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.26",
      "stop-color": "#fffaf1",
      "stop-opacity": "0.06"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.38",
      "stop-color": "#fff3e0",
      "stop-opacity": "0.14"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.5",
      "stop-color": "#ffeac7",
      "stop-opacity": "0.24"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.63",
      "stop-color": "#ffdda7",
      "stop-opacity": "0.38"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.75",
      "stop-color": "#ffce81",
      "stop-opacity": "0.55"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.87",
      "stop-color": "#ffbd53",
      "stop-opacity": "0.75"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.99",
      "stop-color": "#ffa91f",
      "stop-opacity": "0.98"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ffa71a"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-3",
      "x1": "1165.17",
      "y1": "473.2",
      "x2": "1186.4",
      "y2": "473.2",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff",
      "stop-opacity": "0"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.18",
      "stop-color": "#fffcf8",
      "stop-opacity": "0.02"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.36",
      "stop-color": "#fff4e3",
      "stop-opacity": "0.06"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.53",
      "stop-color": "#ffe7c0",
      "stop-opacity": "0.14"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.71",
      "stop-color": "#ffd48f",
      "stop-opacity": "0.24"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.88",
      "stop-color": "#ffbc51",
      "stop-opacity": "0.38"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ffa71a",
      "stop-opacity": "0.5"
    }
  })], 1), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-22"
    }
  }, [_c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M1205,442.5c0-.1,0-.2,0-.3s0,0,0-.1a6.4,6.4,0,0,0,0-1.4h0v-.2h0a.9.9,0,0,0-.3-.6h-1.3c-2.3-.3-41.4,0-43.3,0s-4.9,1.9-4.9,1.9a55.1,55.1,0,0,1-5,2.7l-7.6,3.8-8.2,4-6.8,3.4a20.6,20.6,0,0,0-3.4,1.8h-.7l-.2.2c-.3.4-.1.9-.1,1.4h1.6l-.9.3c-.3.1-.6.3-.9.3s-.1,2.1.6,2.3h49.4c1.1-.1,8.9-3.8,13.1-6.7s17.4-9.8,17.4-9.8,1.8-.2,1.6-2.9Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-24"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1071.1,438.6a28.8,28.8,0,0,0-49.5-20l-28.3,24.2a29.2,29.2,0,1,0,36.5,44.9L1059,462A28.8,28.8,0,0,0,1071.1,438.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-25"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "862.4 679.4 1273.4 679.4 1205.4 810.2 746.3 810.2"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-26"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "1273.3 680.2 1273.3 887 1204.5 1024 1205.5 810.4"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-27"
    }
  }, [_c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "745.1",
      "y": "810.4",
      "width": "460.8",
      "height": "211.8"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-28"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M868.8,735.3l-3.3-24.7c0-.2.1-4,.1-4.4l3.3,24.7C869,731.3,868.8,735.1,868.8,735.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-29"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "867.7 681.9 854.2 698.8 853.3 699.9 853.4 699.9 847 707.9 847 712.9 831.7 728.6 840.7 728.4 840.6 728.6 831.7 728.6 831.7 741.2 868.7 741.2 876.9 720.6 884 720.6 884 707.9 884.2 707.9 884.2 708.6 884.2 708.6 884.3 720.6 905.7 693.9 906.2 681.9 867.7 681.9"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-30"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1227.7,708.5h-62.4V646.9a7.6,7.6,0,0,1,7.5-7.6h47a7.6,7.6,0,0,1,7.5,7.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-31"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1192,639.3h-16.8v-9.5c0-.6.9-1.2,2-1.2h12.7c1.1,0,2,.5,2,1.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-32"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "1228 696.8 1161.7 696.8 1167.8 708.5 1228 708.5 1228 696.8"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-33"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1183,708.3l2.6-72.1,34.1-.8a8.9,8.9,0,0,1,8,9l.2,58.4v5.6Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-34"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1059.6,730.7l-.2.2V720.4h-.2a9.6,9.6,0,0,0-.2-1.2,3,3,0,0,0,.3-1.3,3.6,3.6,0,0,0-1.2-2.5l-1.3-2.5-3-.6-1.7-2.6-.6-.5v-.2c0-.2-.4-.4-1-.5h0v-5l-1.5-1.5-.8-4.3h0c-.1-.3-.7-.5-1.5-.5s-1.3.2-1.5.5h0l-.8,4.3-1.5,1.5v4.9l-1.7,1.5-1.7,2.6-3,.6-2,3.8h.1a2.9,2.9,0,0,0,0,2.5,9.6,9.6,0,0,0-.2,1.2h-.1v53.1c0,6.1,5.6,11,12.5,11s12.5-4.9,12.5-11h.2V754.3l.2-.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-35"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1041.8,763.3c-.1-7.8-9.2-14.2-20.4-14.2s-20.3,6.3-20.4,14.2h0v2.9a10.2,10.2,0,0,0,0,4.5v12.4h.1c.7,7.5,9.6,13.4,20.4,13.4s19.6-5.9,20.4-13.4h.1V763.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-36"
    }
  }, [_c('ellipse', {
    staticClass: "cls-1",
    attrs: {
      "cx": "1021.3",
      "cy": "763.5",
      "rx": "16.4",
      "ry": "11.6"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-37"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1156.8,735s-3.7,6.1-7,7.5-12.5,1.2-12.5,1.2v2.7l-7,.2v2.7l-12,.4v-.6l-39,1.4h-.5l3.6,4h1.8l34.3-1v-.6l11.9-.4v3.2l7-.2v1.2s8.5-1,12.6.4,7.5,7,7.5,7v.4a14.7,14.7,0,1,0-1-29.3Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-38"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1186.7,749.5s-4.3,5.7-7.8,6.7-12.6-.1-12.6-.1l-.2,2.7-7-.5-.2,2.7-11.6-.8-.2-.7-39.5-2.8a2.3,2.3,0,0,0-1.9,2.1,2.3,2.3,0,0,0,.1.7,1.7,1.7,0,0,0,.4.8,1.8,1.8,0,0,0,1.1.7h.2l39.3,2.7.3-.6,11.6.8-.2,3.2,7,.5v1.2s8.6-.1,12.5,1.7,6.7,7.8,6.7,7.8l.7-9.2-.7,9.6a14.7,14.7,0,1,0,2.1-29.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-39"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1177,762h0s-3.2,6.4-6.5,8-12.4,2.1-12.4,2.1l.3,2.7-7,.7.3,2.7-10.3,1.1a2.2,2.2,0,0,0-1.6-.5l-10.2,1.1a.5.5,0,0,0-.6-.3l-17.3,1.8v.8l-11.3,1.2.2,2.2v1.2l11.3-1.2v.8l17.3-1.8a.5.5,0,0,0,.5-.4l10.2-1.1a2.2,2.2,0,0,0,1.5-.8l10.3-1.1.3,3.2,7-.7v1.2s8.4-1.6,12.6-.5,8,6.5,8,6.5v.4A14.7,14.7,0,0,0,1177,762Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-40"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M965.5,749.1v-.8l-8.2,1.5.2.9s-1.2,6.3-3.9,7.9-8.8,2.3-8.8,2.3v.4l-6.6,1.3.3,1.5h0L927.6,766l-32.6,5.7h0l-.6.2-2.2.4h0l-1.5.7,1.7.2,1.8-.3h.8l3.3-.6,40.3-6.9.4,2.2h0v.4l6.6-1.2v.4s5.9-1.7,8.9-1,5.8,4.4,6.5,5.4l.2,1.2,8.2-1.5-.2-1.1a10.8,10.8,0,0,0-3.8-20.8Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-41"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M967.5,786.7a10.8,10.8,0,0,0-4.1-9.9l-1.7-1.1-1-.4-.4-.2-.3-.4-.3-.2-.5-.3h-.8l-1.6-.2-2-.3h-1.8l-.4.2-.3.3-.2.3-1.1,1.8a18.1,18.1,0,0,1-2.2,2.7,6.1,6.1,0,0,1-2.8,1.8c-3,.7-9-.5-9-.5v.4l-6.7-.9-.2,1.6-11.9-1.7-38.7-5.5h-.5l3.3,2.3,1.8.3h0l1.5.2,44.3,6.2-.2,1.4h0v.4l6.6.8v.4s6.1.2,8.7,1.8,4.2,6,4.5,7.2h0c0,.1,0,.2,0,.3v.3a.8.8,0,0,0,.6.5h.6l1.4.2,3.6.5h1.1l.3-.2.4-.2h.1a1.3,1.3,0,0,0,0-.3A10.8,10.8,0,0,0,967.5,786.7Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-43"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M1000.2,722.2a11.6,11.6,0,0,0-17.5,9l-57.8-34a2.1,2.1,0,0,0-2.1,3.6l60.6,35.7a11.6,11.6,0,1,0,16.7-14.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-44"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M924.3,729.9l-3-1.6-22.2,8.3-4.8,4.6v9.5l9.9,4.8,8.4-2.2h0l16-11.5v-9.7Zm-20,16.1h0Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-45"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M955.8,716.1l-3.1,1.6-18.9,8.2-9.2,4-5.5,3.3,9.5,4.7,7.9-5h0l16.9-10.4,5.6-.4-3.3-5.8h0ZM929,728.5h0Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-47"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M834,780.8s6.6,2.5,15-1.1a15.5,15.5,0,0,0,8.3-8.4c1.5,3.6-2.5,8.6-9,11.3S835.5,784.4,834,780.8Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-48"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M859.4,768.7s-11.5,1.2-17.9,4a43.8,43.8,0,0,0-10.2,6.1c-2.5-8.2,2.2-12.7,8.5-15.4S856.4,760.5,859.4,768.7Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-49"
    }
  }, [_c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M784.5,802.4l34-14.4a2.1,2.1,0,0,0,1.6-2.5l-1-2.3-1.2-3.5c-.7-1.2-1.6-1.2-2.9-.8-11.2,3.9-22.4,7.7-33.6,11.5-3.6,1.2-5.8,3.3-6,7.2l1.2,3,.5.2A6.1,6.1,0,0,0,784.5,802.4Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-50"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "720 508.5 666.8 509 680.4 474.8 774.5 474.9 774.1 490.4 738.6 512.4 720 508.5"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-51"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "516.6 499.1 422.9 499.1 467.8 474 557.6 474 516.6 499.1"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-52"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M728.8,465.2h-3.6v-5.6h-8.8v5.6h-3a8,8,0,0,0-8,8v16.7a8,8,0,0,0,8,8h15.3a8,8,0,0,0,8-8V473.2A8,8,0,0,0,728.8,465.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-53"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M707.8,508.2H690.5l-2.2-3.2-.2-35.4c0-2.5.2-4.6,1.6-4.6h19c1.5,0,1.5,4.4,1.4,4.6l-.3,35.4Z"
    }
  })]), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-4",
      "x1": "227.4",
      "y1": "410.17",
      "x2": "227.4",
      "y2": "146.07",
      "xlink:href": "#linear-gradient-2"
    }
  }), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-54"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M331.4,747.2l-1.3-.2c-9.5-1.2-20.8,1.9-30.3,2.7a290.9,290.9,0,0,1-55.3-1.1c-24.5-2.7-49.1-2.5-73.6-5.7s-47.3,0-70.9,0c-17.3,0-34,1.9-51.2,1.6-7.7-.1-13.3,2.5-19.8,6.3-8.1,4.8-16.3,6.4-25.5,8.5s-16.5,4.3-21.4,7.5c-11.1,7.4-7.3,17.4,0,24.9,5.2,5.3,10.5,10.3,21.5,14.4s18.4,9.1,33.6,11.3c18.8,2.8,43.1,3.9,63.6,5,11.3.6,21.9,2.9,33.6,2.8,8,0,8.8-.7,16.2.7s12.9,2.5,20.3,3.2c12.4,1.2,26.8,1.7,39.5,2.8,9.8.9,22.4,2.9,33.2,3.2,8.3.2,18.3-.3,26.5-.4,21.3-.5,39.2-5.1,53.6-10,12.7-4.3,24.8-5.8,41.6-8.1,12-1.7,22.8-2.9,35.5-3.7a516.6,516.6,0,0,0,59.7-7.3c17.6-3.3,35.1-6.8,46.8-12.6s37.8-24.7,20.7-39.9c-9-8-24-4.5-35-3.5-30.3,2.7-61.1-1-91.4-1.1-13.5-.1-26.8,1.4-40.3,1.4-7,0-14.9,1.1-21.8-.2C336.8,749.1,334.2,747.8,331.4,747.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-55"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M423,522.3l-1.4-7.3H336.9s-43,17.9-48.5,22.9c-.6,0-.9.2-.5.9,1.4,2.8,0,18.2,0,18.2l4.2,5.6H388l27.3-18.9,7-7.7,1.5-7.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-56"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M290.6,492.7l-3.7,6.4-1,8,.2,11.3v3.9l-.4,6.8,1.6,7.2-1,9.5s-1,6-.6,8.6,1.9,10.5,1.9,11.3-.4,11.9-.4,11.9l1.2,6.8,2.9,3.7,7.8,2.3,8-.4,9.3-.6,12.1.2h15l8.8-.8H364s4.4,1,5.4,1,7.2-.8,7.2-.8l11.4.8s6.6-1.2,7.4-1.2l14,1.2s6.8.4,7.6,0,8.4-1.6,8.4-1.6l2-5.2,2.2-3.8.4-6.2v-7a50.5,50.5,0,0,0,.4-5.6c0-2.5-1.6-8-1.6-10.3s.6-7,.6-7l.2-8.6V522.9l.8-3.9V516a41.2,41.2,0,0,0-.8-4.9,6.4,6.4,0,0,1,.2-2.3v-7.8l-.8-2.7-2.1-1.6s-.2-1.2-.8-1.4a11.9,11.9,0,0,1-1.9-1l-5.6-2.5-3.5.2h-2.5l-5.7.6h-13l-2.3.4h-5.1l-6.6-1.4c-.6-.2-7.1.2-7.1.2l-5.6.2-3.7.8-8.6,1-3.5-.4-6.6-.6L335,491.5l-4.3,1c-.6.2-4.7.6-4.7.6l-7-.6h-1.6l-2.5-.2h-4.1l-4.9-.6-3.9,1.2-4.1-1.2-3.1.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-59"
    }
  }, [_c('path', {
    staticClass: "cls-2",
    attrs: {
      "d": "M430.7,487c0-.2,0-.3,0-.5s0-.1,0-.1a8.1,8.1,0,0,0,0-2.1h0v-.4h0a1.3,1.3,0,0,0-.6-.8h0l-.3-.2h-2c-3.9-.5-70.8,0-74.1,0s-8.3,2.9-8.3,2.9c-2.7,1.5-5.7,2.8-8.5,4l-13,5.7-14,6-11.7,5a37.4,37.4,0,0,0-5.9,2.7H291l-.4.2c-.5.6-.1,1.4-.1,2a10.2,10.2,0,0,1,1.7.1h.5l.4.2h0l.2.2h.1l-1.6.4a4.5,4.5,0,0,1-1.5.4c.2,0-.2,3.1,1.1,3.4h80a35.2,35.2,0,0,0,3.8,0h.8c2-.1,15.2-5.6,22.4-9.9S427.9,492,427.9,492s3.1-.2,2.8-4.3C430.7,487.4,430.7,487.2,430.7,487Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-60"
    }
  }, [_c('ellipse', {
    staticClass: "cls-1",
    attrs: {
      "cx": "240.4",
      "cy": "441.1",
      "rx": "5.5",
      "ry": "9.9"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-61"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "295.6 493.7 295.5 468.4 252 468.3 209.5 495.2 209.5 520.5 253 520.5 253.5 520.2 253.6 520.2 295.6 493.7"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-62"
    }
  }, [_c('ellipse', {
    staticClass: "cls-1",
    attrs: {
      "cx": "270.7",
      "cy": "441.1",
      "rx": "5.5",
      "ry": "9.9"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-63"
    }
  }, [_c('circle', {
    staticClass: "cls-4",
    attrs: {
      "cx": "206.4",
      "cy": "611.8",
      "r": "5.2"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-64"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "69.7 769.5 344.3 770.6 239.9 861.1 85 861.1"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-65"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "212.5 769.5 344.3 770.6 236.4 862.8 215.9 862.5"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-66"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "0 814.5 67.3 769.6 74 866.5 0 866.5 0 817"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-67"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "469.2 850.4 391.2 851.4 306.9 898 402.9 897.1"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-68"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "374.6 845.5 296.5 846.3 212.2 889 308.2 888.2"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-69"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "444.1 881.7 0 879 0 986 437 983.8 436.1 889.5 444.1 881.7"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-70"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "580.4 752 436 889.5 436.7 1024 439.5 1028.7 439.5 1024 439.5 1024 450.5 1027.3 450.5 1024 450.6 936.5 548.3 843.3 548.3 1024 567.2 1021.3 567.2 1030.7 579.5 1024 579.5 867.6 580.4 867.7 580.4 752"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-71"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M183.9,736c-2.5-27.9-16.7-48.7-34.2-48.7-19.4,0-34.6,25.3-34.6,57.7h.1c0,.5-.1,1-.1,1.5v70.8c-2.2.7-3.6,1.9-3.6,3.2v15.7l-2-.2H106a7.4,7.4,0,0,0-3.9-1H91V814.9c1.1-.3,1.8-.9,1.8-1.4V797.8c0-1-2.1-1.8-4.7-1.8s-4.7.8-4.7,1.8v15.7c0,.6.7,1.1,1.8,1.4V835c-5.5.2-7.5,4.8-7.5,10.5v.4c0,5.8,2.1,10.5,7.8,10.5h15.4a8.5,8.5,0,0,0,4.1-1h4.4l2-.2v15.1c-4.6,1.1-7.6,3-7.6,5.2s7.8,6.3,17.5,6.3,17.5-2.8,17.5-6.2-3.3-4.2-8.3-5.3V820.5c0-1.4-1.6-2.6-4.1-3.4V746.5c0-.5,0-1-.1-1.5h.1c0-12.9,2.8-25,7.8-34s10-12.3,15.6-12.3,11.2,4.5,15.6,12.3,6.3,15.5,7.3,25h-1.2v12.3h14V736Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-72"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "418.5 696 553.3 696.8 490.2 751.4 427.9 770.2"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-74"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "553.3 696.8 565.5 695 553.6 758.4 496 806.5"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-75"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "422.3 718.3 498.3 741 461.6 772.6 425.8 772.8"
    }
  })]), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-5",
      "x1": "423.63",
      "y1": "761.18",
      "x2": "427.06",
      "y2": "761.18",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ffc654"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-6",
      "x1": "436.72",
      "y1": "765.47",
      "x2": "439.3",
      "y2": "765.47",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-7",
      "x1": "421.06",
      "y1": "752.59",
      "x2": "423.2",
      "y2": "752.59",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-8",
      "x1": "409.25",
      "y1": "763.54",
      "x2": "412.68",
      "y2": "763.54",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-9",
      "x1": "398.3",
      "y1": "764.19",
      "x2": "401.74",
      "y2": "764.19",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-10",
      "x1": "459.69",
      "y1": "750.66",
      "x2": "463.13",
      "y2": "750.66",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-11",
      "x1": "451.32",
      "y1": "760.32",
      "x2": "454.75",
      "y2": "760.32",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-12",
      "x1": "447.03",
      "y1": "750.23",
      "x2": "449.17",
      "y2": "750.23",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-13",
      "x1": "434.15",
      "y1": "742.51",
      "x2": "436.29",
      "y2": "742.51",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-14",
      "x1": "413.76",
      "y1": "752.17",
      "x2": "415.9",
      "y2": "752.17",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-15",
      "x1": "455.83",
      "y1": "740.57",
      "x2": "457.97",
      "y2": "740.57",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-16",
      "x1": "466.99",
      "y1": "758.18",
      "x2": "469.14",
      "y2": "758.18",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-17",
      "x1": "484.38",
      "y1": "742.51",
      "x2": "486.52",
      "y2": "742.51",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-18",
      "x1": "475.84",
      "y1": "750.23",
      "x2": "477.45",
      "y2": "750.23",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-19",
      "x1": "470.48",
      "y1": "742.72",
      "x2": "472.09",
      "y2": "742.72",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-76"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M467.4,781.5H299.8v21.2h9.7l9.2,26.9L461.2,817l.7-14.3h5.5Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-77"
    }
  }, [_c('polygon', {
    staticClass: "cls-1",
    attrs: {
      "points": "570.9 689.9 463.6 784.8 459.5 839.4 459.5 839.4 459.5 839.4 459.5 839.4 476.1 825.1 476.1 825.1 476.1 825.1 555.1 755.9 559.7 720.4 572.3 710.1 572.9 690.1 569.4 689.5 569.4 691.2 569.4 691.2 570.9 689.9"
    }
  })]), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-20",
      "x1": "372.55",
      "y1": "753.88",
      "x2": "507.06",
      "y2": "753.88",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0",
      "stop-color": "#fff"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.16",
      "stop-color": "#ffe8dc"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.45",
      "stop-color": "#ffc2a3"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.69",
      "stop-color": "#ffa678"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "0.88",
      "stop-color": "#ff955f"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "1",
      "stop-color": "#ff8f55"
    }
  })], 1), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-21",
      "x1": "1284.55",
      "y1": "761.61",
      "x2": "1287.98",
      "y2": "761.61",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-22",
      "x1": "1294.85",
      "y1": "767.48",
      "x2": "1297.42",
      "y2": "767.48",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-23",
      "x1": "1277.25",
      "y1": "758.32",
      "x2": "1279.4",
      "y2": "758.32",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-24",
      "x1": "1331.77",
      "y1": "768.19",
      "x2": "1335.2",
      "y2": "768.19",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-25",
      "x1": "1267.09",
      "y1": "747.87",
      "x2": "1270.52",
      "y2": "747.87",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-26",
      "x1": "1315.88",
      "y1": "756.39",
      "x2": "1319.32",
      "y2": "756.39",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-27",
      "x1": "1307.51",
      "y1": "766.05",
      "x2": "1310.95",
      "y2": "766.05",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-28",
      "x1": "1303.22",
      "y1": "755.96",
      "x2": "1305.37",
      "y2": "755.96",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-29",
      "x1": "1290.34",
      "y1": "748.23",
      "x2": "1292.49",
      "y2": "748.23",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-30",
      "x1": "1298.07",
      "y1": "744.44",
      "x2": "1300.21",
      "y2": "744.44",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-31",
      "x1": "1312.02",
      "y1": "746.3",
      "x2": "1314.17",
      "y2": "746.3",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-32",
      "x1": "1323.18",
      "y1": "763.9",
      "x2": "1325.33",
      "y2": "763.9",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-33",
      "x1": "1340.57",
      "y1": "748.23",
      "x2": "1342.71",
      "y2": "748.23",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-34",
      "x1": "1332.04",
      "y1": "755.96",
      "x2": "1333.65",
      "y2": "755.96",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-35",
      "x1": "1326.67",
      "y1": "748.45",
      "x2": "1328.28",
      "y2": "748.45",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('linearGradient', {
    attrs: {
      "id": "linear-gradient-36",
      "x1": "1278.18",
      "y1": "753.6",
      "x2": "1280.33",
      "y2": "753.6",
      "gradientTransform": "matrix(-1, 0, 0, 1, 1751.25, 0)",
      "xlink:href": "#linear-gradient-5"
    }
  }), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-78"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M272.2,823.1l7.5,1.7s19.1-1.7,18-.5l-.3.4,4.8,1.1,6.1,11.7c0-.3,25.9-1.9,25.9-1.9l28.5,2.1,11.2,3.7,1.3,4.1-1.3,2.6-9.6,2.2-18.7.4-23.9-.9-15.6-4.4-18.3,12.6-5.3,1.2-20-2.6v-.2l-1.8-.3v-.6l-12-3-9.3-4.7-1.4-7.8,21.2-24A30.4,30.4,0,0,0,272.2,823.1Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-79"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M472.3,841.2c0-.2,0-.4,0-.6,0-7.1-3.2-13.9-8.7-19.4a3,3,0,0,1,.1.8,7.3,7.3,0,0,1-2.1-1.1,4.3,4.3,0,0,1-1-1.9h.5a46,46,0,0,0-14.4-8.1h0a3.8,3.8,0,0,1-2.8.2,4.1,4.1,0,0,1-2.7-1.8,55.5,55.5,0,0,0-12.8-1.5,50.3,50.3,0,0,0-30.9,10.2,6,6,0,0,1-1.4,2.6,5.1,5.1,0,0,1-3,1.5,33.8,33.8,0,0,0-5.1,6.9s-.1,1-.1,3.3-2.5,4.4-2.5,4.4h-.3a24,24,0,0,0-.5,4.7c0,10.4,6.9,13.4,17.6,14.1h-.1a2.4,2.4,0,0,1,2-.8,3.1,3.1,0,0,1,2.4,1.1c3.8.1,7.9,0,12.2-.1a5.6,5.6,0,0,1,3.8-1.4,9.3,9.3,0,0,1,4.7,1.3h10.5a6.7,6.7,0,0,1,4-1.6,8.6,8.6,0,0,1,4.5,1.6v.2c13.9-.1,23.8-2,25.3-12.2h-.1a3,3,0,0,0,.3-1.4,2.1,2.1,0,0,0-1-2A2.3,2.3,0,0,1,472.3,841.2ZM443.2,814h0ZM390,832.5a4.3,4.3,0,0,1-1.3,3A4.4,4.4,0,0,0,390,832.5ZM402.9,852a2.8,2.8,0,0,1,2-.8A3.1,3.1,0,0,0,402.9,852Zm67.4-12,.8.2Z"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-80"
    }
  }, [_c('ellipse', {
    staticClass: "cls-1",
    attrs: {
      "cx": "429.7",
      "cy": "833.7",
      "rx": "50.5",
      "ry": "35.5"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "clip-path-83"
    }
  }, [_c('polyline', {
    staticClass: "cls-1",
    attrs: {
      "points": "579.9 753 580.4 812 436.7 948 436 889.5 503.3 827.1"
    }
  })]), _vm._v(" "), _c('image', {
    attrs: {
      "id": "image",
      "width": "1920",
      "height": "1417",
      "xlink:href": require("../assets/img/textures/white_texture.png")
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "id": "image-2",
      "width": "1920",
      "height": "1417",
      "xlink:href": require("../assets/img/textures/black_texture.png")
    }
  })], 1), _vm._v(" "), _c('title', [_vm._v("main")]), _vm._v(" "), _c('g', {
    staticClass: "cls-5"
  }, [_c('g', {
    attrs: {
      "id": "wall"
    }
  }, [_c('rect', {
    staticClass: "cls-6",
    attrs: {
      "x": "-2.1",
      "y": "-9",
      "width": "1285.8",
      "height": "1036.05"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "cls-7",
    attrs: {
      "transform": "translate(605.5 96.2) scale(0.35)",
      "xlink:href": "#image"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "cls-7",
    attrs: {
      "transform": "translate(605.5 96.2) scale(0.35)",
      "xlink:href": "#image"
    }
  }), _vm._v(" "), _c('use', {
    staticClass: "cls-7",
    attrs: {
      "transform": "translate(3.6 96.2) scale(0.35)",
      "xlink:href": "#image"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-8",
    attrs: {
      "x": "117.1",
      "y": "215.7",
      "width": "684.6",
      "height": "245.2"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-9",
    attrs: {
      "x": "793.8",
      "y": "215.7",
      "width": "11.2",
      "height": "245.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-10",
    attrs: {
      "points": "92 484.4 803 484.4 825.3 458.5 112.5 458.5 92 484.4"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-11",
    attrs: {
      "x": "112.5",
      "y": "451.9",
      "width": "712.9",
      "height": "9"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-12",
    attrs: {
      "x": "117.2",
      "y": "297.7",
      "width": "678.8",
      "height": "4.31"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-12",
    attrs: {
      "x": "117.2",
      "y": "368.7",
      "width": "678.8",
      "height": "4.31"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "178.7",
      "y": "215.8",
      "width": "5.3",
      "height": "236.33"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "246.7",
      "y": "215.8",
      "width": "5.3",
      "height": "236.33"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "314.7",
      "y": "216.3",
      "width": "5.3",
      "height": "235.92"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-12",
    attrs: {
      "x": "318.3",
      "y": "216.3",
      "width": "7.3",
      "height": "235.92"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "382.7",
      "y": "216.1",
      "width": "5.3",
      "height": "236.08"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "450.3",
      "y": "215.8",
      "width": "5.3",
      "height": "236.33"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-14"
  }, [_c('image', {
    attrs: {
      "width": "672",
      "height": "661",
      "transform": "translate(81.1 179.7) scale(0.48)",
      "xlink:href": require("../assets/img/textures/light_texture.png")
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-14"
  }, [_c('image', {
    attrs: {
      "width": "552",
      "height": "661",
      "transform": "translate(207.9 179.7) scale(0.48)",
      "xlink:href": require("../assets/img/textures/light_texture2.png")
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "520",
      "y": "216.1",
      "width": "5.3",
      "height": "236.08"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "588",
      "y": "216.1",
      "width": "5.3",
      "height": "236.08"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "656",
      "y": "216.1",
      "width": "5.3",
      "height": "236.08"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "724",
      "y": "216.1",
      "width": "5.3",
      "height": "235.83"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-13",
    attrs: {
      "x": "791.7",
      "y": "216.1",
      "width": "5.3",
      "height": "235.83"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-12",
    attrs: {
      "x": "592",
      "y": "216.1",
      "width": "7.3",
      "height": "236.08"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-15",
    attrs: {
      "x": "117.2",
      "y": "215.7",
      "width": "679.5",
      "height": "4.31"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "yellow_board",
      "data-name": "yellow board"
    }
  }, [_c('rect', {
    staticClass: "cls-16",
    attrs: {
      "x": "857.1",
      "y": "213.7",
      "width": "301.3",
      "height": "203.17"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-17",
    attrs: {
      "clip-path": "url(#clip-path)"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "350.4",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "359.5",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "368.3",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "376.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "385.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "394.7",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "403.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "412.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "421.7",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "431.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "440.7",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "449.5",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "458",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "467.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "475.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "485",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "494.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "502.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "513.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "522.2",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "530.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "539.4",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "548.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "557.3",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "566.4",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "575.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "584.3",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "594.2",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "603.4",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "612.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "620.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "629.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "638.5",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "647.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "656.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "665.5",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "676.7",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "685.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "694.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "703.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "712.2",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "721",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "730.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "739.3",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "748",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "757.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "767.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "775.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "784.3",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "793.4",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "802.2",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "811.3",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "820.5",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "829.2",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "535",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "545.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "556.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "566.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "577.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "587.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "598.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "608.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "839.4",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "848.5",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "857.3",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "865.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "874.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "883.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "892.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "901.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "910.7",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "618.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "629.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "639.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "650.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "661",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "671.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "682.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "920.6",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "929.7",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "938.5",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "946.9",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "956.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "964.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "974",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "983.1",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "991.8",
      "cy": "692.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "675.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "684.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "693.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "701.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "710.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "719.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "728.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "738",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "746.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "756.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "765.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "774.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "783",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "792.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "800.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "810",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "819.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "827.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "838.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "847.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "856",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "864.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "873.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "882.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "891.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "900.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "909.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "919.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "928.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "937.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "945.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "954.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "963.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "972.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "981.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "990.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])])])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "199",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "209.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "220.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "230.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "241.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "251.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "262.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "272.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "282.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "293",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "303.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "314.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "324.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "335.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "346.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "356.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "999.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1008.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1017.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1026.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1035.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1044.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1053.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1062.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1071.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1081",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1090.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1098.9",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1107.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1116.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1125.2",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1134.4",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1143.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1152.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "368",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "378.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "389.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "399.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "410.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "420.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "431.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "441.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1162.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1171.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1180.3",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1188.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1198",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1206.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1215.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1225",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1233.7",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "451.7",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "462",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "472.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "483.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "493.9",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "504.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "515.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1243.6",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1252.8",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1261.5",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1270",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1279.1",
      "cy": "525.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])])])]), _vm._v(" "), _c('g', [_c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "524",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "534.4",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "545.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "555.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "566.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "576.6",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "587.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "597.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1002.6",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1011.7",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1020.4",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1028.9",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1038.1",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1046.8",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1055.9",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1065.1",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1073.8",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })]), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "607.8",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "618.1",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "629",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "639.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "650",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "660.3",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "671.2",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1083.7",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1092.9",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1101.6",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1110.1",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1119.2",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1128",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1137.1",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1146.3",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-18",
    attrs: {
      "cx": "1155",
      "cy": "681.5",
      "rx": "1.2",
      "ry": "1.2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    staticClass: "swing",
    attrs: {
      "id": "rolo_wall"
    }
  }, [_c('polygon', {
    staticClass: "cls-19",
    attrs: {
      "points": "904.3 237 902.6 262.6 927.3 263.2 927 279.4 913.4 279.4 913.6 277.5 925.3 277.2 925 265.5 882.6 265.2 882.3 271.8 878.9 272 879.3 262.7 899.2 262.1 897.2 237 904.3 237"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-20",
    attrs: {
      "points": "875.6 269 922.8 269 922.8 284.3 875.6 283.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-30",
    attrs: {
      "d": "M898.5,247.8l-1.3-.7-1.3-10.7s2.3-2.2,2.8-2.2l5,.2,1.7,2.7-1.2,9.7-1.8,1.2Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-29",
    attrs: {
      "cx": "901.5",
      "cy": "239",
      "r": "1.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-22"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.03, 0.05, 0.03, 838.43, 370.84)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-23"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.03, 0.06, 0.03, 827.08, 301.08)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "swing swing--reverse",
    attrs: {
      "id": "brush_wall"
    }
  }, [_c('polygon', {
    staticClass: "cls-24",
    attrs: {
      "points": "889.6 310.2 891.1 340.1 897.3 336.8 899.1 310.1 896.6 307.5 893 307.2 889.6 310.2"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-25",
    attrs: {
      "x": "883.9",
      "y": "335.1",
      "width": "21.1",
      "height": "6"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-26",
    attrs: {
      "x": "883.9",
      "y": "335.1",
      "width": "21.1",
      "height": "1.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-27",
    attrs: {
      "points": "903.5 366.4 885.5 366.4 884.4 362.5 884.4 341.1 904.4 341.1 904.4 362.5 903.5 366.4"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-28",
    attrs: {
      "x": "884.4",
      "y": "341.1",
      "width": "20",
      "height": "21.36"
    }
  })]), _vm._v(" "), _c('circle', {
    staticClass: "cls-29",
    attrs: {
      "cx": "894.9",
      "cy": "312.4",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-31",
    attrs: {
      "d": "M888.3,364.9a4.1,4.1,0,0,1,.2,1.3,33.4,33.4,0,0,0,.7-3.7h-1.2A9,9,0,0,0,888.3,364.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-31",
    attrs: {
      "d": "M891.8,363.1a2.8,2.8,0,0,0-.5,1.4,8.2,8.2,0,0,0,.3,1.5A2.6,2.6,0,0,0,891.8,363.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-31",
    attrs: {
      "d": "M894.5,362.5a6.7,6.7,0,0,0,.1,2,5.2,5.2,0,0,1,.2,1.1s.5-2,.5-2.5a2.8,2.8,0,0,0,0-.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-31",
    attrs: {
      "d": "M898.3,366.3s.4-1.2.4-1.5,0-.9,0-.9.5,1.5.6,1.8a5,5,0,0,1,0,.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-31",
    attrs: {
      "d": "M901.4,363.4c.1,1,.3,2,.3,2a9.2,9.2,0,0,0,.2-1.1c0-.5,0-1.8,0-1.8h-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-27",
    attrs: {
      "d": "M887.9,361.4l-.2-13s1.8,9.6,1.3,12.6"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-27",
    attrs: {
      "points": "894.4 361.5 894.5 354.3 895.3 362.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-27",
    attrs: {
      "d": "M901.8,345.1s-.1,7,0,8.9-1.1-9.9-1.1-9.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-27",
    attrs: {
      "d": "M897.5,355.9l-.9-8.5s2,5,2,8.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-27",
    attrs: {
      "d": "M892.4,343s-.9,6.4-.9,7.9,1.1,1,1.1,1"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-27",
    attrs: {
      "points": "902 361.3 901.3 356.4 900.9 362"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-32"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.05, 0.08, 0, 1038.62, 300.7)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-33"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.05, 0.12, 0, 1009.29, 372.2)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sh_spat_overlay",
      "data-name": "sh spat overlay"
    }
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-34"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.03, 0.03, 0.03, 908.97, 286.57)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "swing swing--reverse",
    attrs: {
      "id": "spatoula"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-35",
    attrs: {
      "d": "M957.4,257.9c0,2.9-.9,5.2-3.7,5.2h0c-2.9,0-3.7-2.3-3.7-5.2l-1.5-13.4a5.2,5.2,0,0,1,5.2-5.2h0a5.2,5.2,0,0,1,5.2,5.2Z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-36",
    attrs: {
      "cx": "953.5",
      "cy": "244.3",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-37",
    attrs: {
      "cx": "953.5",
      "cy": "258.7",
      "r": "1.5"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-15",
    attrs: {
      "d": "M961.7,296.4H946.6V286.2c.2-4.9,3.1-24.5,7.3-24.5h0c4.2,0,7.9,21.3,7.9,25.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-15",
    attrs: {
      "points": "961.7 296.4 946.6 296.4 950.8 261.5 956.6 261.5 961.7 296.4"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-38"
  }, [_c('g', {
    staticClass: "cls-39"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, 0, 0, 0.05, 950.16, 225.42)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sh_cloth_overlay",
      "data-name": "sh cloth overlay"
    }
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-40"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.03, 0.06, 0.03, 882.56, 381.75)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-41"
  }, [_c('g', {
    staticClass: "cls-42"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.03, 0.06, 0.03, 882.56, 381.75)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "swing",
    attrs: {
      "id": "cloth"
    }
  }, [_c('g', [_c('path', {
    staticClass: "cls-43",
    attrs: {
      "d": "M934.7,393.3,945,338.7s1.4-9.4,5-9,4.6,7.1,5.7,13,10,49,10,49-9-.7-8,2a67.6,67.6,0,0,0,4,7.7s0-1.7-1,2.7-8,8-8,8l-9.3-11-.6-.7c1.9-2.3,2.6-4.6,2.3-6.3S939,389.7,934.7,393.3Z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-44"
  }, [_c('g', {
    staticClass: "cls-45"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.02, -0.03, -0.06, 0.03, 1030.67, 383.41)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-44"
  }, [_c('g', {
    staticClass: "cls-46"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.05, 0, -0.07, 0.11, 1063.98, 308.46)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-47"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, -0.01, 0.01, 0.01, 932.88, 372.43)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('g', {
    staticClass: "cls-49"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.01, 0.02, 0.01, 929.95, 367.85)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-48"
  }, [_c('g', {
    staticClass: "cls-50"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.01, 0.02, 0.01, 933.25, 375.5)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-44"
  }, [_c('g', {
    staticClass: "cls-51"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.01, 0.02, 0.01, 929.28, 387.85)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sketch_1",
      "data-name": "sketch 1"
    }
  }, [_c('g', [_c('rect', {
    staticClass: "cls-52",
    attrs: {
      "x": "1081.8",
      "y": "237.5",
      "width": "63.4",
      "height": "42.8",
      "transform": "translate(816.8 1362.9) rotate(-88)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1114.7,267.7c0,.5,0,1.2.1,1.5A7.3,7.3,0,0,0,1114.7,267.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.7,263.8l.4-.5-.2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.9,263.5l.5-1C1112.5,263.9,1112.6,263.9,1112.9,263.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.6,279a3.1,3.1,0,0,1-.4.8l-.9.2h-.9c-.3-.1-.6-.2-.6-.5h.3a2,2,0,0,0,1.2.2h.9v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1116.4,266.7a6.3,6.3,0,0,0,.1-.8C1116.4,266.2,1116.4,266.5,1116.4,266.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1117.6,249v-.5A2.4,2.4,0,0,0,1117.6,249Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1115.9,256.9l-.4.7-.2.2h0l.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1117.3,254v.3l-.2.6-.3.8A13,13,0,0,0,1117.3,254Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121.6,246.4l.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1117.5,247.1v1.4C1117.6,247.8,1117.6,246.6,1117.5,247.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1114.6,267.4v.3C1114.7,267.4,1114.6,267.2,1114.6,267.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.7,274.3v.2C1110.7,275.2,1110.7,274.9,1110.7,274.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.6,264.3c.6-1,1.2-2,1.6-3.1-.6,1.2-1.1,2-1.3,2.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1114.1,263.9c-.2.6-.3-.5-.3-1.7s0-2.6-.2-2.4a36.5,36.5,0,0,1,0,5.2c-.4-1.9-.1-4.9-.5-5.8s0,.9.1,1.8.1,1.8.1,1.8c-.1,2.3-.5-.8-.4,1.3a22.5,22.5,0,0,1,.4,2.9l.3,3.8v1.1c0,.2.1,0,.2,0h.2l.4-.3a9.5,9.5,0,0,0,1.6-1.2l.6-.7.5-.7.7-1.3-.5,1.1.4-.7a12.8,12.8,0,0,0,.8-1.6c.3-.6.4-1.2.6-1.7l.2-.8h0v-.2a19.3,19.3,0,0,0,.9-4.2,36.1,36.1,0,0,0,.1-5.9c-.1-.3-.2-1-.3-2l-.2-2.1-.3-2.7h-.4l-.4.3-.9.6a12.7,12.7,0,0,0-1.6,1.3l-.4.4-.3.3-.5.6-.8,1.2a15.1,15.1,0,0,0-1.6,3.7,14.5,14.5,0,0,1,2.7-5v.5l-1,1.5-.2.2c-.1,0-.2,0-.9,1.8a19.2,19.2,0,0,0,1.8-2.9l.7-1.1.9-1.1a10.3,10.3,0,0,1,2.1-1.7,13.4,13.4,0,0,0-3.2,3.2,11.3,11.3,0,0,1,1.6-1.7l.9-.7.5-.3h.4c.5,3.8.7,7.4.9,10.1s-.3.8-.3-.4a13.9,13.9,0,0,1,0,2.2,6.9,6.9,0,0,1-.2,1.2,24.4,24.4,0,0,0-.5,2.9c-.1-.6.3-2.7.4-5a37.6,37.6,0,0,0-.3-6.7c0-.3,0-.7,0-1v-.9c0-.5-.1-1.1-.1-1.7s0-.1,0-.1h-.1l-.3.2-.5.4-.9.9a12.6,12.6,0,0,0-1.8,2.7,25.3,25.3,0,0,0-2.2,6.1c-.2.1-.1-.9,0-1.6s.1-1.2-.3-.1a20,20,0,0,0-1.1,5.3c-.1,1.1,0,1.9-.1,3.5a6.9,6.9,0,0,1-.5,2.5c-.1.4-.3,1.1-.3,4.3v-1.9c0-1-.1-1.9-.1-1.9-.6,3.7.1,3.6.1,6.4a25.3,25.3,0,0,0,.1-4.2c.2-.3.2,2.1.3,3.3v-.8c.1.7.3,1.1.4,1.9s.1.9.2,1.5l.2,2c-.1-.4-.2-.5-.2-.3s0,.3,0,.5,0,.1,0,.2h.2l.4.2h1.4c.1,0,.1-.1.1-.2v-.2l.6-1.3-.2.5-.2.5a27.6,27.6,0,0,0,1.8-7.7v.2a22.9,22.9,0,0,0-.1-2.8c0-.9-.1-1.9-.1-3.5.2.3.5,4.2.5.6a24.9,24.9,0,0,1-.4,7.7l.4-2a6.6,6.6,0,0,1,.2-1.1c.1-.3.2.3-.1,2.3.5-1.1.3-3.8.4-5.9-.1.4-.2-.3-.3-.1s.2-2-.1-4a13.4,13.4,0,0,0-.9-3.9s.3.9.4,1.9.2,1,.2,1.3v.6c-.1.2-.3-1-.6-1.9s-.5-1.7-.4-1a16,16,0,0,0-1.5-5.9l-.4-.9-.4-.8-.2-.4h-.4l-.7.2a12.8,12.8,0,0,0-2.1,1.2l.6-.3.6-.3a12,12,0,0,0-3.8,4.1,31,31,0,0,0-2.3,5,80,80,0,0,0-3,10.9c.2-1.4.3-2.1.4-3.1a21.4,21.4,0,0,1,1.3-4.6c-1.2,3.6-1.4,4.1-1.5,4s-.1-.9-.5.2c-.9,2.9-.9,3.6-.8,3.9s.3.1.2,1l.4-2,.5-2c-.4,2.9-1.5,7.3-2,12l-.4-.2a16.3,16.3,0,0,0,3.4-4.4,33.9,33.9,0,0,0,2.3-5.1c.4-.5-.6,1.6-1,2.6,1.8-3.2,1.3-3.3,2-5.4s2.6-7.9,2.3-5.6c1.1-4-.3.4.1-1.8l.3-.7v-.7l.2-1.5.2-2.2a41.2,41.2,0,0,0,.7-5.1h.5a15.1,15.1,0,0,1-2.3,3.8c-4.3,7.3-.9,2.9-3.9,8.3-1.8,2.9.1-.7.1-1.1l-.4.7-.9,1.6-.8,1.7-.2.6v.2a14.8,14.8,0,0,1,1.4-3.6c.6-1.2,1-2.1.8-2-1,2.1-1.6,3.5-2.3,5.1l-.5,1.3-.4,1.5a9.1,9.1,0,0,0-.1,3.7v0c0,.1,0,.2.1.2h.3l1.1-.3a13.3,13.3,0,0,0,2.8-1.5,28.2,28.2,0,0,0,4.9-4.3,23,23,0,0,1-5.9,5.3,24.4,24.4,0,0,0,6.8-5.8,37.7,37.7,0,0,0,4.9-7c1.4-1.8,3.8-6.1,2.4-3.1,2-3.5,2.1-4.5,2.2-5.1a10.4,10.4,0,0,1,.3-1.3,27.3,27.3,0,0,0,.8-3.2l.3.3a8.4,8.4,0,0,0,.2-1.1h.3a130.1,130.1,0,0,0-11.2,18l.2.6-1.2,2.3-.8-.4,1.7-2.1-1.5,2.3.3.2.3-.9-.4.8h0a18.4,18.4,0,0,0,1.5-2.4,36.7,36.7,0,0,1,1.7-3.3c-.1,0-1.8,2.6-2,2.5s-1.2,1.8-1.8,2.8l1.1.6a59.7,59.7,0,0,1,5.6-10.7c2.2-3.4,4.6-6.6,6.9-10l-1.4-.4a14.3,14.3,0,0,1-1,4.4,39,39,0,0,1-1.9,4.3,66.3,66.3,0,0,1-5,8.1c.4-.4.8-1,.7-.6s-3,3.8-2.9,3.3l.3-.4a27.4,27.4,0,0,1-7.6,6.5,6.1,6.1,0,0,1-1.6.9h-.6c-.2,0-.4.1-.4-.1a4,4,0,0,1,0-.5v-.6c0-.4-.1-.5-.2-.1a8.3,8.3,0,0,1,.3-1.2,5.6,5.6,0,0,1,.3-.8l.2-.4c.1-.9-.3-.5.2-2.1a7.4,7.4,0,0,1,1.1-1.9c.1,0-.1.4-.5,1.5a65.6,65.6,0,0,1,4-7,40.2,40.2,0,0,0,4.1-7.7l-1.9-.3a43.9,43.9,0,0,1-1.2,8.8,81.7,81.7,0,0,1-2.4,8.4l.4-1.4.3-1.4c-.4,1.2-1.1,3.5-1.7,5.2s-1.1,2.7-.9,1.6a31.4,31.4,0,0,1-2.1,4.3,16.6,16.6,0,0,1-2.9,3.7l1.9,1c.2-2.7.5-4.8.3-5s1.2-4.9,2.2-8.4a50.8,50.8,0,0,1,4.1-10.8c-.5.4.1-.9,1.3-2.5a11.8,11.8,0,0,1,2-2l.5-.4.5-.3.6-.3c.1.1,0,.2-.3.3l-.6.4-.8.7a8.2,8.2,0,0,0-2,2.7,11.4,11.4,0,0,1,1.7-2.3l1.2-.9.3-.2h.7v.2l.2.3v.3l.2.4.3.8a27.6,27.6,0,0,1,.9,3.4c.9,4.6.8,8.7,1.2,10.4s-.1.9-.1.6a31.2,31.2,0,0,1-.8,4.8c0,.9.7-2.2.1,1.2-.3,1.3-.5,1.6-.6,1.6s-.2,0-.4.4a3.1,3.1,0,0,1-.2.7.6.6,0,0,1-.8,0v-.7h0v-.3c-.1-.8-.2-1.5-.2-2.2-.2-2.9-.3-5.3-.4-5.7s.5-3.2.5-1.5a35.6,35.6,0,0,1,1-8.2c.3-1,.5-2,1-3.2a20.6,20.6,0,0,1,2.1-4.4,6.4,6.4,0,0,0-1,2.1c-.2.5-.4,1.1-1.2,3.1.5-.9,1-2.3,1.9-3.9a13.4,13.4,0,0,1,1.6-2.3l.3-.4.2-.2h.2v1.5c0,.4.1.8.1,1.1a36.9,36.9,0,0,1,.1,4.4v1.4c.1.7.1,1.4.1,1.4a9.7,9.7,0,0,1-.6,3.3c-.1.2-.1-.5,0-1.9a23.2,23.2,0,0,1-1.1,4.4,11.8,11.8,0,0,1-.8,1.7,4.9,4.9,0,0,1-.4.8l-.2.3h-.1l-.3.3h-.2c-.1.1-.1,0-.1-.1v-1.9c0-.3.1-.1.2.8s-.2-2-.3-3.9-.1-3.9-.1-3.9-.1-3.6-.4-3S1114.1,259.7,1114.1,263.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1114,257.1v.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.2,277.1c0-.8,0-1.4,0-2A15.5,15.5,0,0,0,1110.2,277.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.6,254.3a5.5,5.5,0,0,0-1.9,2.5,7.7,7.7,0,0,0-.8,4.8,5.8,5.8,0,0,1-.2-1.7,2.3,2.3,0,0,0,0-.7c-.1-.2-.2.1-.4.3a6.1,6.1,0,0,0,.6,2.7,4.2,4.2,0,0,0,1.5,1.8,4.5,4.5,0,0,0,3.1.6,8.1,8.1,0,0,0,4.2-2.1c.1,0-.5.7-1.3,1.3s-1.9,1-2.1,1.2a9.7,9.7,0,0,0,5.6-4.8,5.7,5.7,0,0,0,.6-3.1,3.4,3.4,0,0,0-.1-.7l-.2-.5-.2-.4h-.3a7,7,0,0,0-1.5-.3h-1.4l-1.4.2-.7.2a2.3,2.3,0,0,0-.2.7,9.5,9.5,0,0,0,.2,5.1,10.4,10.4,0,0,0,2.8-2.6,11.3,11.3,0,0,0,.9-1.4l.6-1.4-.6,1.4-.4.8c-.2.4-.2.5-.2.6s.1.1-.1.4l-.4.7a5.6,5.6,0,0,1-1.1,1.2l.9-.8.9-1.1.4-.6.2-.5.5-1a19.9,19.9,0,0,0,1.1-4.9,33.2,33.2,0,0,0,.1-5.4c0-.9-.1-1.9-.2-2.7a20.8,20.8,0,0,0-.4-2.1s0-.1,0-.1h-.1l-.2.3-.4.5-.6.9a10.2,10.2,0,0,0-.8,1.6l-.5.3-.3.2c-.1,0-.2-.1-.1-.7l-.6,1.3-.4,1.1-.5,1.5a4.5,4.5,0,0,0-.2,1.3c0,.6-.1,1.1-.7,5.1l.3-1.8.3-1.8a13.6,13.6,0,0,0-.2,3.6c.1.7.2,1,.3,1.6a38.6,38.6,0,0,1,.5-4.6,32.3,32.3,0,0,1,1.1-4.4,2.4,2.4,0,0,1-.1,1l-.2.9-.2,1.1a32.8,32.8,0,0,0-.6,4.3c0,1.4.2.2.4-1.3l.4-2c.1-.5.3-.8.3-.5a11.8,11.8,0,0,1,.2-1.3c.1-.5.3-1.1.5-1.8l.7-1.9.2-.4v-.2h0v-.2h.1l.2-.2.2.2h0c0,.2,0,.6,0,.8s0,1.2,0,1.9-.1.4-.1.3a16,16,0,0,1-.4,5l.2-.9.2-.9a15.3,15.3,0,0,1-.5,3,14.6,14.6,0,0,1-.5,1.6l-.6,1.3-.5.8-.3.5c0,.2.3,0,1.2-1.1a9.7,9.7,0,0,1-2.7,2.6,10.6,10.6,0,0,1-.3-1.5,8.7,8.7,0,0,1,0-1.5,6.9,6.9,0,0,1,.2-1.4l.2-.7.7-.2-.3.2h-.1s-.1,0-.1.2v1a3.6,3.6,0,0,0,.6,1.5l.7-.7a1.4,1.4,0,0,0,0-.3l-.5.4a2.1,2.1,0,0,1-.2-1.2c.3-.3.7-.5,0-.5l.6-.3.9-.2a6.3,6.3,0,0,1,2.1.1h.3v.3a3.3,3.3,0,0,1,.1.6,4.3,4.3,0,0,1,0,1.3,5.9,5.9,0,0,1-1.1,2.6,8.8,8.8,0,0,1-4.9,3.2,4.7,4.7,0,0,1-2.8-.1,3.5,3.5,0,0,1-1.9-1.7c0-.3.4.5,1.2,1.1a3.1,3.1,0,0,0,1.4.5h1.4c1.9-.3,3-1.3,3.3-1.2a7.4,7.4,0,0,0,1.7-1.7,3.3,3.3,0,0,0,.5-.9c.1-.4-.1-.2-.2-.2s-.3.1-.1-.3a8.2,8.2,0,0,0,.4-1.1,4.7,4.7,0,0,0,.1-.9v-.3h0v-.2h-.2c-.2,0-.2-.1-.1-.1h.6l.2.4a.7.7,0,0,0,0-.3c0-.1,0-.3-.1-.3h-2.1l-.8.2-.2.2c0,.1,0,.2,0,.2h.1v-.2h2.4s0,0,0,.2a3.5,3.5,0,0,1-.1,1.1,5.4,5.4,0,0,1-1,2,6.9,6.9,0,0,1-5.2,2.8,2.7,2.7,0,0,1-2.4-3.4,10.8,10.8,0,0,1,2.4-4.7,20.7,20.7,0,0,1,3.4-3.4,15.7,15.7,0,0,1,5.9-3l1.6-.2h1.5l.4.2h.3s0,.1,0,.1v.2l-.3.6a26.2,26.2,0,0,1-2.8,4.5,21.5,21.5,0,0,1-8.3,6.4,16.7,16.7,0,0,1-5.1,1.3h-3.5c-.2,0-.2-.1-.2-.2h0v-.9a9.4,9.4,0,0,1,.1-1.2,12.7,12.7,0,0,1,.6-2.5,22.7,22.7,0,0,1,2.3-4.8,24.8,24.8,0,0,1,3.3-4.2,10.3,10.3,0,0,1,4.1-2.8h1.5l.3.4c.1.1-.1.1-.1.2l-.2.2-.8.6-1.1.7-1.1.5-1.1.3a3.6,3.6,0,0,1-2.1-.3,4.1,4.1,0,0,1-1.6-1.5,5.8,5.8,0,0,1-.6-4.5,3,3,0,0,1,3.2-2.2,9.9,9.9,0,0,1,4.7,1.7l.3-2h-.1a15.6,15.6,0,0,1-5.5.3,12.4,12.4,0,0,1-3.8-1.1l-.4,1.6a49.1,49.1,0,0,1,6.1-.3c-1.8-.8-7.6-.3-5.7-.7h-.5a16.5,16.5,0,0,0,8.6,1.1c.3.1-.8.3-1.9.3h-.4a7.1,7.1,0,0,1-2.9,0,14.7,14.7,0,0,0,6.6.1l1.1-.2-1-.5a14.8,14.8,0,0,0-3.6-1.5,6.3,6.3,0,0,0-3.8,0,3.9,3.9,0,0,0-2.3,2.4,4.9,4.9,0,0,0-.2,2.5c0,1.1.1,1.5,0,1.4a1.3,1.3,0,0,1-.2-.5,5.1,5.1,0,0,1-.1-1,5.8,5.8,0,0,1,.6-2.9,4.7,4.7,0,0,1,1.9-2,4.5,4.5,0,0,0-2.3,2.3,6.5,6.5,0,0,0-.5,3,7.2,7.2,0,0,0,2.5,5.2,5.3,5.3,0,0,0,2.7,1.1,6.7,6.7,0,0,0,2.8-.4l1.2-.6,1.1-.7,1.1-.8,1.3-1.2.3-.3c.1,0,0-.1,0-.2V246l-.5-.7a3.6,3.6,0,0,0-4.3-1.4,11.8,11.8,0,0,0-4.5,3,27,27,0,0,0-6.1,9.6c.4.4-.4,1.7-.2,4v.7c0,.3,0,.7,0,.7s.1,0,.3.1.1,0,.1-.3,0-.7.1-1.4a6.5,6.5,0,0,0,.2,3c0,.3.3.2.5.3h1.8l2.1-.2,1.8-.4a23.6,23.6,0,0,0,6.4-3.3l-.2.4a20.7,20.7,0,0,0,4.3-3.6,21.4,21.4,0,0,0,3.1-4.1l1.1-1.7.2-.2a15.8,15.8,0,0,1-1.2,2.3c-1.3,2.2-3.5,4.5-2.5,3.9l.2-.3.5-.6.5-.6.2-.3a15.5,15.5,0,0,1-3.3,4.5,30.7,30.7,0,0,0,6.2-7.7l.5-1,.5-1.1.3-.7v-.2h0l-.3-.3a5.4,5.4,0,0,0-1.2-.9,6.8,6.8,0,0,0-5.8,0,6.1,6.1,0,0,1,1.8-.7,6.5,6.5,0,0,1,3.5.1l1,.5,1,.8.4.4-.2.6-.4,1.1c-.4,1-.9,1.8-1.1,2.3a23.9,23.9,0,0,0,1.2-2.3l.4-.9.2-.5c0-.1.1-.2.1-.2l-.2-.2a8.3,8.3,0,0,0-1.5-1.2,6,6,0,0,0-2.4-.7h-1.1l-.3.2-.3.2-2.1.5c-.2,0,0-.1.2-.2s1.6-.7.7-.6a13.9,13.9,0,0,0-3.5,1.5l-1.7,1.2c-.7.6-.7.8-.7,1s.1.3-.3.8S1112.2,252.3,1110.6,254.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.6,254.1a21.9,21.9,0,0,1,1.9-3.4A15.7,15.7,0,0,0,1113.6,254.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119.4,263.7a2.7,2.7,0,0,1,0,.5C1119.4,263.8,1119.4,263.6,1119.4,263.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119.2,266.3c-.2.3-.1,0,0-.4a14.1,14.1,0,0,0,.3-1.6C1119.2,265.8,1117.5,269.8,1119.2,266.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1124,269.9l.7.8,1,.9.9.6-.6-.5-.6-.5-.6-.7a9.3,9.3,0,0,1-1-1.4l-.4-.7A15.6,15.6,0,0,0,1124,269.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121.9,260.4s0-.3,0-.7v-1.6l.2-2.3-.3-3.1a27.3,27.3,0,0,0,0,3.8C1121.9,257.2,1121.9,257.9,1121.9,260.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1123.7,250.6l-.4-1C1123.6,250.5,1123.7,250.7,1123.7,250.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1123.9,250.7l.8,1.6c-.4-1.2-.8-2.3-1.2-3.5l-1.5.3c.1.8.1,1.5.1,2.3v-2.2h0l1.1-.2c0,.2.3,1.4.3,1.6l.4,1.1.4,1.1C1124.4,252.2,1124,251.1,1123.9,250.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1125.3,255.7c0-.1,0-.3,0-.4S1125.2,255.4,1125.3,255.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1126.3,267.2c.1-1.2.4,1.2.5,1.6a20.7,20.7,0,0,0-.4-4.6c-.2-1.1-.4-2.2-.7-4.2.6,3,.6,2.5.4.9s-.7-4.2-.8-5.2c-.1,1.2.3,3.5.8,8.1l.3.5A12.6,12.6,0,0,1,1126.3,267.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1122.4,263l.3,1.8.3,1.8c-.1.3.1,1.9.2,3.4s.3,2.9.1,2.8a36.3,36.3,0,0,0,1,4h0v.8l.6-.7a6.5,6.5,0,0,0,1.8-4.4,9.1,9.1,0,0,1-1.8,4.4l-.4.5V277c-.5-3.5-.6-3.3-1.1-9.1a13.2,13.2,0,0,1,.2,2l-.2-2.5c-.1-1.2-.1-2.5-.1-2.5S1122.5,258.2,1122.4,263Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1122.5,255.7c0,4,.4,6.1.5,4.2l-.2-4.2v-4.2C1122.8,253.9,1122.8,257,1122.5,255.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1122.7,249.9v-.2h.4a17.8,17.8,0,0,0-2,6.3,15.8,15.8,0,0,1,1-3.3,30.1,30.1,0,0,0,1-3h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1109.8,270.8v.7h.4a8.7,8.7,0,0,0,4.9-1.9l.9-.8c.6-.4.1.4-1.1,1.3a8.6,8.6,0,0,1-2.1,1.2l-1.3.4-1.2.3,1.4-.2,1.1-.3,1.4-.7a7.1,7.1,0,0,0,1.5-1.2,13.1,13.1,0,0,0,2.3-3.6,26.1,26.1,0,0,0,2.2-6.7c-1.2,4.9-2.6,7.3-4.2,8.9a10.8,10.8,0,0,1-2.7,2.1l-.9.4-.9.3-1.1.3h-.6s0,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119.8,262v-.9s-.2.9-.5,1.8-.6,1.8-.6,1.8l.6-1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1116.4,253.8a40.3,40.3,0,0,0,3.2-7l-1-.4-1.2,3-1.3,3.2c.2-.5,0-.2.4-1.2l-1.6,4.2-.2.2c.4-.1-1.2,4.3-2,6.1a10.1,10.1,0,0,0,1.4-3.1,11.4,11.4,0,0,1,1.1-2.8c-.2,1-.3,1.7-.6,2.6a32.1,32.1,0,0,0,1.3-4.6c1.1-2.8.9-1.9,1.1-2.1s.6-2,.8-2.8a27.9,27.9,0,0,1,1-2.7l.6.3-1.1,2.6c-1.6,2.9.5-1.9-1.8,3.2,1.6-2.3-2.5,5.1-3,7.2l-1.2,2.6-.8,1.9c-.5,1-.7,1.4-.6,1s.1.9-.1,2.2l-.2,1V271h0v-.5l.3-2,.5-2.4.3-1.1,1.2-2.1a67.8,67.8,0,0,1,4.1-9.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1114.6,258.5l-.5,1.5A11.8,11.8,0,0,0,1114.6,258.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.3,266.3s.4-1.7.4-1.7l-.5,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.4,261.9c.4-.9.4-1.2,0-.4l-.5,1.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1111.1 265.5 1109.6 267.3 1109.5 267.6 1109.1 267.3 1109.4 266.2 1108.9 267.3 1109.6 267.7 1111.1 265.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1108.9,259.6c.7-3,.4-2.8.2-3.3C1108.3,261,1109.4,256.5,1108.9,259.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.4,252.3l-.4-.8-.2-.4c-.1-.1-.1-.3-.3-.2l-.8.2-.8.3-.7.3-.6.4-.5.4-.5.4a18.4,18.4,0,0,0-3,4.1,20,20,0,0,1,3.3-4.1l1.1-.9,1.3-.6.8-.2h.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1115.5,278.3v-1.2c0-.2,0,0-.4.9a28,28,0,0,0,.4-3.5c-.3,1.2-.5,2.1-.6,2.7v.7a4.5,4.5,0,0,0-.1.5C1114.9,278.9,1115.3,278.4,1115.5,278.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1111.7,254.3s-.4,1.2-.7,2.4-.5,2.4-.5,2.4l.3-1.2.4-1.2c-.2,1.3-.3,2.2-.5,4,.3-1.8.7-3.5.9-4.7S1112,254,1111.7,254.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.1,264.9c0-.5.1-1.1.2-1.8A4.3,4.3,0,0,0,1110.1,264.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.6,261.3v-.6c-.1.9-.2,1.7-.3,2.5A10.1,10.1,0,0,0,1110.6,261.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.6,251l.9-1.3,1.3-1.5a14.1,14.1,0,0,1,2-1.5l2.1-1.3.5,4.3c-.1-1.5-.3-3-.5-4.4l-1.1.6c-.6.6-1.8,1.2-3.3,2.5l-.5.5-.3.3-.5.7A4.7,4.7,0,0,0,1113.6,251Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112,260.1l.3-.9a60.5,60.5,0,0,1,.7-8.4,23.2,23.2,0,0,1,1-3.7l.7-1.5.4-.6.5-.7c-.5.7-.5.7-.4.4l.6-1.4c.2-.5.4-.7.1-.4l-.7,1.2-.3.5-.2.4-.4,1a41.6,41.6,0,0,0-1.6,6.6A64.9,64.9,0,0,0,1112,260.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1118.4,240.6c-.4.5-.3.5-.1.3l.4-.4.2-.2h.1c.1,1.2.3,2.2.4,2.9s.2,1,.2.3a6.1,6.1,0,0,1-.3-1.8c0-.6,0-1.4-.1-2.3s-.2.2-.4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.9,259.5a14.4,14.4,0,0,0,.6,2.4c.5-.4.6-.5,0-.1l-.2-.7-.2-.9v-1.5c0-.2,0-.4,0-.6a11.4,11.4,0,0,1,0-1.6v-1.2c-.1-.3.3-.3.5-.4l1.1-.4-1.1.3h-.6a2,2,0,0,0-.2.5,7.5,7.5,0,0,0-.4,2.1,13.2,13.2,0,0,0,0,1.7l.3,1.1c.1.6.3.9.4.7S1112.9,260.4,1112.9,259.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.7,254a5.7,5.7,0,0,0-1.6,1.5,8.5,8.5,0,0,0-1.2,2A12.4,12.4,0,0,1,1112.7,254Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1111.7,251.9l-.5.4-.5.5-.4.7-.3.7.2-.4.6-.8.6-.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119.9,258.9l-.4.4-.9.9-.9.8-.5.3.7-.5,1.5-1.1a24.3,24.3,0,0,0,1.9-1.9l-.7.6-.5.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1115.4,262l-.7.3-.7.3-.8.3-1.5.6-.7.2.8-.2h.8A11.3,11.3,0,0,0,1115.4,262Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.1,262.2l.2,1,.2.8s0,.1.1.2h.5c-.6.1-.5-.5-.7-.8a7.2,7.2,0,0,1-.2-.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.3,240.8c-.2,0-.2.1,0,.1l1,.4,1.2.8.9.8-.7-1-1.1-.8Z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.6,284.8c0-.2,0-.1-.1,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.5,284.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127,284.7c.1-.1.2,0,.3-.2S1127.1,284.4,1127,284.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1127.2 284.8 1127.2 284.7 1127.2 284.9 1127.2 284.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1127.3 284.9 1127.3 284.8 1127.2 285 1127.3 284.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1126.7,284.6h.1c.1.1,0,.2,0,.3s0-.3.2-.3-.3,0-.3-.2S1126.8,284.5,1126.7,284.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1120.9,285h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119,286h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121.4,284.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.4,283.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1116.5,286.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1122,284.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119.8,286.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1125.1,284.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1124.6,284.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1124.2,284.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1125.1,284.3c0-.1,0-.4-.1-.1h0C1124.9,284.6,1125,284.4,1125.1,284.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1120.9,284.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121.1,284.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1122.6,285h0S1122.6,285,1122.6,285Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121,284.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1122.2,284.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1103.6,283.3h.1c.2-.1-.2-.1,0-.2h-.2v.2C1103.6,283.4,1103.5,283.3,1103.6,283.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1109.7,283.6h-.1c0,.1.3.3.3.4h.1A.5.5,0,0,1,1109.7,283.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1109.9,283.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1104.8,284.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1117.1,283.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.7,283.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1108.8,286.7c0-.2,0,0-.1-.1h.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1103.5 283.2 1103.5 283.2 1103.5 283.2 1103.5 283.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1106.5,287.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.3,283.7h.1C1110.4,283.7,1110.2,283.6,1110.3,283.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110,286.2h.1c.1-.4.6-.3.5-.8s-.1-.5.4-.3h-.1l.8-.3h.6l3.8,1.2c.2-.1.1-.3.3-.4s.2,0,.1.2-.1.2-.1.2.4.2.6.1v-.2h.2c0,.1,0,.3,0,.3s.3.2.6.1.5-.6.7-.9h.1c-.2,0,0,.2-.2.2h.5a.2.2,0,0,1,0-.2l.3.2h-.1c.1.1.1-.1.2-.1s.3.1.3.3.2-.2.3-.3,0-.2-.1-.3h-.2c.3,0-.1.1,0,.3s.1-.4-.1-.3.3-.1.5-.4,0-.2-.1-.2.1.1.2.2.2.1.2-.2.1.2.2.2-.5,0-.3.5-.1.3-.3.3.4.1.5-.1v-.3c.1-.1,0-.2.1-.3s.1.2.2.1h-.1c.1-.1.1-.3.2-.4h-.4c-.1-.2.1-.1.1-.1h.1c.2,0,.1.3.3.3s.1-.2.2-.1h0s.1-.1,0-.2,0,0,0-.1,0-.3.1,0h0v.2h.1v.2c.1,0,.1-.2.1-.4s.2.1.3,0h.2c0,.2.2-.1.2,0h0c0,.1,0,.4.1.2h.4c.1,0,0,.1,0,.1s.3,0,.5.3,0-.2,0-.3l.3-.2c0,.2.3.5.1.7s0-.2.1-.2h0a.4.4,0,0,1-.1-.3.1.1,0,0,1,.2-.1v.2c.2,0,.2-.3.4-.5s0,.3,0,.5h.1v.2c.1,0,.2-.2.3-.1s.2.2,0,.4.1-.2.1,0,0-.1-.1-.1.2-.1.3-.2-.1.1,0,.2.1-.2.2,0,.1,0,.2,0a.3.3,0,0,1-.1-.3h.1c.1-.2.1.2.3.1l-.2.2.3-.2v.2c0-.1.1,0,.1-.2s-.1.2-.1.3.1-.3.3,0v.2h.1c0-.3.3-.2.2-.6h-.1c.1-.1.2-.3.3-.2s0,.2-.1.3.1-.4.2-.3-.1-.2,0-.3-.2-.1-.2.1h0v.2c-.1,0-.1-.1-.1-.2s0,.3-.2.3h0c-.1.1-.2.1-.2.3s-.2.1-.3,0,.3,0,.4-.2,0-.2.1-.3l-.2.2c0-.1-.1-.3-.1-.1h0c-.1.1-.1.3-.2.2a.4.4,0,0,1,0-.1c-.1-.1-.1.1-.1.1s.1-.2,0-.2-.1-.1-.2-.1-.4.3-.2.6l-.2.2c0-.1.2-.4.2-.6h.1c0-.3-.3.2-.4-.2l-.2-.2v.3a.5.5,0,0,1,0-.3h0c0-.2,0-.1-.1,0h-.2a.8.8,0,0,0,0,.3c-.1-.2-.3-.1-.4-.4v-.2c-.1-.1-.2,0-.2.2h0c0-.1,0-.2,0-.2h0c-.1.2-.2.1-.3.1h.1c-.1.1-.2.3-.2.1s0-.3.2-.3-.1.2-.2,0h0c.1-.2.2,0,.2-.1h-.1c.1-.1.3.1.5-.1l-.2-.2c-.4.1-.8-.4-1.2-.1h-.1c0-.2-.2-.2-.3-.4a.3.3,0,0,1,.1.3c0,.2-.1.2-.2.1s.1-.1,0-.2a.1.1,0,0,1-.1.2c-.1-.1-.2-.1-.2-.2h.1s-.1-.1,0-.2h-.2c-.1-.1.1-.2,0-.2s-.4.4-.6.5V283c-.2,0-.3.4-.4.5h.1c-.7.2-.8.3-1.2.3v.3h-.1c-.3,0-.5.2-.8.3s-.1-.2-.1-.3-.2.3-.5.3.1-.3,0-.3,0,.2-.1.2h0c0-.1-.1,0-.2-.1s-.4.1-.6.4.1-.3.1-.4.1,0,.1-.1-.2.1-.2-.1h-.3c.1-.1.1.1,0,.1s-.3-.1-.2-.3l-1.4-.5c-.1.1,0,.1,0,.1s-.1-.1-.2,0h.1c-.1-.1-.4.1-.6.2s-.1-.2.1-.2.1-.7-.1-.6v.6h-.1c0-.1-.1-.3-.1-.3s.1-.1.2-.1-.2-.2,0-.4,0,.1-.1.2h0c-.1,0-.2.2-.3.1l-.2.2c0-.2-.1-.1-.2-.1h.1l-.2-.2c.1-.2.1.1.1-.1h-.1c0,.1-.1.2-.1.3s-.2.3-.5.3.2-.2.2-.4-.5.5-.6.4-.2.1-.4.1-.1-.2-.2-.3v-.2c-.1.1-.2,0-.2-.1s-.4.2-.5.4h.1l-.4.3c-.2.1,0,.2-.1.5a.9.9,0,0,1-.3-.4h.2c.1-.2.3-.6.6-.6s-.2.1-.4,0h0a.6.6,0,0,0,.2-.4c-.2.1,0,.4-.3.3s-.4-.1-.5,0,.1.5-.1.5v-.2c-.2.1,0,.3-.2.5s.1.2.2.1a.3.3,0,0,1-.2.3h.1c.2.1.1-.2.3-.1v-.2a.3.3,0,0,1,.3.3h.1c.2.3-.2,0-.1.2h.1c.1.2,0,.3-.1.3h-.4v-.2c-.1-.1-.1.2-.2.2h-.1l-.2.2h.1a.1.1,0,0,1,.2.1c-.1.2-.3,0-.4-.1s.1-.1.1-.2-.1.1-.4.1.1-.1,0-.3,0,.2-.2.2,0-.2-.1-.3h-.1c.1-.1-.2-.2-.2-.4s.1.2-.1.2.3.2.3.3h-.1c-.1-.1-.1-.3-.2-.3h0l.2.2c-.1,0,.1.3.1.4h-.2c0,.3-.1.3-.2.6s-.1-.2-.2-.3,0-.3-.1-.4a.6.6,0,0,0,.1.3c-.1,0,0,.2-.2.1s-.1-.2-.1-.3.1.3-.1.3h0c-.1,0-.1.1-.1.2s-.2.1-.3-.2.1.1.1.3-.2.1-.2.1h.1v-.2c-.2-.1,0,.5-.2.4s0-.2,0-.3-.2,0,0,.2h-.2a.7.7,0,0,0-.1.3l-.3-.2c-.2.2-.4-.1-.6.1h0c-.2,0,.1.3-.1.3s-.1-.2-.1-.3-.3.2-.5-.1h-.2c0-.1-.1-.1-.2-.1h-.3a.3.3,0,0,0-.4-.1c0-.3-.1,0-.2-.3h.1l-.3-.3c-.3,0-.6.2-.9,0s.2,0,.4-.2-.2.1-.3-.1v-.2c0-.1-.5.2-.5.2s0,.1.1.1-.4-.1-.6,0,.2.1.1.3-.4.2-.5.3.2-.3.2-.5-.1-.3,0-.4-.4.1-.6.2h0c-.3,0-.5.4-.7.3h.1s-.1.1-.2.2-.2-.2-.2-.3-.4.3-.4.7-.1-.2-.1-.3.2,0,.2-.1h-.2c0,.2-.2.4-.2.7s-.2-.1-.3-.3.4.5,0,.6,0-.3-.2-.3h0c-.4-.4,0,.4-.1.4s0-.2-.2-.3,0,.5-.2.6h0l-.4.4h0c-.2.2,0,.2-.2.2h.1a.3.3,0,0,0,.2-.3c.1.2.4.1.5.3h.9c.1-.3.3,0,.4-.3s0-.1.2-.2.1.2.1.3V285c.1.1.3.3.3.1s0,.1,0,.2,0-.1.1,0a.1.1,0,0,1,0,.1h.3c0-.3.1-.1.2-.2s.1.1.1.2v-.2c.1-.2.1.2.2.1h0c.1-.1.2.2.2.3s.6.1.8.4l.3.5.2.2.4.2c.1-.1,0-.2.1-.3h.2c-.1-.1-.1,0,0-.1h-.3c.1,0,.2-.2.3-.1h.1c.1.1.1,0,.1.1l.3.2c.2-.2.3.1.4.1s-.2,0-.3.2v0h.2s0,.1,0,.1h.1c-.1.2.1.1.1.2s.5-.2.9,0,.1-.3.2-.3a.1.1,0,0,1,.1.2h.1c.2.3.3,0,.6.1h0l.3-.2v.2c.2.1,0-.4.2-.3l-.2-.4c.1.2.3.1.2,0s.1,0,.1,0h.1c.1,0,.1.2.1.3s.2-.1.3-.1h.1a.3.3,0,0,1,.3-.2v.3c.1.1,0-.1,0-.1s.2,0,.3.1S1110,286.7,1110,286.2Zm12.6-1.4h0C1122.7,284.8,1122.7,284.8,1122.6,284.8Zm-1-.4c.1-.1.1,0,.1.1h-.2a.8.8,0,0,1,0,.2s-.1-.1-.1-.2S1121.7,284.6,1121.7,284.4Zm2.7-.3h0Zm-.7,0a.2.2,0,0,0,0-.1C1123.7,284.1,1123.7,284.2,1123.7,284.2Zm-1.2-.8c0-.1-.1-.1-.2-.1Zm-8.4-.1c.1,0,.2-.1.1-.2s-.1-.1-.1,0h0Zm-3.9,1.1-.2-.2h-.1C1110.2,284.4,1110.1,284.5,1110.2,284.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1111,282.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110,284.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1126.5,285.4h0c.1-.1.1-.3.2-.4s-.2.1-.4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1126.4,284.3v-.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1125,283.8h.1C1125.1,283.8,1125,283.7,1125,283.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1125.3,285.5h.1c-.1-.1-.1-.1-.2,0S1125.3,285.5,1125.3,285.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1124.7,283.7c-.1.2-.1-.1-.1.1S1124.7,283.9,1124.7,283.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1124.4,285.5c0,.2.1.1.2.1S1124.5,285.4,1124.4,285.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1124,284.1c0-.1.1-.1.1-.1h.1c0-.1-.1-.2-.1-.4S1124,284,1124,284.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1124.2,285.5c.1.1.1.2.2.2s0-.2-.1-.2h.1C1124.3,285.2,1124.3,285.6,1124.2,285.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1123.8,283.6h0c.1-.1.2,0,.3-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1123.9,285.1v.2c.1.1,0-.1.1-.1h.1C1123.9,285.3,1124.1,285.1,1123.9,285.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1123.5,285.3h-.2v.3C1123.6,285.6,1123.5,285.5,1123.5,285.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1123.4,285.1h0l-.3.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121.6,283c0,.1.1.2.1.1S1121.5,282.9,1121.6,283Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121.7,284.8h-.2C1121.6,284.9,1121.7,284.9,1121.7,284.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1121.5,284.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119,286.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1119.1,286.3a.2.2,0,0,0,.2-.2l-.3.3S1119.1,286.4,1119.1,286.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1118.1,286.4c0-.1.1,0,.1-.1S1118,286.3,1118.1,286.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.8,282.4c-.1-.1-.1,0-.1.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1113.6 282.5 1113.6 282.4 1113.6 282.3 1113.6 282.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.1,282.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.2,282.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1113.2,282.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.9,282.1v.2c.1-.1-.1-.1.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.5,282.1c-.1-.1-.3.2-.3,0s0,.4-.3.5.2-.5.5-.3S1112.4,282.1,1112.5,282.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1112.5,282.5a.1.1,0,0,0-.2-.1S1112.4,282.6,1112.5,282.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1111.9,282.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1111.4,282.1v-.2C1111.4,282,1111.2,282,1111.4,282.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.6,282.1c-.1,0-.1.3.1.2h-.1C1110.7,282.3,1110.5,282.2,1110.6,282.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1109.8,283.2a.1.1,0,0,0,0-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110.3,283.9c.2.1.1-.1.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1109.5,283.1c0-.1.1-.1.1-.1S1109.4,283,1109.5,283.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1109.3,283.3h-.1c-.1,0-.2.1-.2.2l.3.3c.1-.2-.1-.5.1-.3V283C1109.2,283,1109.4,283.2,1109.3,283.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1110,283.6h-.1c.1.1,0,.1,0,.2S1110,283.7,1110,283.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1108.8 283.9 1108.8 284 1108.8 284 1108.8 283.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1108.7 283.9 1108.7 283.8 1108.7 284 1108.7 283.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1108.6 283.9 1108.6 283.9 1108.6 283.8 1108.6 283.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1108.3,283.9h.1s.1,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1108.4,287v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1108.1,286.8v.2c.2,0,.1-.2.3-.3h-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1105.1,286.8c0-.1,0-.1.1-.2h-.5c0,.1-.2.2-.1.2h.2C1104.9,287,1104.9,286.7,1105.1,286.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.2,284.7h-.1C1099,284.7,1099.2,284.7,1099.2,284.7Z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.7,233.2c.1.2,0,0,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.7,233.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.9,233.3c0,.1-.1,0-.1.2S1100,233.5,1099.9,233.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1099.8 233.2 1099.9 233.3 1099.8 233.1 1099.8 233.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1099.8 233.1 1099.8 233.1 1099.8 233 1099.8 233.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.1,233.3h0c-.1-.1,0-.2-.1-.3s.1.3,0,.3.1,0,.2.2S1100.1,233.4,1100.1,233.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.7,235h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.6,236.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.3,234.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.7,235.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1101.8,237.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.2,234h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1103.1,235.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.6,233.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.8,233.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.8,233.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.7,233.6c0,.1-.1.4,0,.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.7,235Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.4,234.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.2,233.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.4,234.7h0S1102.4,234.7,1102.4,234.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.2,233.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.3,234h0c0-.2,0,0,0-.2h0v.2C1100.3,234.1,1100.3,234.1,1100.3,234Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.1,235.1h.1l-.5-.2h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.8,235h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.6,234.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.4,235.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.9,235.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.9,232.8c0,.2,0,0,.1.1h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1100.3 234 1100.3 234 1100.3 234 1100.3 234"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1101.8,233.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.6,235.1h0C1099.6,235.1,1099.8,235.2,1099.6,235.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1098.6,233.3h-.1c0,.4-.5.4-.2.8s.3.3-.2.4h.1a2.1,2.1,0,0,0-.2,2.2h-.1l.2.5.4.5a2.3,2.3,0,0,0,1.2.7h2c.1-.2-.1-.3,0-.5h.2c0,.1.1.2.1.2s.4-.1.4-.3h-.1l.2.2c-.1-.5.3,0,.3-.3a4,4,0,0,1-.5-.8h.1c0,.1.2.1.1.2s.1-.2.1-.3h.1c.1,0,0-.1,0-.1h.3c-.1-.2,0-.2-.1-.3s-.2-.1-.3-.1h0c.1-.1,0,.1.2.1s-.3-.2-.3-.1,0-.2-.1-.3h0c0-.1.1-.1,0-.1h.3c.2.1-.3.2.3.3s.2.2.1.3.3-.1.2-.2h-.3l-.2-.2h.1l-.2-.2h-.3c-.2-.1,0-.1,0-.1h.4c.2,0-.1-.1,0-.1h-.1c0-.1,0-.1-.2-.1h-.1c-.1,0-.2-.1,0-.1h0c.1-.1,0-.2-.1-.2h-.2s0,0,0,0h.1c.2-.1-.1-.1-.1-.1h0s.3-.2.1-.2h-.1c.2-.3-.2-.1-.1-.4l-.2.2h-.3c.1-.2.1-.4.3-.6s-.1.2-.2.2h0v.2h0c-.1,0-.3.2-.5.4l.3-.4h-.2c.1-.1,0-.2.1-.3s-.2.2-.1,0,0,.1,0,.2-.1.1-.2.1.1-.1.1-.2-.1.1-.1,0-.1,0-.1,0a.3.3,0,0,1,0,.3h-.1c-.1.2,0-.2-.1-.1v-.2l-.2.2v-.2c0,.1-.1,0-.1.2s.1-.2.1-.3-.1.3-.2,0v-.2h-.1c0,.3-.1.2-.1.6h0c0,.1,0,.3-.1.2a.6.6,0,0,1,0-.3c-.1,0,0,.4,0,.3a.5.5,0,0,1,.1.2s.1.1.1-.1h0a.6.6,0,0,1,0-.2s0,.1.1.2,0-.3,0-.3h0a.7.7,0,0,0,.1-.3c0,.2.1-.1.1,0s-.1,0-.2.2,0,.2,0,.3v-.2c0,.1,0,.3,0,.1h0s0-.2.1-.2h0s0,.2,0,.2,0,.1.1,0,.2-.3.2-.6h.2c0,.1-.2.3-.2.5h0c-.1.3.2-.2.1.2s0,0,0,.1v0h0c-.1.1-.1.1,0,0h.1l.2-.3c0,.1.1.1-.1.3h0c-.2.2.2-.1.1,0h-.5c.2,0,0,.1.4.1h.2l-.3.2h.2c-.1.1-.1.3-.4.3h.1c-.2.1-.1.2,0,.3h-.3l.2.3-.3-.2h0l.3.5-.2-.3h-.1c.1.1.1.1,0-.1h.1v-.2h-.2c0,.1,0,.2,0,.2h.2s0,0,0,0h-.5c.1-.1-.1,0-.1-.1h0l.4.2c.4,0,0,0,.1-.1h-.3c-.1,0-.1-.1-.1-.1h-.1c-.2,0,.1.1-.1.1h-.1s0,0,0,0,.1,0-.2-.1h0c-.2,0-.2-.1-.2-.2h.4c.1,0-.1-.1,0-.1h.1s-.1-.1,0-.1h-.3c-.1-.1.2,0,.3,0s0,0,0,.1h.2l.2.2s-.1-.1,0-.1l.2.2h.1l.3.2h0l-.4-.2h.1l.3.2h-.2l-.3-.2h.1l-.3-.3.2.3h0c-.1-.1,0,0,0-.1h0v.2c0,.2,0,0,0,0h0c0,.3,0-.4,0-.2v.1a.4.4,0,0,1,0,.1V235a.6.6,0,0,1,0,.3h0V235h.3s0,0,0-.1h-.2l-.2-.4v-.2h0c0,.2,0,.5-.1.4s0-.1,0-.4,0,.1,0,0v-.2a1.9,1.9,0,0,0,0,.3h0c0,.2,0,0,0,.1s0,.1,0,.2l-.2.4c.1,0,0-.1,0-.1s.1-.1,0-.1v-.3h-.1l.2-.5h-.1v.4h-.1c.5,0-.3,0-.3-.1h.4l-.3-.2h.2c.1,0-.1-.1.1,0h-.1c-.1,0-.2,0-.1.1l-.5-.2h.1c-.4,0-.5.2-.7.4s-.1.4.2.5.1,0,.2.1-.2.1-.2.2h.2c-.1.1,0,.5.2.3s-.1.1-.1.1.1-.1.1.1h0l.3.3c.1-.3.1-.1.3-.1s0,.1,0,.2v-.2c.1-.2.1.1.2.1h0c.1-.1.2.1.3.3s.5-.3.8-.2h.6l.3-.3h.1v-.2h-.3c0-.1,0-.1,0-.1h0c-.1-.1-.3-.2-.2-.2h0s-.1-.1,0-.1h.2v-.2c-.2-.2,0-.5,0-.6s.1.3.3.4v-.2h-.2a2.4,2.4,0,0,0,0-.3h-.1c.2,0,0-.1.2-.2s-.5-.2-.6-.7-.3.2-.3.1a.1.1,0,0,1,.1-.2h-.1c0-.3-.2-.2-.3-.4h-.2v-.2c-.1-.1-.2.3-.3.2s0,.3,0,.5-.1-.2-.1-.1-.1,0-.1-.1h-.1c-.1,0,0-.2,0-.3s-.2,0-.3,0h-.6v-.2c-.1-.1,0,.1,0,.1s-.1,0-.2-.1S1098.5,232.8,1098.6,233.3Zm3.5.2h0Zm.2.7c-.1-.1,0-.1.1-.1s0,.1,0,.2h0C1102.1,234.3,1102.4,234.1,1102.3,234.2Zm-1.5-.5h0Zm.3,0h0Zm-.1.5c-.1,0-.1.1,0,.1Zm-.9,1.9h0Zm-.9-1.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.4,235.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.6,234.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.1,232.5h0a.7.7,0,0,0,0,.4c0-.2.1-.1.2-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.3,233.6v.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.5,234.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.8,232.4h-.1c0,.1.1.1.1,0S1100.8,232.4,1100.8,232.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.5,234.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1101.4,232.5c.1-.2-.1-.1-.1-.1S1101.3,232.6,1101.4,232.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.9,233.7h-.1l-.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1101.5,232.5c0-.1,0-.2,0-.2s-.1.2,0,.2h-.1C1101.3,232.8,1101.5,232.5,1101.5,232.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.7,234h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1101.5,232.9l.2-.2h-.1C1101.6,232.8,1101.4,232.9,1101.5,232.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1101.8,232.9h.1v-.2C1102,232.7,1102,232.8,1101.8,232.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1101.8,233.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.9,234.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.6,234c-.1,0,.1.1.2.2S1102.7,233.9,1102.6,234Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.8,234.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1103,236.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1103,236.3s0-.1-.1-.2v.2S1103.1,236.4,1103,236.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.6,236.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.3,235.9h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1100.4 235.8 1100.4 235.8 1100.4 235.8 1100.4 235.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.6,235.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.6,235.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.6,235.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.7,235.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.7,235.7c.1,0-.3,0,0,0h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.3,235.8h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1100.6 235.6 1100.7 235.6 1100.6 235.6 1100.6 235.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.6,235.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.8,235.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.3,235.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.5,235c-.2,0,0,.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.6,235.3c.1,0,0,0,0,0S1100.7,235.4,1100.6,235.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.5,235.3h.2c.1,0,.1,0,0,0l-.4-.2c.1.1.4.2.1.1h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.9,235.1h0C1099.6,235,1099.9,235.1,1099.9,235.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1100.4 235.1 1100.4 235.1 1100.4 235.1 1100.4 235.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.5,235.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1100.5 235.1 1100.5 235.1 1100.5 235.2 1100.5 235.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.3,235h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.3,232.6a.3.3,0,0,0,0,.2v-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1100.5,232.9v-.2c-.1,0-.2.1-.3.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1102.3,234.7h-.2a.9.9,0,0,1,0,.6h.2V235h.1C1102.5,234.9,1102.3,234.9,1102.3,234.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1099.7,234.6h0Z"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.6,238.6c.2,0,.1,0,0-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.6,238.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.7,238.2c.1.1,0,.2.2.3S1128,238.2,1127.7,238.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1127.6 238.3 1127.7 238.3 1127.5 238.2 1127.6 238.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1127.5 238.4 1127.5 238.4 1127.4 238.2 1127.5 238.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.8,237.8h-.3c0,.1.3,0,.3.2s0-.2.2-.2S1127.9,237.9,1127.8,237.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.5,238.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.4,240.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1130.9,237.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.8,237.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129.8,242.7h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1130.6,236.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.9,239.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.3,236.9h0S1128.2,236.8,1128.3,236.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,236.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.7,236.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.3,236.8c.1.1.2.3.1,0h0c.1,0,.1-.1.1-.1h-.2C1128.1,236.6,1128.2,236.8,1128.3,236.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.4,238.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.2,237.7h0S1131.2,237.7,1131.2,237.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1130,235.5h0S1130,235.5,1130,235.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.2,237.8h0S1131.1,237.8,1131.2,237.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1130.5,236.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129.4,238.3s0,.1,0,.1,0,0,0-.2h0v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.3,237.4h.1c-.1-.1-.2-.3-.2-.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.1,237h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129.6,238.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129,239.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.8,237.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1130.3,235.3c-.1.2,0,0,.1.2h-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1129.4 238.2 1129.4 238.2 1129.4 238.2 1129.4 238.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1132.4,237.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.8,237.1h-.1C1127.7,237.2,1127.9,237.3,1127.8,237.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.9,234.9h0c-.3.3-.9,0-1.1.5s-.1.5-.7.3h.1a3.3,3.3,0,0,0-1.4,1.6,2.7,2.7,0,0,0-.1,1.7h-.1a4,4,0,0,0,.2,1.3,4.1,4.1,0,0,0,.8,1.4,3.3,3.3,0,0,0,2.9,1.1c.2-.1,0-.3.1-.5s.2-.1.2,0,0,.2,0,.2.6-.1.7-.4h-.2l.2-.2c0,.1.2.2.2.2s.4-.1.5-.5a9.2,9.2,0,0,1-.3-1.2h.1c-.1.2.2.1.1.3s.1-.4.2-.6h-.2l.3-.2h.1c.1,0,0-.1,0-.2h.3c-.2-.2,0-.2-.1-.4s-.2-.1-.3-.1v.2c.1-.2,0,.1.2.1s-.4-.2-.4,0,0-.3-.1-.5-.2,0-.2,0,.1,0,.2-.1.1-.1,0-.2.2,0,.3,0-.3.4.3.4.2.2.1.3.3-.2.2-.4h-.3c0-.1-.2-.1-.2-.2h.1c0-.1-.2-.2-.3-.4l-.3.3c-.2-.1,0-.1,0-.2h0c.1-.2.3,0,.4-.1s-.1-.1,0-.2h-.1c0-.1,0-.2-.2-.2s0-.1-.1-.1-.3-.1,0-.3h0c0-.1.1-.2.2-.2v-.2h.2c-.1-.2-.2-.1-.4-.2s-.1-.4-.2-.4h-.1l-.2-.2h.1c.1-.2-.2-.1-.2-.2h0c0-.1.1-.4,0-.3h-.2v-.2h-.2c-.1,0,0-.1,0-.1s-.3,0-.5-.3,0,.2,0,.3l-.3.2c-.1-.2-.4-.4-.4-.6s.1.2,0,.3h0l.2.2c0,.1-.1.2-.2.2v-.2c-.2.1-.1.4-.1.6s-.1-.3-.2-.4h-.1v-.2h-.2c0-.2-.2,0-.2-.3s.1.3-.1.1.1,0,.1.1,0,.2-.1.3,0-.2-.2-.2,0,.2-.1.2-.1.1-.1.2a.2.2,0,0,1,.3.1.2.2,0,0,1-.1.2h.1c.2.2-.2,0-.2.2v.1h-.3c.1,0,0,.1.1.2s-.2-.1-.3-.2.2.2,0,.3h-.1c0,.1.1.2,0,.2h0c.3.1.2.3.5.3h0c.1.1.3.2.2.3h-.3c0,.1.4.1.3.2h.3c0-.1.1-.2-.1-.2h0c.1-.1-.3,0-.3-.2h.1c-.1-.1-.1-.2-.3-.2s0-.2.1-.2-.1.2.2.4h.3l-.2-.2c.1,0,.3,0,.1-.1h0c0-.1-.2-.1-.1-.2h.1c.1,0-.1-.1-.1-.1h.2c-.1-.1.1-.1.1-.1s-.1-.4-.4-.4v-.3c.1.1.1.4.3.5h-.1c.1.1.1,0,.1,0s0-.2.2,0h.2l-.2-.2h.2a.2.2,0,0,1,0,.1c.1.2.1.1,0,0h0a.3.3,0,0,0,0-.1h0v-.3c.1.1.3,0,.3.3v.2s.1-.1.1-.2h0a.9.9,0,0,0,0,.2.2.2,0,0,0,0,.1c.1-.2.1-.1.2-.2h-.1c.1-.1.2-.3.2-.2s0,.3-.2.3.1-.2.2,0h0c-.1.1-.2,0-.2.1h-.1v.2s0,0,0,.1h.7l-.2.3h.4l-.2.2s0,0,0,0h-.4l.5.2h-.3c-.1.1.3.1.3.3h-.1a1.4,1.4,0,0,1-.4.8h.1a.8.8,0,0,0-.1.7h-.3c-.1,0,.2.3.2.4l-.3-.3v.2h-.1a5.9,5.9,0,0,0,0,.7c-.1,0-.1-.4-.1-.4s0-.1,0-.2,0,.2-.1-.1,0,0,0,.2,0,0,0,.2-.1,0-.1-.3-.3-.1-.3-.2h-.1c-.1.1,0-.1-.1,0h-.1l.4-.3h-.3l-.3.2h-.1l.2-.2h.1l.4-.2h-.3c-.1,0-.3,0-.2-.1h-.3c.2-.1,0-.1.1-.1h.1c-.2,0-.4,0-.4-.2h.4c.1-.1-.5-.2-.5-.3s-.1-.1-.1-.3h.6c-.2,0-.2-.2-.2-.3h-.2c0-.1-.1-.2,0-.3s-.1-.2-.2-.3l.4.2h-.1c0,.2.4.4.3.4s0-.1.1-.1h0l.3.2s-.4-.2-.2-.2h.2c-.1-.1-.4-.2-.3-.3h.2s-.3-.2-.2-.3h-.2c-.1-.1,0-.2.1-.2h-.1c-.2-.1,0,.2-.2.1l.2.2-.3-.2h0c-.3-.2.1,0-.1-.2h0c-.2-.1-.1-.2,0-.3h.3c.1.1,0-.2.1-.2h.2s-.2,0-.2-.1.2.1.3.2-.1,0-.1.1.1,0,.3.1-.1,0,0,.3,0-.2.1-.1,0,.1,0,.3h.1c-.1,0,.1.3.1.4s-.1-.2,0-.1a1.4,1.4,0,0,1-.1-.4h.1c0,.1,0,.3.1.4h0v-.2c0,.1,0-.3,0-.4h.1c.1-.2.2-.2.4-.4s0,.3,0,.4-.1.3-.1.4a.8.8,0,0,0,.1-.3c0,.1.1-.2.1,0s-.1.2-.1.3.1-.3.1-.2h.1c-.1.3.1,0,0,.3s.1-.2.1-.2.1,0,.1.1h-.1v.2c0,.2.3-.4.3-.1l-.2.2s.1.1.1-.1a.2.2,0,0,1,0,.1h.3c0,.1-.1.2-.1.2s0,.2.1.2h0c-.1,0,.1.1,0,.1h-.2v.2h0s0,.1,0,.1v-.2s0-.1,0,.2,0,.1-.1-.2h0c-.1.2-.2.5-.3.3l.2-.3h0v-.2l-.2.3h0c-.1.2-.1,0-.1.1l-.2.2-.4.2.5-.3.3-.2h-.4v.2h0c-.1,0-.1,0,0-.1h.1c-.4,0-.2-.2-.5-.3h.3c0,.1-.1.1,0,.1h.2l-.5-.3h.4c-.1-.2-.6-.2-.5-.3s.2.2.3.1h0c.4.2-.3-.2-.2-.3l.3.2c0-.1-.2-.4-.1-.4h.3s0,0,0,0,0-.1.2.1h0c-.1-.1-.2-.2-.2-.1s-.3-.3-.3-.5h0a.9.9,0,0,0-1.2.3c.1.3-.3.4-.1.7s.1.1.1.3-.2,0-.3,0v.2c-.1,0-.4.4-.1.5s-.1,0-.2,0,.1.1.1.2h-.1v.2h0v.2h0v.2c.3-.1.2.1.4.2s0,.2.1.3h.3c.2,0,.1.2.3.2h0c.1,0,.3.3.4.5h1.5a1.6,1.6,0,0,0,1.6-.7h-.4c0-.2-.1-.3,0-.4h0c.1-.1,0-.1.1-.1h.3c-.2-.3.2-.4.2-.5s0,.3.1.5h.1v-.2h0c-.1,0-.1-.1,0-.1h.1v-.2c.2.1.1-.1.3-.1a.8.8,0,0,0,0-.6.8.8,0,0,1,0-.6c-.1.1-.3-.1-.3-.2h0c.2-.3-.1-.4-.2-.7h.1l-.4-.2h.1c-.1-.2-.4.2-.4-.1s-.1.3-.2.4-.1-.3-.1-.2-.1-.1-.1-.1h-.2c-.1-.1.1-.2.2-.3s-.2-.1-.4-.2h-.1a.4.4,0,0,1-.5-.1l.2-.2c-.1-.2-.1.1-.1.1s-.2-.1-.3-.3S1129.2,234.5,1128.9,234.9Zm1.1.8h0C1129.9,235.7,1129.9,235.7,1130,235.7Zm.9,1.1c-.2-.1,0-.1,0-.1s.1.2.1.4h.1v.2C1130.7,237.1,1131,236.7,1130.9,236.8Zm-2.2-.1h0Zm.4-.2h0C1129,236.5,1129,236.4,1129,236.4Zm.5.6c-.1.1,0,.1,0,.1A.2.2,0,0,0,1129.5,237Zm-1.7,2.8h0Zm-.1-3.3v.2h.1C1127.9,236.5,1127.9,236.5,1127.8,236.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.2,238h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128,236.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127,237.6h-.1l.4.2c-.1-.1-.1-.2-.1-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.1,237.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.6,237.2h-.1C1128.6,237.2,1128.6,237.4,1128.6,237.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.2,236.4h.1c.1,0,.1-.1,0-.2S1127.2,236.3,1127.2,236.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.9,237.1s0-.1,0-.1h-.1s0,0,0,0h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.8,235.6c-.1-.1-.1,0-.2,0S1127.9,235.7,1127.8,235.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.9,236.6c0,.1,0,.1-.1.1h0v.2a.5.5,0,0,1,.1.3A1.1,1.1,0,0,0,1128.9,236.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.1,235.4h-.1C1128.3,235.7,1127.9,235.5,1128.1,235.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129,236.9h0c0,.1-.1.1-.1.3S1129,237,1129,236.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.6,235.6v-.2c-.1,0,0,.1,0,.1h-.1C1128.6,235.4,1128.5,235.7,1128.6,235.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.9,235.3h.2V235C1128.8,235.1,1129,235.1,1128.9,235.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129.1,235.5h0l.3-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129.5,237.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.1,236.5c0,.1.2.2.3.3S1131.2,236.4,1131.1,236.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.4,236.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.8,240.4h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.7,240.3c.1-.1,0-.2-.1-.2v.4C1131.8,240.3,1131.9,240.3,1131.7,240.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.3,241.3c0-.1,0-.1,0-.2S1131.2,241.3,1131.3,241.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,239.2h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1128.3 239.2 1128.4 239.1 1128.5 239.1 1128.3 239.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,238.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,238.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,238.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,238.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.4,238.6c.1,0-.3-.1,0-.1s-.4,0-.5-.2.5.1.3.3S1128.4,238.6,1128.4,238.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128,238.6c.1,0,.1-.1.1-.1S1127.9,238.6,1128,238.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1128.3 238.3 1128.4 238.3 1128.4 238.3 1128.3 238.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.4,238.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.6,238.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.3,237.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1127.8,237c-.2-.1-.1.1-.2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,237.8c.1.1,0,0,0,0S1128.6,237.9,1128.5,237.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.5,237.7h.1c.1.1.1,0,0-.1l-.2-.4c0,.1.2.4,0,.2l.2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128,237.2h.1c-.1-.1-.1-.1-.1-.2S1128,237.2,1128,237.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.7,237.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.8,237.6h0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-53",
    attrs: {
      "points": "1128.9 237.6 1128.9 237.6 1128.8 237.7 1128.9 237.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1129,237.7h0s0-.1-.1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1130.9,235.4v.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1130.9,235.8h.3c-.1-.2-.3,0-.4-.1h.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1131.9,239.2c-.1-.1-.1,0-.1-.2a1,1,0,0,1-.2.5h.2v-.2h.1C1132,239.4,1131.7,239.3,1131.9,239.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-53",
    attrs: {
      "d": "M1128.7,237.3h0Z"
    }
  })])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sketch_2",
      "data-name": "sketch 2"
    }
  }, [_c('g', [_c('rect', {
    staticClass: "cls-52",
    attrs: {
      "x": "1088.6",
      "y": "296.8",
      "width": "56",
      "height": "63.38",
      "transform": "matrix(1, -0.04, 0.04, 1, -12.41, 45.58)"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1097.5,311.1c.1.2.1.2.1,0a1.5,1.5,0,0,1,0-.6A2.1,2.1,0,0,0,1097.5,311.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1097.6,310.5l.2-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1098.8,306.7c.2,1,0,2.3.2,2.9A6,6,0,0,0,1098.8,306.7Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-54",
    attrs: {
      "points": "1098.7 308.3 1098.8 308.4 1098.6 307.5 1098.7 308.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1098.6,309h0v.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1098.9,303.3v1c-.2,1-.2-.6-.3,0s.3.4.3,2.1c.1-.1,0-2.6.2-2.3C1099.2,302.7,1098.9,304,1098.9,303.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1134.1,315.2h0C1134.1,315.1,1134,315.2,1134.1,315.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1124.1,305.3h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1129.6,321.1l-.6-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1132.6,341h.1V341Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1131.7,300h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1123.4,320.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1128.7,306.8l-.5-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1112.8,305.2h0a2,2,0,0,0,.4-.8l-.5.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1115.1,302.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1115.6,305.8h0S1115.6,305.8,1115.6,305.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1113.3,304.4c.3-.5.5-.1.4-.8h-.1c.1-.1.2-.6.3-.9h-.1l-.3.6a1.3,1.3,0,0,0-.2.5A2.7,2.7,0,0,1,1113.3,304.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1134.2,315.2c0,.1.1.4,0,0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.5,319.7l.3-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1120.5,316.2h0S1120.5,316.3,1120.5,316.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.9,318.9l-.2.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1121.3,320.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1101.8,348.6h0s0,.1,0,.2,0-.1,0-.2h0l-.2.2h.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1128.3,340.6v-.2c-.1.1-.2-.1-.5.8s.1.3.2.3.2,0,.2.6a2.3,2.3,0,0,1,.1-.9C1128.3,341.7,1128.1,341.2,1128.3,340.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1128.4,341.2h.1l.2-.4A1.5,1.5,0,0,0,1128.4,341.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1102.9,338.7l.3-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1129.5,301.8l-.5-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.6,345.4v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1123,342c.3.2-.1-.2-.2-.9l-.2-.2h0v.3Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-54",
    attrs: {
      "points": "1101.9 348.6 1101.9 348.6 1101.9 348.6 1101.9 348.6"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1113.8,345.7v.3A1.9,1.9,0,0,0,1113.8,345.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1132,339.4h.4c.1.4.1.8.2,1.2v.3c-.1-.3-.1-1-.2-1.5h-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1126.3,352.6l.3.3h.7a3.3,3.3,0,0,0,1.5-.6l.6-.5.5-.6a5.5,5.5,0,0,0,.6-1.1,3.4,3.4,0,0,0,.2-.7c0-.3.1-.4.1-.6a9.9,9.9,0,0,0-.4-3.3,4.5,4.5,0,0,0-.1-2.4v-.8a.8.8,0,0,1,.1-.7h-.1l.2-.3h.6a2.3,2.3,0,0,1,0,.3v2.1l.2.8c.1.4.2.8.3,1.2s.1.8.1,1.3,0,.9.1,1.4a6,6,0,0,0,.1.9l.2.6a2.1,2.1,0,0,0,.7.9,1.9,1.9,0,0,0,1.5.3l.8-.3.9-.8a3.8,3.8,0,0,0,.8-2.1,8.3,8.3,0,0,0,0-1.7c0-.5-.1-1-.2-1.4s-.1-.7-.1-1.3l-.3-2.6v-1c0-.1,0-.2,0-.2h.3l.3-.2a3,3,0,0,0,.8-.9,4.6,4.6,0,0,0,.5-1.8,16.7,16.7,0,0,0-.1-2.7,13.3,13.3,0,0,1,.7-4.3l1.3-4.7a38.3,38.3,0,0,0,1.1-4.9,16.8,16.8,0,0,0,0-5.3,28.1,28.1,0,0,0-1.3-5l-.9-2.3c-.3-.8-.6-1.5-1-2.3a10.6,10.6,0,0,0-3.6-4.3c-.7-.4-.9-.3-1-.3h-1.6l-.4-.3c.7.3.4,0,.6,0s-1.2-.7-2.2-1.1a5.8,5.8,0,0,0-2.8-.2h-.6c.2-.1-.4-.2-.1-.3h-3.4a4.7,4.7,0,0,0-1.6.4l-.8.7a4.5,4.5,0,0,0-1.1,1.5,4,4,0,0,0-.3,2.1,2.6,2.6,0,0,0,1.1,1.9l1,.5h0l-.7-.2h-.3a2,2,0,0,1-.8-.8,2.3,2.3,0,0,0,.8.9l.9.4a2.5,2.5,0,0,0,1.1.1l.7-.3.3-.2.3-.2.5-.2c-.2,0-.2-.1.2-.3a6,6,0,0,1,1.5.2h.7c.1.1,1.3.5,1,.6a9.7,9.7,0,0,1,2.6,1c-1.1-.8.4,0,.3-.2l-.7-.4-.7-.3c1.8,1.1-.6-.3-.6,0s1.4.2-.1-.4l2,.9,1.8,1.2c-.9-.7.3,0-.2-.4,1.1,1,.2.3.4.7s.6.9,1,1.5-.2-.1-.1.5a11.4,11.4,0,0,0-.9-1.6c-.5-.6-1.1-1-1.1-.6a23.1,23.1,0,0,0-2.2-1.2l1.2.9,1.2.9.2-.2c.5.5.7.5,1,1s0,.3.2.8-.1-.4-.1-.3a8.5,8.5,0,0,1,1,2.6,14.8,14.8,0,0,0-.3-2.6c.3.2.3.7.5,1.4s-.1-.2-.1,0v.7c.2,1.6-.3-.2-.2,1.2a2.8,2.8,0,0,0,.3,1.1,2.3,2.3,0,0,1,.3.8h0v.3h0c.2.8.2,1.5.3,1.7a6,6,0,0,0-.1.9,3.2,3.2,0,0,1-.9,1.9h0c-.6.8-1.2,1.2-1.1,1h-.2l-.3.2h-.4v-.2h-2.2a8.3,8.3,0,0,0-2-.6h-1.9l-1.9.2h-1.2l-.6.2a1.8,1.8,0,0,1-.9.3h0c-.1,0-.2-.1-.2-.2s0-.4-.1-.4a.6.6,0,0,0-.1-.3v-.3c0,.2,0,.2,0,.3v-.2c0-.1,0-.2,0-.2V318a5.5,5.5,0,0,0-.1-1v-.3c-.1-.5,0-.6,0-.5a7,7,0,0,0-.3-2.5,23.4,23.4,0,0,0-1-2.6c-.3-.3.1.5,0,.6l-.6-.8-.8-.9c-.5-.7-.8-3.4-.5-3.1-.3-1.6-.1.5-.3-.2v-.2a6.3,6.3,0,0,1,.1,1.4c-.1.2-.5-1.3-.5-1.7l.3.3c-.4-1.5-.6-1.1-1-2s.2-.6.3-1l-.2-.7-.2-.7v-.2l-.3-.7-.3-.4c-.1-.1-.1-.2-.2-.3h-.5c.4-.2,0-.2-.4,0s-.6.4-.2-.1-.5,1-.8,1,.4-.5.6-.6-.1.3-.4.8a8.9,8.9,0,0,0-.7,1.6c-.1,0,.1-.7-.4.3a1.3,1.3,0,0,1-.4.9h-.2c.1.1-.1.2-.3.3h0c.2,0,.3,0,.2.1a3.5,3.5,0,0,1-1.8.3h.7a16.9,16.9,0,0,1-2.7.1l1.3-.3a8.3,8.3,0,0,1-2.5.3l-.5-.2-.5-.2c-.1.1-1.1-.3-1.2-.1s1.1.1,1.2,0l-1.4-.3-1.5-.2h-.6l-.5.3-.6.3a.8.8,0,0,1-.6-.1c-.1-.1-.2-.1-.2,0l.3.3.3.2a1.4,1.4,0,0,1-.7-.4l-.5-.6-.6-1c-.2-.2-.1-.2.1-.1l.6.6a1.2,1.2,0,0,0-.6-.6l-.6-.2.3-.2a3.8,3.8,0,0,1,0,.5c.1-.6.2-.5.3-.1v-.4l-.6.5c.4,0,.8,1,.8.8v-.2c.1,0,.3.3.4.5s.4.6.3.6-.1,0-.1.1a1.3,1.3,0,0,0,.7.5h.2l.8-.3h.2c.6-.3,1.7-.1,2-.3s1.7.3,2.3.6-2.5-.7-3.3-.4c.7.1-.5.2-.7.4h2.3a2.4,2.4,0,0,0,1.3.5h-.2c1,.2.8-.1,1.6.1s-.1.1-.2.1.7-.1,1.2-.1-.4.2.3.2a8,8,0,0,1,2.2-.1c-.2-.2.6-.2,1.3-.5a1.2,1.2,0,0,0,.5-.5h-.4l.4-.4a4.9,4.9,0,0,0,.5-1.2c.2-.3.1.2.1.5s-.1.7.1.5l-.3.5a2.1,2.1,0,0,1-.9.6c.1.1.6-.1,1-.5a3,3,0,0,0,.4-.8l.2-.7c.2-.4.4-.8.5-.8l.3-.4h.6s0,.1.1.2a7.6,7.6,0,0,0,.1-.8,3.1,3.1,0,0,1,.1,1.2h0a4.1,4.1,0,0,1,.2.8l-.2-.2c0,.5,0,.5.1.6v.9l-.2-.4a2.3,2.3,0,0,0,.2.7v.6a3.8,3.8,0,0,0,.1-1.2c.2,1.8.5,3.2.8,4.8-.1,0-.4-.7-.4-.5a3.5,3.5,0,0,0,.5,1.1c.2.3.4.4.4.4l.3.4a1.7,1.7,0,0,0,.3.6l.2.4c.4.1.8,1.4,1,1.6a4.9,4.9,0,0,0-.4-1.1,2.4,2.4,0,0,1,.7,1.4c-.4-1,.1,1.2-.4-.4,0,1.2.4.5.5,1.8v.8c-.2-.1-.2-1.3-.3-1.1v.5c-.1-.3-.2-.9-.4-1.6a5.2,5.2,0,0,0-.9-1.9,7.1,7.1,0,0,1,.5,1.1,9,9,0,0,1,.3,1.2,16.1,16.1,0,0,1,.5,3.4c0,.6.1,1.3.1,1.9v1.3l.3,1.4a4.3,4.3,0,0,0,2.5-.1l.8-.3h.8l.6-.2a20.8,20.8,0,0,1,2.8.3c-.6-.2-.6-.2-.6-.3s.2-.3,1.1,0-.6,0,.1.2,0-.2.4-.1l.8.3.5.3-.6-.2c-.3,0,1,.4.2.3h1c.6.2-.4.1-.2.2l1.1.2h1.3a2.1,2.1,0,0,0,1.2-.7l.8-.9c0,.1.2.3.1.2a8.1,8.1,0,0,0,1.6-3.8,4.1,4.1,0,0,1-.3,1.1,7.3,7.3,0,0,0,.5-1.6,5.7,5.7,0,0,0,0-1.6,9.7,9.7,0,0,0-.3-1.5l-.2-.7V313c-.2-.8-.2-1.7-.4-2.7a8.1,8.1,0,0,0-1.3-2.9l-1-.6-.3-.4-.4-.4a14.1,14.1,0,0,0-5.2-2.6,7.4,7.4,0,0,0-3-.1l-1.5.5-.7.5h-.1v.2h-.3c-.3-.1-.2-.3-.3-.4s-.3-.8-.2-1.2a1.8,1.8,0,0,1,1.3-1.3c-.2.2-.5.5.2.3s.2-.3.8-.3h-.3c.5,0,1-.1,2.2,0h3.1a11.2,11.2,0,0,1,2.6.7c2.1.8-.3.2,0,.4l-1-.5h-.3l1.1.5,1,.5a6.3,6.3,0,0,1,1.8.8c-.4-.2-.6-.5-.2-.3l1.1,1.1c.3.4.5.8.4.9a15.4,15.4,0,0,1,1.6,3.1c.5,1.2.9,2.3,1.3,3.5a18.1,18.1,0,0,1,.9,7.2c0,.8.1-.6.2-.2s-.2.9-.3,1.9v-.4c-.3,1.4-.5,3-.7,4.4-.1-.3-.5,1.1-.2-.1-.2.7-1.1,1.4-1.1,1.9l.8-.6c0,.1-.3,1-.2.9a11.5,11.5,0,0,0-.8,1.7c-.2.2.1-.9.3-1.4s-.7,1.9-.7,1c-.3,1.3.2-.1.1.6l-.4,1.1.3-.8a14.4,14.4,0,0,1-.5,2.6v.7c0,.4.1.7.1.7s-.1.4-.1.7.1.7.1,1l-.2-.4a5.2,5.2,0,0,1,0,1.6c-.2-.4,0-.7-.2-.9s0,.9,0,.8.2.5.3-.1a3.3,3.3,0,0,1,.2,1,1.1,1.1,0,0,1-.1.5v.2h-1.1a.6.6,0,0,0-.1.4c-.1.4-.1.4-.2.2a2.5,2.5,0,0,1,0-.9c.4-.1.8-.1.4-.2h-.6a4.2,4.2,0,0,0-.1,1.1,8.6,8.6,0,0,0,0,1v1.1a7.2,7.2,0,0,1,.4,1.7,13.1,13.1,0,0,0,.2,1.7c.1.4.2.9.3,1.7s0,1.2-.2,1.5v-.6c.1.5,0,.9-.1.8s.1.5,0,.8v.2l-.2.2h0v.3c0,.1,0,.2,0,.1l.3-.3s0,0,0-.1h-.1a3.3,3.3,0,0,1-.3-1.3v-1.7a6.2,6.2,0,0,0-.8-2.2c0-.6.2-.6.4-.4s.3,1.1.3,1.7l.3,1.4c.1.4.2.9.2,1.3a5.5,5.5,0,0,0,.2,1h-.1l-.3.3a.8.8,0,0,0-.1-.4v-.2h.1c0-.1,0-.2,0-.2h0v.4c.1.3-.1.3.1.1l.5-.3s0,0,0-.1a1.4,1.4,0,0,1-.1-.6h0a1.3,1.3,0,0,1,0-.2v.6h-.2l-.4.3h0a1.3,1.3,0,0,0-.1-.5,1,1,0,0,1,.1.5v-.2l.6-.3c-.1-.1-.2-.2-.1-.9a8,8,0,0,1,0-1.5,7.4,7.4,0,0,0,0-1.2,6.3,6.3,0,0,0-.5-.8l-.3-.6a3.3,3.3,0,0,1-.2-.9l.3.6a4.1,4.1,0,0,0-.4-1.2v-.4a7.6,7.6,0,0,1-.1-1.1c0,.5,0,.3-.1.2h-.1a1.7,1.7,0,0,0,0,.2v.4c0-.1-.1-.6-.2-.9l-.2-1.3h-1.5c-.3.1-.1.1-.2.2h1.5a4.7,4.7,0,0,1,.2,1.7l.2.4v.4c0,1-.2,1.1-.3.5a5.1,5.1,0,0,1,.1.7c-.3.2,0-1.2-.3-1.5v.7c-.2.3-.3-1.5-.4-2.4h0a7.6,7.6,0,0,0-2.1-.1l.8-.3h.8a2.5,2.5,0,0,0-1.5.2,2.7,2.7,0,0,0-1.2,1l-.2.2h.1l-.3.5a2.9,2.9,0,0,0,0,1.4,4.7,4.7,0,0,1,.2,1.1h.1c-.1-.6-.1-1.5.1-1a2.5,2.5,0,0,1-.1,2.1,1.9,1.9,0,0,1-.1-.9,5,5,0,0,0-.2-1.2,3.4,3.4,0,0,0,0,1.1,10.4,10.4,0,0,1,0,1.9c-.3-.6,0-1.7-.3-2s.1,1.4.2,2.8c-.1-.2-.2-1.5-.3-1.4v.9c0-2.1-.3.3-.4-1.2-.1.7.2,1,.1,2.2.1-.3.2-1.3.4-.2v1.2c-.1.5-.4-1.1-.4-.4l.2,1.1c.1,0,.1-.5.2-.2a1.8,1.8,0,0,0,.1.8c.1.3.2.3.1.7l-.4.5h-.2l-.4.3a.6.6,0,0,1-.5-.2l-.4-.6a7,7,0,0,1-.6-1.7c.3.9.2-.1.3-.7.1,1.1.4,1.1.5,1s-.4-1.1-.4-.7c0-1.2-.2-.8-.1-1.9s.2.3.3.1-.3-.3-.4-1.9c0,.1.1.2.1.1a3.7,3.7,0,0,0-.6-1.8,3.9,3.9,0,0,0-.3-1.4l-.2-.5c0-.1-.1-.3,0-.2s-.6-1.2-.5-.8.3,1.1.2.8l-.4-.9v-.3h-.6l-.6-.3h-2a6.2,6.2,0,0,1-1.9.1c1.2-.1.4-.2,1-.3s-2.3,0-1.1.1h-2l-1.2.3-.9.3-1.4.3-.7.2-.6.4-.3.3a2.7,2.7,0,0,0-.3.7,4.7,4.7,0,0,0-.1.6c0,.4-.1.7-.1,1V344c-.1,1.4.2,2.6.2,3.6h0c0,.3,0,.3,0,.3h.2s.1.2-.1.4-.2,0-.4,0h-1.6c-.1-.1-.1-.2-.1-.4v-1.1a18.7,18.7,0,0,0-.4-2.7c.1,0,.2.1.3.6a19.3,19.3,0,0,0-.7-2.5l-.2-.5v-.9c-.1-.7-.2-1.5-.3-2.2h0a4.6,4.6,0,0,0-.7-2.1l-.5-.5-.7-.3a1.9,1.9,0,0,0-1,.4,4.4,4.4,0,0,0-.9.9,7.1,7.1,0,0,0-1.3,2.4c0-.3,0-.4.1-.7a3.9,3.9,0,0,0-.4,1.5,6.8,6.8,0,0,0,0,1.1v1.1c0,.6-.1,1.3-.1,1.7s-.3,1.7-.5,3.4c0,.1,0-.2-.1-.3a5.8,5.8,0,0,1-.1,1l-.3,1.3,1.1-1.2-.4.2h-.2l-.3.3h.1l.5.5.2.3v.2l-.3-1.3h-.7a.6.6,0,0,1-.1-.4c0-.2,0-.4,0-.7s0-.6,0-.8.1,0,.2.2v.6c0,.2,0,.5,0,.6s.1.1.1.1v-1.1c0-.2,0-.3,0-.5s.1.1.2.4a4.9,4.9,0,0,0-.2-1.3l-.2-.6v-.3c-.1,0-.1.2,0,.7a31.3,31.3,0,0,1-.4-3.8c0,.4,0,1.7-.1,1.2s-.5-2.2-.5-3.4.2-.5.2,0,.1,1,.2.9.3-.8.4-.2c.1-1.2.1-2.2.4-3.4h.1a13.5,13.5,0,0,0,.3-1.7c0-.6,0-1.1.1-1.3v-.3l.4-.4.3-.5.2-.7-.2.7-.3.4.3-.5a2.9,2.9,0,0,0,.2-1,2.7,2.7,0,0,0-.1-.6l.2-.2h0c-.2-.2-.3-.4,0,.1l.5-.4.4-.5a3.8,3.8,0,0,0,.8-2.3,2.1,2.1,0,0,0-.6-1.3,1.9,1.9,0,0,0-.7-.5c-.4-.4,0-.3.2-.2a3.2,3.2,0,0,1,.9,1,2.7,2.7,0,0,1,.3.9,4.7,4.7,0,0,1,0,.7,3.1,3.1,0,0,0,.1-.7c-.1-1.1-.7-1.6-.5-1.5a6.8,6.8,0,0,0-2.1-1.2l-1.5-.5c-.5-.4-.9-.9-.6-.9s-.8-.5-.7-.2.1.6-.8-.6,1,1-.1-.6l.2.3c-.2-.7-.3-.9-.6-1a1.6,1.6,0,0,1-.8-1.1c.2-.3.5.9.4-.1a7.9,7.9,0,0,1-.6-3.4v.2c0-1,0-2.8,0-3.7h0v0a2.8,2.8,0,0,1,.2-.5v-.6a2.2,2.2,0,0,0,.2-.9v-.3l-.2-.2a1.3,1.3,0,0,1,.1.6,2,2,0,0,1-.2.7,3.4,3.4,0,0,0-.4,1.2,4.6,4.6,0,0,0,0,.6c-.1-.9-.3,1.4-.6,1v.2a31.1,31.1,0,0,0-.4,4.1,6.6,6.6,0,0,0,.5,2.4,10.7,10.7,0,0,0,1.2,2.1,17.6,17.6,0,0,0,2.2,1.8,24.4,24.4,0,0,0,2.4,1.3h.4a1.3,1.3,0,0,1,.4.8,1.5,1.5,0,0,1,0,.3c0-.2,0-.3,0-.3h0l-.3.5a2.1,2.1,0,0,1-.4.9h-.4l-.3.3-.2.3h-.2a3.4,3.4,0,0,0-.2,1.2v.7h-.2l.2-.3a.2.2,0,0,0,0-.1h-.1v.2l-.5.5v-.2a2.3,2.3,0,0,0-.4.8c-.3.9-.2,1.5-.4,2l-.5,1.9c.3.2-.3,1.7-.2,2.6s-.2,1-.2,1.6l.3.9c.3.9,0,1.3.2,2.5v-.3a14.5,14.5,0,0,1,0,3.9,5,5,0,0,0,.3,1.6,1.7,1.7,0,0,0,1.4,1.2h.9l.8-.2h.1a1.3,1.3,0,0,0,.5-.4h0l-.4-.6h.8c.1-.5.3-1.1.3-1.7a10.1,10.1,0,0,0,0-1.8,3,3,0,0,1,.2-1.3,13.8,13.8,0,0,0,.5-1.7,7.1,7.1,0,0,0,.1-.9v-.4a2,2,0,0,1,.1-.5l.3-.4.4-.3c.2.2.2.5.3.7s.1-.4.2-.4a7,7,0,0,0,.2.8c0-.4-.1-.3,0-.3l-.2-.5h.1a2.8,2.8,0,0,1-.1-.5c.1.1.3-.1.3.7V341c0,.5.1.4.2.8v.4c0,.1,0,0,0,.1l.3,1.2.3,1.1a5.2,5.2,0,0,1,.3,2.8c-.2-.3-.1-1.6-.4-2v.8h.2v1.2h0v.2a1.9,1.9,0,0,1,0,.5c0,.1,0,.3-.1.1v.7l.2.7c-.2-.5-.1.2,0,.7s.6.1.4.2h1l.8.2h2.2a2.7,2.7,0,0,0,1-.5,2.9,2.9,0,0,0,.8-2.1c.1-.6.1-1.2.1-1.8s-.4-.8-.4-1.5.1-.5.2-.2,0-.2,0-.4,0-.3,0-.4v-.2a9.7,9.7,0,0,0,.2-1.4v-.5h.6l.9-.4.6-.2h.6v.2c1.1,0,.8-.4,2.2-.4s-.9-.2-1.1-.4h1.5c1.3-.1.9,0,1,.1h.8c.9.1.3.3-.1.3h1.8c.1,0,.2,0,.2.1h0v.3a9.9,9.9,0,0,1,1,2.9l-.4-.6c.1.8.2.4.3.5a3,3,0,0,1,0,1.9c.2,1,0,2,.2,3.2a6.5,6.5,0,0,0,.2.9,4,4,0,0,0,.4,1A3.4,3.4,0,0,0,1126.3,352.6Zm-5.9-35.9v.2C1120.3,316.5,1120.3,316.3,1120.4,316.7Zm6.3,3.6c-1.4,0-1-.1-1.1-.1a9.6,9.6,0,0,1,3.3.6l-.2-.2,1,.5a7.1,7.1,0,0,1-1.9-.5ZM1115.3,304h0Zm1.8,6.3.2.5A.9.9,0,0,0,1117.1,310.2Zm4.3,11.8.9-.2h-.1Zm15.8,4c.1-.4.2-1.2-.1-.5s-.3.9-.3,1.2h0Zm-8.2,15.4c-.1-.1-.1-.4-.2-.2h-.1a2,2,0,0,0-.1.9l.3.2C1129,342.3,1128.9,342.1,1129,341.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1134.4,348.4v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1128.6,342.1a6.3,6.3,0,0,1,.2-.8A1.5,1.5,0,0,0,1128.6,342.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1100,303.5l.2.3-.3-.8a1.6,1.6,0,0,0-1.3-.8h-.5v.3a2.2,2.2,0,0,0,.2.5v-.7h.2a1.6,1.6,0,0,1,1.1.9l.3.6.4.6-.3-.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1099.4,304.6a2.4,2.4,0,0,0,.5.8h.3l-.4-.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1114.1,304l-.2.3h.2A.3.3,0,0,0,1114.1,304Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1109.4,304.9l-.6.2a3.7,3.7,0,0,0,1.5-.2C1109.4,305,1110,304.9,1109.4,304.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1114.7,303.6h.1c0,.1,0,.4.1.3s-.1-.3-.1-.4S1114.7,303.5,1114.7,303.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1114.9,300.1c-.5-.2-1.1.3-1.6,1a2.6,2.6,0,0,1,.8-.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1116.1,308c-.2,0-.3-.6-.4-1.1l.2.6c-.3-.9-.3-1-.5-1.8,0,.8.2,2,0,1.9S1116.1,308.7,1116.1,308Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1116.1,301.4l-.2-.9-.3-.4c-.1-.1-.1-.3-.5-.2h.3l.5.6h-.2v.2C1115.8,301.4,1115.7,300.1,1116.1,301.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1117.4,311.5v-.3a5.2,5.2,0,0,1-1-1.3,11.7,11.7,0,0,0-.6-1.2,6,6,0,0,0,.8,1.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1116.6,305.4h.2c-.1-.9-.1.1-.2-.2a3.1,3.1,0,0,0-.1-.8C1116.7,305.4,1116.4,304.5,1116.6,305.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1117.4,308.2l.2.5.2.4s0-.2,0-.4v-.4C1117.4,307.1,1117.7,308.3,1117.4,308.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1117.8,309.5h0l.6.6.7.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1128.7,322.3c.1,0-.1-.1-.2-.2h-.1C1128.1,322.1,1129.5,322.7,1128.7,322.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1124.8,320h3.1l-2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1128.2,320.1h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1123.8,305.8h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1124.3,305.7h1.2a3.4,3.4,0,0,0-1.7.2C1124.1,305.8,1124.3,305.8,1124.3,305.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1118.4,301.9c-.1.5-.2,1.2-.1,1.1S1118.6,301.6,1118.4,301.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1135,331.4c-.2.7-.2,1.2,0,1S1134.9,332,1135,331.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-54",
    attrs: {
      "points": "1134.9 333.3 1134.8 333.4 1134.7 334 1134.9 333.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1134.7,337h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1134.6,336.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1134.7,336.8h-.1v.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.2,337.2h1c-.1,0-.1,0,0-.1h.4v.2h0v-.2h-1.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.3,341.5c0,.9.5,2,.3,2.4s.3,1.1.4,1,.2-.1.4,1.1a4.3,4.3,0,0,0-.4-1.9,3.3,3.3,0,0,1-.3-1.6C1133.5,343.7,1133.4,341.9,1133.3,341.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.6,341.1c-.1-.1,0,1,.1,1.3A3.7,3.7,0,0,0,1133.6,341.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.9,346.1v0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1133.8,347.9v-.3a.8.8,0,0,1,0,.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1134.7,347.3a1.3,1.3,0,0,0-.2-.8s-.1,0-.1.2a5.6,5.6,0,0,0,0,.7v-.3C1134.6,347.2,1134.7,346.4,1134.7,347.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1131.3,338.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1131.3,339.4h.7c.1,0,.2,0,.2.1a4.7,4.7,0,0,1,.2,1.1,11.3,11.3,0,0,0-.1-1.1c0-.1-.2-.1-.3-.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1129,339a3.2,3.2,0,0,1,1.9-.7h-1A2.1,2.1,0,0,0,1129,339Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1127.6,341.7c-.1.6-.1-.1-.2.3a4.6,4.6,0,0,0,.1.9v.5a7.8,7.8,0,0,0,.1.9c.1-.2.3-.5.4-.2a3.7,3.7,0,0,0-.2-.8l-.2-.7a2,2,0,0,1,.1-1.5,3.2,3.2,0,0,1,.2-.9,3.5,3.5,0,0,1,.5-.9,2.1,2.1,0,0,0-.8,1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1130.4,339.2h-.5l-.5.2c.2,0-.4.4-.6.8s.4-.3.7-.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1128.2,349.1l-.2.5-.3.4.2-.2.2-.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1127.7,349.6h-.1v.4h.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1127.3,349.8h0l.2-.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1126.7,348.7v.7c.1.2.1.3.2.2l-.2-.4A1.3,1.3,0,0,1,1126.7,348.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1122,340.8c.3,0,.1-.1,0-.2h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1120.3,340.3h-1.1c1.2,0,1.4-.1,2.5,0h-1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1107.2,345.7c.1.1.1-.2.3.6a16.8,16.8,0,0,0-.8-3.3c0,.3-.5-.7-.3-.2l.5,1.4-.2-.2C1106.9,345.1,1107.1,344.7,1107.2,345.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-54",
    attrs: {
      "d": "M1097.3,317.9c.1.1.1,0,.2-.2S1097.3,318.1,1097.3,317.9Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-55",
    attrs: {
      "d": "M1102.1,313.5c-1.3.9.2,1.4,1,1.1a.8.8,0,0,0-1-1.1,1.5,1.5,0,0,0,.1.9c.8.2,1.7-.8,1.1-1.5s-2.7.8-1.1,1.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-55",
    attrs: {
      "d": "M1112.6,313.3c-.7.2-1.2,1.5-.1,1.6s1.2-1.5.4-1.8-2.3.5-1.4,1.2,2.6-.2,2.4-1.3-2-1-2.5-.3-.3,2.4.9,2.2,1.7-1.1.8-1.8-3.6.5-1.1,1.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-55",
    attrs: {
      "d": "M1106.8,313.4c-1.2-.3-1.3,1.9-1,2.5s2-2.7,1.8-3.8-2,1.7-1.7,2.8,2.9-.7,2.8-2.4-1.7-.8-2.3-.4.3,2.4,1,2.7,1.7.3,1.7-.7-1-1.9-1.4-2.4a3.9,3.9,0,0,0,1.9,3.3c.1-1.1-.8-2.2-1.4-3-.2,1,.7,3.6,2.1,2.7s.1-1.8-.9-2.4-2.3-.4-2.2,1.1c.1,3.8,2.1.1.8-.9a10.2,10.2,0,0,0,.1,1.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-55",
    attrs: {
      "d": "M1103.8,319.7c-.2,0-.3.1-.2.2a4.7,4.7,0,0,0,2.9-1,9.5,9.5,0,0,0,1.8-2.4c.3-.5.5-1.9,1.1-2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-55",
    attrs: {
      "d": "M1108.4,314.6c-.9.6,1.2,2.6,1.7,3.1a4.8,4.8,0,0,0,1.3,1c.5.2,1.1.1,1.5.4"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sh_clock_overlay",
      "data-name": "sh clock overlay"
    }
  }, [_c('g', {
    staticClass: "cls-38"
  }, [_c('g', {
    staticClass: "cls-56"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, -0.07, 0.1, 0.06, 864.43, 222.39)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('clock'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sh_table_overlay",
      "data-name": "sh table overlay"
    }
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-63"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.03, -0.03, 0.32, -0.03, 357.86, 720.84)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('pagos-oxi'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "pagos_brosta",
      "data-name": "pagos brosta"
    }
  }, [_c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "1273.3 680.2 1273.3 887 1204.5 1024 1205.5 810.2"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-93",
    attrs: {
      "points": "862.4 679.4 1273.4 679.4 1205.4 810.2 746.3 810.2"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-94",
    attrs: {
      "x": "745.1",
      "y": "810.4",
      "width": "460.8",
      "height": "211.8"
    }
  }), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-95",
    attrs: {
      "x": "751.1",
      "y": "817.1",
      "width": "448",
      "height": "33"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-95",
    attrs: {
      "x": "751.1",
      "y": "856.1",
      "width": "448",
      "height": "33"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-95",
    attrs: {
      "x": "751.1",
      "y": "895.6",
      "width": "448",
      "height": "33"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-95",
    attrs: {
      "x": "751.1",
      "y": "934.6",
      "width": "448",
      "height": "33"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-95",
    attrs: {
      "x": "751.1",
      "y": "974.1",
      "width": "448",
      "height": "33"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M803,835a5,5,0,0,1-5,5H776a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M803,874a5,5,0,0,1-5,5H776a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M803,914a5,5,0,0,1-5,5H776a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M803,953a5,5,0,0,1-5,5H776a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M803,992a5,5,0,0,1-5,5H776a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-97"
  }, [_c('g', {
    staticClass: "cls-98"
  }, [_c('use', {
    attrs: {
      "transform": "translate(781.3 521.3) rotate(-1.8) scale(0.26)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', {
    staticClass: "cls-100"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.07, 0, 0.01, 0.3, 1191.78, 601.95)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M1179.5,835a5,5,0,0,1-5,5h-22a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M1179.5,874a5,5,0,0,1-5,5h-22a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M1179.5,914a5,5,0,0,1-5,5h-22a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M1179.5,953a5,5,0,0,1-5,5h-22a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M1179.5,992a5,5,0,0,1-5,5h-22a5,5,0,0,1-5-5h0a5,5,0,0,1,5-5h22a5,5,0,0,1,5,5Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-101"
  }, [_c('g', {
    staticClass: "cls-102"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.16, 0.34, -0.1, 699.62, 1111.82)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.crayon_active
    },
    attrs: {
      "id": "crayon"
    }
  }, [_c('polygon', {
    staticClass: "cls-103",
    attrs: {
      "points": "885.2 706.4 907.2 680.4 907.2 680.4 906.7 692.4 885.3 719.1 885.2 706.4 885.2 706.4"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-104",
    attrs: {
      "x": "848",
      "y": "706.4",
      "width": "37",
      "height": "12.67"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-105",
    attrs: {
      "points": "891 699.7 892 705.4 899 695.7 899.7 688.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-104",
    attrs: {
      "points": "869.7 739.7 832.7 739.7 851.7 712.7 880 713.7 869.7 739.7"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-106",
    attrs: {
      "x": "832.7",
      "y": "727.1",
      "width": "37",
      "height": "12.67"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-105",
    attrs: {
      "points": "869.7 727.1 883 709.4 883 720.1 869.7 739.7"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-107",
    attrs: {
      "points": "832.7 727.1 849.9 709.4 850.7 720.4 844.4 726.9"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-5"
  }, [_c('polygon', {
    staticClass: "cls-108",
    attrs: {
      "points": "838.2 722.4 856.8 705.9 858 705.9 839.5 722.5 838.2 722.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-109",
    attrs: {
      "points": "843.3 726.2 861.8 709.6 859.5 712.8 840.9 729.3 843.3 726.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-108",
    attrs: {
      "d": "M839.5,722.5l3.6,2.3.2,1.5-2.3,3.2-1,.6-3.3-2.8-.5-1.2,2-3.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-8",
    attrs: {
      "points": "839.5 722.5 858 705.9 861.6 708.2 843 724.7 839.5 722.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-110",
    attrs: {
      "points": "843 724.7 861.6 708.2 861.8 709.6 843.3 726.2 843 724.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-5"
  }, [_c('polygon', {
    staticClass: "cls-111",
    attrs: {
      "points": "853.6 725.4 861 707.3 862.1 706.7 854.7 724.8 853.6 725.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-112",
    attrs: {
      "points": "859.8 726.1 867.2 708 866.8 712.1 859.4 730.2 859.8 726.1"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-113",
    attrs: {
      "d": "M854.7,724.8h4.2l.9,1.2-.5,4.1-.5,1-4.2-.7-1-.9c0-.2,0-3.8,0-4.2Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-114",
    attrs: {
      "points": "854.7 724.8 862.1 706.7 866.3 706.8 858.9 724.9 854.7 724.8"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-115",
    attrs: {
      "points": "858.9 724.9 866.3 706.8 867.2 708 859.8 726.1 858.9 724.9"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-5"
  }, [_c('polygon', {
    staticClass: "cls-116",
    attrs: {
      "points": "874.4 730.2 871 705.5 871.9 706.7 875.2 731.4 874.4 730.2"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-5"
  }, [_c('g', {
    staticClass: "cls-117"
  }, [_c('g', {
    staticClass: "cls-5"
  }, [_c('path', {
    staticClass: "cls-118",
    attrs: {
      "d": "M868.8,735.3l-3.3-24.7c0-.2.1-4,.1-4.4l3.3,24.7c0,.4-.1,4.2-.1,4.4"
    }
  })])])]), _vm._v(" "), _c('path', {
    staticClass: "cls-119",
    attrs: {
      "d": "M870.1,730.2h4.3l.9,1.2-.6,4.3-.6,1.1-4.3-.7-1-.9c0-.2.1-4,.1-4.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-120",
    attrs: {
      "points": "870.1 730.2 866.8 705.5 871 705.5 874.4 730.2 870.1 730.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-115",
    attrs: {
      "points": "869 730.9 865.6 706.1 866.8 705.5 870.1 730.2 869 730.9"
    }
  })]), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "cls-75",
    attrs: {
      "points": "848 706.4 868.7 680.4 907.2 680.4 906.9 681.9 885.2 707.1 885.2 706.4 848 706.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-121",
    attrs: {
      "points": "863.3 687.4 899.7 688.4 891 699.7 854.3 698.4 863.3 687.4"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-122"
  }, [_c('g', {
    staticClass: "cls-123"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.02, -0.01, 0.04, -0.07, 866.3, 768.43)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-5"
  }, [_c('polygon', {
    staticClass: "cls-118",
    attrs: {
      "points": "860.7 697.3 900.1 676.9 901.2 676.4 861.8 696.8 860.7 697.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-124",
    attrs: {
      "points": "865.8 702.9 905.2 682.5 904.6 683.5 865.2 703.9 865.8 702.9"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-120",
    attrs: {
      "points": "861.8 696.8 901.2 676.4 905.3 676.9 865.9 697.3 861.8 696.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-125",
    attrs: {
      "d": "M861.8,696.8l4.1.5.8,1.3-.9,4.2-.6,1-4-1.2-.9-1,.4-4.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-126",
    attrs: {
      "points": "865.9 697.3 905.3 676.9 906.1 678.2 866.6 698.6 865.9 697.3"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-127",
    attrs: {
      "points": "866.6 698.6 906.1 678.2 905.2 682.5 865.8 702.9 866.6 698.6"
    }
  })])]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.paper_active
    },
    attrs: {
      "id": "paper1"
    }
  }, [_c('path', {
    staticClass: "cls-81",
    attrs: {
      "d": "M1129.6,709.8h-.1a10.3,10.3,0,0,1-2.7,2.3c-.3.2-.6.4-.1.5s.3.1.1.3-.8.1-.8.3-1,.9-1.2,1.4a.9.9,0,0,1-.6.7,3.6,3.6,0,0,0-1.5,1.2,11.3,11.3,0,0,1-3.4,2.4c-.9.4-1.1.8-.8,1.1s-.1.2-.2.4h-.4c-.1.1.1.1.2.1h0a11.2,11.2,0,0,1-1.3,1.3c-1.2.9-2.3,1.8-3.3,2.8s-1.9,2.5-3.6,3.7l-2.7,2.1a1.8,1.8,0,0,1-.9.3c-1.2.2-2.1,0-3.4.2a3.1,3.1,0,0,1-2.1-.1,2.5,2.5,0,0,0-1.3,0,21.9,21.9,0,0,1-3.9.3H1091c-.5,0-1.3.2-1.6.1s-4.1-.3-6.4-.2h-7.8c-2.8,0-5.8.3-8.4.2a17,17,0,0,1-2.2.1,26.4,26.4,0,0,0-3.9-.1c-2.1-.1-4.8.3-6.7-.1a13,13,0,0,0-3.1.1,16.4,16.4,0,0,1-3.9.1,29.5,29.5,0,0,0-4.9-.1c-2,0-4.1.1-5.9,0s-4.3.1-6.2,0-4.7,0-6.9-.1h-7.8l-2.8.2a35.7,35.7,0,0,1-5.3.3c-3.1-.2-6.6-.1-9.8-.2-1.3,0-2.9.2-3-.5l3.9-3.3a1.3,1.3,0,0,0,.4-.6,4.3,4.3,0,0,1,2.5-2.3,8.8,8.8,0,0,0,1.7-1.4l1.5-1.1c1.4-.9,1.4-1.6,2-2.5a6.9,6.9,0,0,1,2.3-2.2c1-.6,1.5-1.3,2.4-1.9s.1-.4.2-.7.9-.8,1.3-1.2,2.5-2.2,3.6-3.2a22.6,22.6,0,0,0,2.9-2.9,2.9,2.9,0,0,1,1.1-1,5,5,0,0,0,2.4-2.3,15.1,15.1,0,0,1,3.9-3.3,18.5,18.5,0,0,0,3.7-3.1c1.2-1.3,1.4-2.5,3.1-3.8a54.5,54.5,0,0,0,4.9-4.4,20.2,20.2,0,0,1,3-2.5,3,3,0,0,1,1.5-.5c2.3-.2,4.2,0,6.3,0s2.4.2,3.7.2l2.6-.2a13.3,13.3,0,0,1,2.9-.1h16.2a40.5,40.5,0,0,1,6.4.4h1.4a25.2,25.2,0,0,1,5.3-.1h4.7a22.6,22.6,0,0,0,2.8,0,28.1,28.1,0,0,1,6.3-.3c1.8.1,3.9-.1,5.8-.1a31.5,31.5,0,0,1,5.3.3,18.7,18.7,0,0,0,3.4-.1,22.5,22.5,0,0,1,4,0,37.1,37.1,0,0,0,4.9,0h8.7a4.2,4.2,0,0,1,2,.1c.4.2,1.2,0,1.7,0,2.3,0,4.8-.2,6.8,0s6.1-.5,8.5-.2c-.3.3.3.2.5.2s.6.1.4.3a10.8,10.8,0,0,1-1.9,2.5c-1.5,1.3-2.8,2.6-4.2,3.9s-2.6,2.2-3.9,3.3-2.4,2.5-3.9,3.8-3,2.4-4.4,3.6a15.6,15.6,0,0,0-2.9,2.8,2.8,2.8,0,0,1-1.6,1.3c-1.2.4-1.1.9-1.8,1.4S1129.4,709.8,1129.6,709.8Z"
    }
  })]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.paper_active
    },
    attrs: {
      "id": "paper2"
    }
  }, [_c('path', {
    staticClass: "cls-81",
    attrs: {
      "d": "M1126.6,705.8h-.1a10.3,10.3,0,0,1-2.7,2.3c-.3.2-.6.4-.1.5s.3.1.1.3-.8.1-.8.3-1,.9-1.2,1.4a.9.9,0,0,1-.6.7,3.6,3.6,0,0,0-1.5,1.2,11.3,11.3,0,0,1-3.4,2.4c-.9.4-1.1.8-.8,1.1s-.1.2-.2.4h-.4c-.1.1.1.1.2.1h0a11.2,11.2,0,0,1-1.3,1.3c-1.2.9-2.3,1.8-3.3,2.8s-1.9,2.5-3.6,3.7l-2.7,2.1a1.8,1.8,0,0,1-.9.3c-1.2.2-2.1,0-3.4.2a3.1,3.1,0,0,1-2.1-.1,2.5,2.5,0,0,0-1.3,0,21.9,21.9,0,0,1-3.9.3H1088c-.5,0-1.3.2-1.6.1s-4.1-.3-6.4-.2h-7.8c-2.8,0-5.8.3-8.4.2a17,17,0,0,1-2.2.1,26.4,26.4,0,0,0-3.9-.1c-2.1-.1-4.8.3-6.7-.1a13,13,0,0,0-3.1.1,16.4,16.4,0,0,1-3.9.1,29.5,29.5,0,0,0-4.9-.1c-2,0-4.1.1-5.9,0s-4.3.1-6.2,0-4.7,0-6.9-.1h-7.8l-2.8.2a35.7,35.7,0,0,1-5.3.3c-3.1-.2-6.6-.1-9.8-.2-1.3,0-2.9.2-3-.5l3.9-3.3a1.3,1.3,0,0,0,.4-.6,4.3,4.3,0,0,1,2.5-2.3,8.8,8.8,0,0,0,1.7-1.4l1.5-1.1c1.4-.9,1.4-1.6,2-2.5a6.9,6.9,0,0,1,2.3-2.2c1-.6,1.5-1.3,2.4-1.9s.1-.4.2-.7.9-.8,1.3-1.2,2.5-2.2,3.6-3.2a22.6,22.6,0,0,0,2.9-2.9,2.9,2.9,0,0,1,1.1-1,5,5,0,0,0,2.4-2.3,15.1,15.1,0,0,1,3.9-3.3,18.5,18.5,0,0,0,3.7-3.1c1.2-1.3,1.4-2.5,3.1-3.8a54.5,54.5,0,0,0,4.9-4.4,20.2,20.2,0,0,1,3-2.5,3,3,0,0,1,1.5-.5c2.3-.2,4.2,0,6.3,0s2.4.2,3.7.2l2.6-.2a13.3,13.3,0,0,1,2.9-.1h16.2a40.5,40.5,0,0,1,6.4.4h1.4a25.2,25.2,0,0,1,5.3-.1h4.7a22.6,22.6,0,0,0,2.8,0,28.1,28.1,0,0,1,6.3-.3c1.8.1,3.9-.1,5.8-.1a31.5,31.5,0,0,1,5.3.3,18.7,18.7,0,0,0,3.4-.1,22.5,22.5,0,0,1,4,0,37.1,37.1,0,0,0,4.9,0h8.7a4.2,4.2,0,0,1,2,.1c.4.2,1.2,0,1.7,0,2.3,0,4.8-.2,6.8,0s6.1-.5,8.5-.2c-.3.3.3.2.5.2s.6.1.4.3a10.8,10.8,0,0,1-1.9,2.5c-1.5,1.3-2.8,2.6-4.2,3.9s-2.6,2.2-3.9,3.3-2.4,2.5-3.9,3.8-3,2.4-4.4,3.6a15.6,15.6,0,0,0-2.9,2.8,2.8,2.8,0,0,1-1.6,1.3c-1.2.4-1.1.9-1.8,1.4S1126.4,705.8,1126.6,705.8Z"
    }
  })]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.paper_active
    },
    attrs: {
      "id": "paper3"
    }
  }, [_c('path', {
    staticClass: "cls-81",
    attrs: {
      "d": "M1121.9,706.8h-.1a10.3,10.3,0,0,1-2.7,2.3c-.3.2-.6.4-.1.5s.3.1.1.3-.8.1-.8.3-1,.9-1.2,1.4a.9.9,0,0,1-.6.7,3.6,3.6,0,0,0-1.5,1.2,11.3,11.3,0,0,1-3.4,2.4c-.9.4-1.1.8-.8,1.1s-.1.2-.2.4h-.4c-.1.1.1.1.2.1h0a11.2,11.2,0,0,1-1.3,1.3c-1.2.9-2.3,1.8-3.3,2.8s-1.9,2.5-3.6,3.7l-2.7,2.1a1.8,1.8,0,0,1-.9.3c-1.2.2-2.1,0-3.4.2a3.1,3.1,0,0,1-2.1-.1,2.5,2.5,0,0,0-1.3,0,21.9,21.9,0,0,1-3.9.3h-4.5c-.5,0-1.3.2-1.6.1s-4.1-.3-6.4-.2h-7.8c-2.8,0-5.8.3-8.4.2a17,17,0,0,1-2.2.1,26.4,26.4,0,0,0-3.9-.1c-2.1-.1-4.8.3-6.7-.1a13,13,0,0,0-3.1.1,16.4,16.4,0,0,1-3.9.1,29.5,29.5,0,0,0-4.9-.1c-2,0-4.1.1-5.9,0s-4.3.1-6.2,0-4.7,0-6.9-.1h-7.8l-2.8.2a35.7,35.7,0,0,1-5.3.3c-3.1-.2-6.6-.1-9.8-.2-1.3,0-2.9.2-3-.5l3.9-3.3a1.3,1.3,0,0,0,.4-.6,4.3,4.3,0,0,1,2.5-2.3,8.8,8.8,0,0,0,1.8-1.4l1.5-1.1c1.4-.9,1.4-1.6,2-2.5a6.9,6.9,0,0,1,2.3-2.2c1-.6,1.5-1.3,2.4-1.9s.1-.4.2-.7.9-.8,1.3-1.2,2.5-2.2,3.6-3.2a22.6,22.6,0,0,0,2.9-2.9,2.9,2.9,0,0,1,1.1-1,5,5,0,0,0,2.4-2.3,15.1,15.1,0,0,1,3.9-3.3,18.5,18.5,0,0,0,3.7-3.1c1.2-1.3,1.4-2.5,3.1-3.8a54.5,54.5,0,0,0,4.9-4.4,20.2,20.2,0,0,1,3-2.5,3,3,0,0,1,1.5-.5c2.3-.2,4.2,0,6.3,0s2.4.2,3.7.2l2.6-.2a13.3,13.3,0,0,1,2.9-.1h16.2a40.5,40.5,0,0,1,6.4.4h1.4a25.2,25.2,0,0,1,5.3-.1h4.7a22.6,22.6,0,0,0,2.8,0,28.1,28.1,0,0,1,6.3-.3c1.8.1,3.9-.1,5.8-.1a31.5,31.5,0,0,1,5.3.3,18.7,18.7,0,0,0,3.4-.1,22.5,22.5,0,0,1,4,0,37.1,37.1,0,0,0,4.9,0h8.7a4.2,4.2,0,0,1,2,.1c.4.2,1.2,0,1.7,0,2.3,0,4.8-.2,6.8,0s6.1-.5,8.5-.2c-.3.3.3.2.5.2s.6.1.4.3a10.8,10.8,0,0,1-1.9,2.5c-1.5,1.3-2.8,2.6-4.2,3.9s-2.6,2.2-3.9,3.3-2.4,2.5-3.9,3.8-3,2.4-4.4,3.6a15.6,15.6,0,0,0-2.9,2.8,2.8,2.8,0,0,1-1.6,1.3c-1.2.4-1.1.9-1.8,1.4S1121.8,706.8,1121.9,706.8Z"
    }
  })]), _vm._v(" "), _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-left",
      value: (_vm.acid),
      expression: "acid",
      modifiers: {
        "top-left": true
      }
    }],
    staticClass: "lift",
    attrs: {
      "id": "acid"
    }
  }, [_c('g', [_c('path', {
    staticClass: "cls-128",
    attrs: {
      "d": "M1228.1,708.5h-58c-2.1,0-4.4,0-6.1-1.4s-2.1-3.4-2.2-5.4-.1-2.7-.1-4,0-.9,0-1.3,0-.9,0-1.4,0-.9,0-1.4,0-1,0-1.5,0-1,0-1.5,0-1,0-1.5,0-1,0-1.6,0-1.1,0-1.6,0-1.1,0-1.6,0-1.1,0-1.6,0-1.1,0-1.7,0-1.1,0-1.7,0-1.1,0-1.7,0-1.1,0-1.7,0-1.1,0-1.7,0-1.1,0-1.7,0-1.1,0-1.7,0-1.1,0-1.7,0-1.1,0-1.6,0-1.1,0-1.6,0-1.1,0-1.6,0-1,0-1.6,0-1,0-1.5,0-1,0-1.5,0-1,0-1.5,0-.9,0-1.4,0-.9,0-1.4,0-.9,0-1.3,0-.8,0-1.3,0-.8,0-1.2,0-.8,0-1.1,0-.7,0-1.1,0-.7,0-1,0-.6,0-.9v-.8c0-.3,0-.5,0-.8v-.7c0-.2,0-.4,0-.6v-.5c0-.1,0-.3,0-.4v-.4h0a8,8,0,0,1,8-8h50a8,8,0,0,1,8,8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-129",
    attrs: {
      "d": "M1220.7,708.5h-51.5c-1.8,0-3.9,0-5.4-1.3s-1.9-3.1-2-4.9-.1-2.5-.1-3.7,0-.8,0-1.2,0-.8,0-1.3v-1.3q0-.7,0-1.3t0-1.4,0-1.4,0-1.4,0-1.5,0-1.5,0-1.5,0-1.5,0-1.5c0-.5,0-1,0-1.5s0-1,0-1.5,0-1,0-1.5,0-1,0-1.5v-1.5q0-.8,0-1.5c0-.5,0-1,0-1.5s0-1,0-1.5,0-1,0-1.5,0-1,0-1.4,0-.9,0-1.4V664q0-.7,0-1.3t0-1.3,0-1.3,0-1.2,0-1.2c0-.4,0-.7,0-1.1s0-.7,0-1,0-.7,0-1v-.9q0-.4,0-.8v-.8c0-.2,0-.5,0-.7v-.6c0-.2,0-.3,0-.5v-.4c0-.1,0-.2,0-.3v-.2h0a7.2,7.2,0,0,1,7.1-7.3h44.5a7.2,7.2,0,0,1,7.1,7.3Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-130",
    attrs: {
      "x": "1165.7",
      "y": "657.8",
      "width": "62.3",
      "height": "22.02"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-131",
    attrs: {
      "x": "1165.7",
      "y": "671.1",
      "width": "62.4",
      "height": "9.01"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-130",
    attrs: {
      "x": "1165.7",
      "y": "678.3",
      "width": "62.4",
      "height": "4.51"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-132"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.03, 0, 0.01, 0.1, 1186.69, 584.64)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-133",
    attrs: {
      "d": "M1194,639.3h-18.5V630c0-.6,1-1.2,2.2-1.2h14c1.2,0,2.2.5,2.2,1.2Z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-101"
  }, [_c('g', {
    staticClass: "cls-134"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, 0, 0, 0.02, 1180.98, 620.19)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('text', {
    staticClass: "cls-135",
    attrs: {
      "transform": "translate(1167.3 669.1)"
    }
  }, [_vm._v("ΟΞΥ")]), _vm._v(" "), _c('g', {
    staticClass: "cls-136"
  }, [_c('g', [_c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1227.8,652.1c0,1,.1,1.8-.8,1.8h-9.4a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4c1,0,.8.8.8,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1228,691.5c0,1-.1,1.8-1.1,1.8h-9.4a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4c1,0,1.1.8,1.1,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1228.1,700.8c0,1-.2,1.8-1.1,1.8h-9.4a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4c1,0,1.1.8,1.1,1.8Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1228.1,663.5c0,1-.4,1.8-1.4,1.8h-9.3a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.3c.9,0,1.4.8,1.4,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1228.1,672.1c0,1-.4,1.8-1.4,1.8h-9.3a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.3c.9,0,1.4.8,1.4,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1228.1,681.3c0,1-.4,1.8-1.4,1.8h-9.3a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.3c.9,0,1.4.8,1.4,1.8Z"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-1",
    attrs: {
      "x": "1208.9",
      "y": "646.7",
      "width": "18.9",
      "height": "62"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-136"
  }, [_c('g', {
    staticClass: "cls-138"
  }, [_c('g', [_c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1177.1,708.5h-9.3a10.3,10.3,0,0,1-3.3-.9h0c0-1,.5-.9,1.4-.9h9.4a1.8,1.8,0,0,1,1.7,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1184.9,708.5a1.8,1.8,0,0,1-1.7,1.8h-9.4a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4a1.8,1.8,0,0,1,1.7,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1193.1,708.5a1.8,1.8,0,0,1-1.7,1.8H1182a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4a1.8,1.8,0,0,1,1.7,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1201.4,708.5a1.8,1.8,0,0,1-1.7,1.8h-9.4a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4a1.8,1.8,0,0,1,1.7,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1210.1,708.5a1.8,1.8,0,0,1-1.7,1.8H1199a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4a1.8,1.8,0,0,1,1.7,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1217.4,708.5a1.8,1.8,0,0,1-1.7,1.8h-9.4a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4a1.8,1.8,0,0,1,1.7,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-137",
    attrs: {
      "d": "M1225.4,708.5a1.8,1.8,0,0,1-1.7,1.8h-9.4a1.8,1.8,0,0,1-1.7-1.8h0a1.8,1.8,0,0,1,1.7-1.8h9.4a1.8,1.8,0,0,1,1.7,1.8Z"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-101"
  }, [_c('g', {
    staticClass: "cls-139"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.03, -0.11, 0, 1314.69, 667.22)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.ink1),
      expression: "ink1"
    }],
    staticClass: "lift",
    attrs: {
      "id": "ink1"
    }
  }, [_c('g', [_c('ellipse', {
    staticClass: "cls-140",
    attrs: {
      "cx": "1046.8",
      "cy": "773.5",
      "rx": "12.5",
      "ry": "11"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-140",
    attrs: {
      "cx": "1046.8",
      "cy": "721.6",
      "rx": "12.5",
      "ry": "11"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-140",
    attrs: {
      "x": "1034.4",
      "y": "720.4",
      "width": "25.1",
      "height": "53.12"
    }
  }), _vm._v(" "), _c('g', [_c('ellipse', {
    staticClass: "cls-141",
    attrs: {
      "cx": "1046.8",
      "cy": "718",
      "rx": "12.5",
      "ry": "5.9"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-141",
    attrs: {
      "points": "1034.5 716.7 1036.5 712.9 1039.5 712.3 1041.2 709.7 1043.5 707.6 1047.2 707.6 1047.2 718.2"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-141",
    attrs: {
      "points": "1058.8 716.7 1056.8 712.9 1053.7 712.3 1052.1 709.7 1049.7 707.6 1046.1 707.6 1046.1 718.2"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-142",
    attrs: {
      "points": "1042.9 708.7 1042.9 703.4 1044.4 701.9 1045.2 697.6 1047.2 697.6 1047.2 709.2"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-142",
    attrs: {
      "points": "1050.6 708.7 1050.6 703.4 1049.1 701.9 1048.2 697.6 1046.2 697.6 1046.2 709.2"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-142",
    attrs: {
      "cx": "1047.2",
      "cy": "708.9",
      "rx": "4.3",
      "ry": "0.9"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-143",
    attrs: {
      "d": "M1059.6,754.1a18.3,18.3,0,0,1-13,5.6,15.5,15.5,0,0,1-12.2-5.6V730.7s2.5,5,12.2,4.9,13-4.9,13-4.9Z"
    }
  }), _vm._v(" "), _c('g', [_c('path', {
    attrs: {
      "d": "M1039,747.7c-.1.2-.4.2-.8,0l-.5-.5v.3a8.8,8.8,0,0,0,.1,1.2l-.9-.7a6.6,6.6,0,0,1-.1-1.2v-3.3l1,.8q0,.9,0,1.8a1.2,1.2,0,0,0,.5,1c.3.2.5.1.5,0v-2.1l1.1.6v2.1a.5.5,0,0,0,.3.5v.7h-.4a1.5,1.5,0,0,1-.8-.9Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1043.7,749.7a2.6,2.6,0,0,1-1.4-.1c-.8-.2-1.6-.9-1.6-1.6s.4-.5.8-.4h0a1.2,1.2,0,0,1-.6-.9c0-.4.5-.6,1.6-.3l1.2.6-.2.6-.9-.4c-.4-.1-.6-.1-.6.1s.3.4.8.5h.4v.6h-.4c-.5-.1-.9-.2-.9,0s.3.5.7.6h1Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1046,748.9l-.2-.7h0l-.2.6-.5,1.4-1.2-.2,1.3-2.7V747a1.2,1.2,0,0,0-.8-.7h-.2v-.7h.4c.9.1,1.3.8,1.7,1.6l1.4,3.2h-1.3Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1051.9,746.5c-.1.5-.1,1.4-.1,2.1s.1.4.3.3v.7l-.4.2c-.4.1-.7,0-.8-.4h0a1.7,1.7,0,0,1-1.2.8,1.3,1.3,0,0,1-1.6-1.4,2,2,0,0,1,1.7-1.9,1,1,0,0,1,1,.3h0v-.4Zm-1.9,2.9a.9.9,0,0,0,.7-.7,2.2,2.2,0,0,0,0-.3,1.3,1.3,0,0,0,0-.3.5.5,0,0,0-.7-.5,1,1,0,0,0-.7,1C1049.3,749.1,1049.5,749.4,1050,749.4Zm1.1-4-.6,1.1h-.8l.4-1Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1053.5,746l.5,1.2.2.7h0a6.8,6.8,0,0,0,.6-2.2c0-.1,0-.2,0-.2l1-.6v.2a9.6,9.6,0,0,1-1.2,3.5l-1.1.5-1.3-2.6Z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M1057.3,745.8c0,.2.1.2.3.1v.7l-.4.4c-.5.4-.8.4-.8-.3v-2.2l1-.7Z"
    }
  })]), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-143",
    attrs: {
      "cx": "1046.7",
      "cy": "697.7",
      "rx": "1.5",
      "ry": "0.6"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-144"
  }, [_c('g', {
    staticClass: "cls-145"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, 0, 0, 0.07, 1041.97, 683.1)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-left",
      value: (_vm.ink2),
      expression: "ink2",
      modifiers: {
        "top-left": true
      }
    }],
    staticClass: "lift",
    attrs: {
      "id": "ink2"
    }
  }, [_c('g', [_c('g', [_c('rect', {
    staticClass: "cls-146",
    attrs: {
      "x": "1000.9",
      "y": "763.3",
      "width": "40.9",
      "height": "19.76"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-146",
    attrs: {
      "cx": "1021.3",
      "cy": "782.1",
      "rx": "20.5",
      "ry": "14.4"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-95",
    attrs: {
      "d": "M1038,781.2c0,6.5-7.5,11.7-16.7,11.7s-16.7-5.3-16.7-11.7V769.7c2.8-3.7,27-1.9,33.4-1.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-94",
    attrs: {
      "d": "M1021.2,780.5c0,6.5.2,12.4.2,12.4-9.2,0-16.7-5.3-16.7-11.7V769.7c2.8-3.7,27-1.9,33.4-1.9Z"
    }
  })]), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-93",
    attrs: {
      "cx": "1021.1",
      "cy": "768.5",
      "rx": "20.5",
      "ry": "14.4"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-147",
    attrs: {
      "cx": "1021.3",
      "cy": "763.5",
      "rx": "20.5",
      "ry": "14.4"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-144"
  }, [_c('g', {
    staticClass: "cls-148"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.02, 0.01, -0.05, -0.06, 1079.29, 808.14)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-101"
  }, [_c('g', {
    staticClass: "cls-149"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.01, 0.02, -0.07, -0.04, 1118.36, 784.55)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.gouzes_active
    },
    attrs: {
      "id": "gouza3"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-150",
    attrs: {
      "d": "M1141.7,750.5a1.5,1.5,0,0,1-1.5,1.6l-22.9.8v-3.1l22.9-.8a1.5,1.5,0,0,1,1.6,1.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-151",
    attrs: {
      "d": "M1141.7,751.3c0,.4-.7.7-1.5.8l-22.9.8v-1.4l22.9-.8c.8,0,1.5.3,1.6.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-152",
    attrs: {
      "d": "M1106.4,751.7a1.7,1.7,0,0,1-1.7,1.8l-22.3,1.1-3.6-4,25.7-.5a1.7,1.7,0,0,1,1.8,1.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-153",
    attrs: {
      "d": "M1106.4,751.7a1.7,1.7,0,0,1-1.7,1.8l-22.3,1.1-1.1-1.2,23.3-1c.9,0,1.7-1.5,1.7-.6Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-152",
    attrs: {
      "x": "1130.4",
      "y": "746.6",
      "width": "7.7",
      "height": "8.91",
      "transform": "translate(-24.8 38.9) rotate(-1.9)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-153",
    attrs: {
      "x": "1130.5",
      "y": "751.6",
      "width": "7.7",
      "height": "3.87",
      "transform": "translate(-24.9 38.9) rotate(-1.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-154",
    attrs: {
      "d": "M1171.9,749.2a14.7,14.7,0,0,1-14.2,15.1l-1-29.3A14.7,14.7,0,0,1,1171.9,749.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-16",
    attrs: {
      "d": "M1149.7,742.5c-3.9,1.7-12.5,1.2-12.5,1.2v7.9l.2,4.9s8.5-1,12.6.4,7.5,7,7.5,7l-.5-14.9v-2.7l-.4-11.4S1153.1,741.1,1149.7,742.5Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-155",
    attrs: {
      "points": "1118.5 751.3 1118.6 753.5 1082.4 754.6 1078.8 750.6 1118.4 749.1 1118.5 751.3 1118.5 751.3"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-156",
    attrs: {
      "d": "M1118.5,751.3v2.2l-36.1,1.1-1.1-1.2,35-1.1a3.7,3.7,0,0,0,2.2-1Z"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-157",
    attrs: {
      "points": "1080.7 750.5 1084.3 754.5 1082.4 754.6 1078.8 750.6 1080.7 750.5"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-158"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(0.05, 0, 0, 0.02, 1072.59, 749.59)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.gouzes_active
    },
    attrs: {
      "id": "gouza_2",
      "data-name": "gouza 2"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-150",
    attrs: {
      "d": "M1170.1,763.3a1.5,1.5,0,0,1-1.6,1.4l-22.9-1.6.2-3,22.9,1.6a1.5,1.5,0,0,1,1.4,1.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-151",
    attrs: {
      "d": "M1170.1,764.1c0,.4-.7.7-1.6.6l-22.9-1.6v-1.4l22.9,1.6c.8.1,1.5.4,1.5.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-152",
    attrs: {
      "d": "M1134.9,760.8a1.7,1.7,0,0,1-1.8,1.6l-25.6-1.8.2-3.4,25.6,1.8a1.7,1.7,0,0,1,1.6,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-153",
    attrs: {
      "d": "M1134.9,760.8a1.7,1.7,0,0,1-1.8,1.6l-25.6-1.8v-1.2l25.6,1.8c.9.1,1.9-1.3,1.8-.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-152",
    attrs: {
      "x": "1158.3",
      "y": "759.2",
      "width": "8.9",
      "height": "7.74",
      "transform": "translate(318.7 1868.4) rotate(-85.9)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-153",
    attrs: {
      "x": "1160.6",
      "y": "761.7",
      "width": "3.9",
      "height": "7.74",
      "transform": "translate(316.1 1870.6) rotate(-85.9)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-154",
    attrs: {
      "d": "M1200.3,765.2a14.7,14.7,0,0,1-15.7,13.6l2.1-29.2A14.7,14.7,0,0,1,1200.3,765.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-16",
    attrs: {
      "d": "M1179,756.2c-4.1,1.2-12.6-.1-12.6-.1l-.2,3.3V764l-.4,4.9s8.6-.1,12.5,1.7,6.7,7.8,6.7,7.8l1.1-14.9.2-2.7.8-11.3S1182.4,755.2,1179,756.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-152",
    attrs: {
      "d": "M1147.9,761.7l-1.1,2.1-39.4-2.8a2.1,2.1,0,0,1-1.6-2.2,2.3,2.3,0,0,1,1.9-2.1l39.5,2.8.7,2.2Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-156",
    attrs: {
      "d": "M1142.5,761.3c-.1.9-2.4,1.5-3.3,1.4l-31.5-2.1a1.6,1.6,0,0,1-1.5-1.7h0a1.6,1.6,0,0,1,1.7-1.5l31.5,2.1c.9.1,3.1.9,3.1,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-156",
    attrs: {
      "d": "M1147.9,761.7l-1.1,2.1-39.3-2.7a1.9,1.9,0,0,1-1.4-.7,1.5,1.5,0,0,1-.4-.9l38.9,2.8a10.3,10.3,0,0,0,3.2-.6Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-159"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(0.05, 0, 0, 0.02, 1099.07, 755.28)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.gouzes_active
    },
    attrs: {
      "id": "gouza1"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-150",
    attrs: {
      "d": "M1163.1,778.5a1.5,1.5,0,0,1-1.4,1.7l-22.8,2.4-.3-3,22.8-2.4a1.5,1.5,0,0,1,1.7,1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-151",
    attrs: {
      "d": "M1163.2,779.3c0,.4-.6.8-1.4.9l-22.8,2.4-.2-1.4,22.8-2.4c.8-.1,1.6.2,1.6.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-152",
    attrs: {
      "d": "M1128,782.2a1.7,1.7,0,0,1-1.5,1.9l-25.6,2.7-.4-3.4,25.6-2.7a1.7,1.7,0,0,1,1.9,1.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-153",
    attrs: {
      "d": "M1128,782.2a1.7,1.7,0,0,1-1.5,1.9l-25.6,2.7v-1.2l25.5-2.7c.9-.1,1.6-1.6,1.7-.7Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-152",
    attrs: {
      "x": "1151.9",
      "y": "775.1",
      "width": "7.7",
      "height": "8.91",
      "transform": "translate(-75.5 125.6) rotate(-6)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-153",
    attrs: {
      "x": "1152.2",
      "y": "780.1",
      "width": "7.7",
      "height": "3.87",
      "transform": "translate(-75.7 125.7) rotate(-6)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-154",
    attrs: {
      "d": "M1193.2,775a14.7,14.7,0,0,1-13,16.1L1177,762A14.7,14.7,0,0,1,1193.2,775Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-16",
    attrs: {
      "d": "M1170.6,769.9c-3.8,1.9-12.4,2.1-12.4,2.1l.3,3.3.2,1.6v1l.2,1.9.5,4.9s8.4-1.6,12.6-.5,8,6.5,8,6.5l-1.6-14.8-.3-2.7L1177,762S1173.8,768.3,1170.6,769.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-152",
    attrs: {
      "d": "M1142.2,780.7a2.2,2.2,0,0,1-1.9,2.4l-23.6,2.5-.5-4.3,23.6-2.5a2.2,2.2,0,0,1,2.4,1.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-153",
    attrs: {
      "d": "M1142.2,780.7a2.2,2.2,0,0,1-1.9,2.4l-23.6,2.5-.2-1.4,23.6-2.4a3.7,3.7,0,0,0,2.1-1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-160",
    attrs: {
      "d": "M1129.9,782c.1,1.4.5,2.5-.4,2.6l-17.3,1.8-.5-5.1,17.3-1.8c.9-.1.8,1.1.9,2.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-161",
    attrs: {
      "d": "M1129.9,782c.1,1.4.5,2.5-.4,2.6l-17.3,1.8v-.9l17.3-1.8c.9-.1.3-3.1.5-1.7Z"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-162"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(0.05, -0.01, 0.01, 0.03, 1098.29, 780.24)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.kalemi_active
    },
    attrs: {
      "id": "kalemi1"
    }
  }, [_c('g', [_c('rect', {
    staticClass: "cls-152",
    attrs: {
      "x": "938.4",
      "y": "761.8",
      "width": "7.7",
      "height": "4.83",
      "transform": "translate(-125.6 188.5) rotate(-10.7)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-153",
    attrs: {
      "x": "938.7",
      "y": "763.9",
      "width": "7.7",
      "height": "3.08",
      "transform": "translate(-125.8 188.4) rotate(-10.7)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-163",
    attrs: {
      "d": "M975.9,757.9a10.8,10.8,0,0,1-8.6,12.6l-4-21.2A10.8,10.8,0,0,1,975.9,757.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-164",
    attrs: {
      "d": "M953.3,758.6c-2.7,1.5-8.8,2.3-8.8,2.3v.5l.2,1.2v.8l.3,1.3.4,2.2s5.9-1.7,8.9-1,6.6,5.7,6.6,5.7l-2-10.8-.4-1.9-1.5-8.1S956.1,757,953.3,758.6Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-89",
    attrs: {
      "x": "959.1",
      "y": "748.9",
      "width": "8.3",
      "height": "23.06",
      "rx": "1",
      "ry": "1",
      "transform": "translate(-121.3 186.2) rotate(-10.4)"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-68",
    attrs: {
      "points": "938.1 763 944.3 761.9 944.5 762.8 939.8 763.8 938.3 764.1"
    }
  }), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "cls-152",
    attrs: {
      "d": "M915.8,768.5c0,.2-.7.5-1.6.7L892.3,773l-.2-.9,22-3.7c.9-.2,1.7-.1,1.7.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-153",
    attrs: {
      "d": "M915.8,768.5c0,.2-.7.5-1.6.7L892.3,773h-1l22.8-4c.9-.2,1.7-.6,1.7-.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-155",
    attrs: {
      "points": "943.3 763.3 940.3 764.8 892.3 773 892.1 772.1 927.6 766 940.8 763.7 943.3 763.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-156",
    attrs: {
      "d": "M939.3,764.5v.4L892.3,773h-1l34.2-5.8a12.1,12.1,0,0,0,2.1-.6Z"
    }
  })]), _vm._v(" "), _c('polyline', {
    staticClass: "cls-157",
    attrs: {
      "points": "894.9 771.6 895.1 772.2 894.9 772.6 891.2 772.6 894.9 771.6"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-165",
    attrs: {
      "points": "892.2 772.1 894.1 772.7 892.3 773 890.7 772.8 892.2 772.1"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-166"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(0.05, -0.01, 0.01, 0.02, 890.5, 771.94)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    class: {
      active: _vm.kalemi_active
    },
    attrs: {
      "id": "kalemi2"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-152",
    attrs: {
      "d": "M905.9,778.7c0,.4-.8.7-1.8.5l-22.1-3-3.2-2.3,25.5,3.8c.9.1,1.7.6,1.6,1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-153",
    attrs: {
      "d": "M905.9,778.7c0,.4-.8.7-1.8.5l-22.1-3-1-.7,23.1,3.2c.9.1,1.8-.4,1.8,0Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-155",
    attrs: {
      "points": "933.8 781.7 930.6 783 882 776.2 878.8 773.8 917.9 779.4 931.3 781.2 933.8 781.7"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-156",
    attrs: {
      "d": "M929.7,782.1v.7L882,776.2l-1-.7,34.6,5a6.4,6.4,0,0,0,2.2-.1Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-157",
    attrs: {
      "points": "880.6 774.1 883.9 776.4 882 776.2 878.8 773.8 880.6 774.1"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-152",
    attrs: {
      "x": "931.2",
      "y": "778.5",
      "width": "4.8",
      "height": "7.74",
      "transform": "matrix(0.13, -0.99, 0.99, 0.13, 39.88, 1609.97)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-153",
    attrs: {
      "x": "931.9",
      "y": "779.7",
      "width": "3.1",
      "height": "7.74",
      "transform": "matrix(0.13, -0.99, 0.99, 0.13, 38.45, 1610.82)"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-24",
    attrs: {
      "d": "M967.5,786.7a10.8,10.8,0,0,1-12.1,9.3l2.7-21.4A10.8,10.8,0,0,1,967.5,786.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-164",
    attrs: {
      "d": "M945.8,780.4c-3,.7-9-.5-9-.5v2.5l-.2,1.3-.3,2.2s6.1.2,8.7,1.8,4.6,7.4,4.6,7.4l1.4-10.9.2-1.9,1-8.2S948.9,779.7,945.8,780.4Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-89",
    attrs: {
      "x": "943.2",
      "y": "781",
      "width": "23.1",
      "height": "8.34",
      "rx": "1",
      "ry": "1",
      "transform": "translate(50.8 1628.4) rotate(-82.4)"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-167"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(0.05, 0, 0, 0.02, 875.25, 773.45)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-167"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(0.05, 0.01, 0, 0.02, 875.52, 774.61)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('polyline', {
    staticClass: "cls-68",
    attrs: {
      "points": "930 779.9 936.2 780.8 936.1 781.8 931.3 781.2 929.8 781"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-168",
    attrs: {
      "points": "880.9 774.3 882.2 775.5 881.1 775.5 878.8 773.8 880.6 774.1"
    }
  })])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.rolo),
      expression: "rolo"
    }],
    staticClass: "shake",
    attrs: {
      "id": "rolo_xilografia",
      "data-name": "rolo xilografia"
    }
  }, [_c('g', [_c('g', [_c('line', {
    staticClass: "cls-169",
    attrs: {
      "x1": "924.8",
      "y1": "698.4",
      "x2": "941.2",
      "y2": "689.2"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-20",
    attrs: {
      "cx": "937.7",
      "cy": "699.1",
      "r": "11.6",
      "transform": "translate(-139.6 1154.5) rotate(-59.6)"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-20",
    attrs: {
      "x": "954.9",
      "y": "682.6",
      "width": "23.2",
      "height": "66.79",
      "transform": "translate(-139.9 1187.7) rotate(-59.6)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-170",
    attrs: {
      "cx": "994.3",
      "cy": "732.2",
      "r": "11.6",
      "transform": "translate(-140.2 1219.8) rotate(-59.6)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-171",
    attrs: {
      "cx": "994.3",
      "cy": "732.2",
      "r": "7.2",
      "transform": "translate(-140.2 1219.8) rotate(-59.6)"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-24",
    attrs: {
      "cx": "994.3",
      "cy": "732.2",
      "r": "3.6",
      "transform": "matrix(0.51, -0.86, 0.86, 0.51, -140.29, 1219.6)"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-169",
    attrs: {
      "points": "994.3 732.2 986.2 735.6 923.9 699"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-172"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, 0.02, -0.01, 0.02, 967.03, 712.92)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('path', {
    staticClass: "cls-19",
    attrs: {
      "d": "M956,720.9,913.9,747a5.9,5.9,0,0,1-6.2-10l.8-.4,45.6-19.5a2.1,2.1,0,0,1,1.9,3.7Z"
    }
  }), _vm._v(" "), _c('g', [_c('polygon', {
    staticClass: "cls-16",
    attrs: {
      "points": "928.5 732.1 912.6 743.8 912.6 753.3 928.6 741.8 928.5 732.1"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-16",
    attrs: {
      "points": "894.4 741.2 904.7 746.2 912.6 743.8 928.5 732.1 921.3 728.3 899.1 736.6 894.4 741.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-16",
    attrs: {
      "points": "894.4 741.2 894.4 750.7 904.3 755.5 904.3 745.6 894.4 741.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-16",
    attrs: {
      "points": "904 746.2 912.9 742.9 912.7 753.3 904.3 755.5 904 746.2"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-173"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, -0.02, 0.01, 0.02, 892.17, 745.29)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('polyline', {
    staticClass: "cls-19",
    attrs: {
      "points": "952 714.6 947.7 722.7 963.5 721.9"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-174"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, -0.02, 0.01, 0.02, 918.67, 732.35)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-173"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, -0.02, 0.01, 0.02, 892.17, 745.29)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: (_vm.spoon),
      expression: "spoon",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "lift",
    attrs: {
      "id": "spoon"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-175",
    attrs: {
      "d": "M862.4,767.6c.8,5.4-4.5,11.2-8.5,14a42.8,42.8,0,0,1-8.1,4.2,12,12,0,0,1-12.1-1.5,8.1,8.1,0,0,0-8.4-1l-5.3,2.1-1-2.3-1.2-3.5c2.5-1.1,5.2-1.6,7.6-3.2a6.4,6.4,0,0,0,3-4.2c1.3-6,4.8-9.6,11-11a56,56,0,0,1,8.7-1.7c4.8-.3,10.9,1.1,13.5,5.6A7.2,7.2,0,0,1,862.4,767.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-176",
    attrs: {
      "d": "M784.5,802.4l34-14.4a2.1,2.1,0,0,0,1.6-2.5l-1-2.3-1.2-3.5c-.7-1.2-1.6-1.2-2.9-.8-11.2,3.9-22.4,7.7-33.6,11.5-3.6,1.2-5.8,3.3-6,7.2l1.2,3,.5.2A6.1,6.1,0,0,0,784.5,802.4Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-177",
    attrs: {
      "points": "817.6 779.6 820.1 785.5 825.8 783.3 820.7 778.5 817.6 779.6"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-178"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(-0.01, 0.01, 0, 0.01, 859.8, 769.01)",
      "xlink:href": "#image-2"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-179"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(0.01, -0.01, -0.01, -0.01, 829.41, 780.01)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-136"
  }, [_c('g', {
    staticClass: "cls-180"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(-0.02, 0.01, 0.01, 0.02, 823.41, 778)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "stool"
    }
  }, [_c('g', [_c('g', [_c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "605.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "602.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "599.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "596.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "593.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "590.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "587.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "584.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "581.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "578.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "575.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "572.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "569.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "566.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "563.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "560.9",
      "r": "3.3"
    }
  })]), _vm._v(" "), _c('g', [_c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "557.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "554.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "551.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "548.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "545.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "542.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "539.9",
      "r": "3.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-69",
    attrs: {
      "cx": "490.1",
      "cy": "536.9",
      "r": "3.3"
    }
  })])]), _vm._v(" "), _c('path', {
    staticClass: "cls-24",
    attrs: {
      "d": "M460.4,638.5a3.3,3.3,0,0,0,2.4,4h0a3.3,3.3,0,0,0,4.3-1.8l24.4-76.1a3.3,3.3,0,0,0-2.4-4h0a3.3,3.3,0,0,0-4.3,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M451.4,648.5a3.3,3.3,0,0,0,2.4,4h0a3.3,3.3,0,0,0,4.3-1.8l24.4-76.1a3.3,3.3,0,0,0-2.4-4h0a3.3,3.3,0,0,0-4.3,1.8Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-96",
    attrs: {
      "points": "507.6 585.9 472.6 585.9 482.6 555.9 497.6 555.9 507.6 585.9"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-96",
    attrs: {
      "d": "M528.7,648.5a3.3,3.3,0,0,1-2.4,4h0a3.3,3.3,0,0,1-4.3-1.8l-24.4-76.1a3.3,3.3,0,0,1,2.4-4h0a3.3,3.3,0,0,1,4.3,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-69",
    attrs: {
      "d": "M493.5,555.4a3.3,3.3,0,1,1-6.7,0"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-69",
    attrs: {
      "d": "M524.4,533.9a4.6,4.6,0,0,1-4.6,4.6,198.7,198.7,0,0,1-29.9,2.5,182.6,182.6,0,0,1-29.1-2.5,4.6,4.6,0,0,1-4.6-4.6h0a4.6,4.6,0,0,1,4.6-4.6h59a4.6,4.6,0,0,1,4.6,4.6Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-181",
    attrs: {
      "cx": "490.6",
      "cy": "529.9",
      "rx": "31",
      "ry": "4.5"
    }
  })])]), _vm._v(" "), _c('man'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "table"
    }
  }, [_c('g', [_c('g', [_c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "458.7 487.3 458.7 657.9 463 654.8 463 487.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-94",
    attrs: {
      "points": "448.6 487.3 448.6 657.9 458.8 657.9 458.8 487.3"
    }
  })]), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "764.7 487.3 764.7 657.9 769 654.8 769 487.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-94",
    attrs: {
      "points": "754.6 487.3 754.6 657.9 764.8 657.9 764.8 487.3"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-164",
    attrs: {
      "points": "719.3 509.3 386.9 509.3 446.2 474.7 773.3 474.7 719.3 509.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "400 519.3 400 689.9 404.4 686.8 404.4 519.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-94",
    attrs: {
      "points": "389.9 519.3 389.9 689.9 400.1 689.9 400.1 519.3"
    }
  }), _vm._v(" "), _c('g', [_c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "712.7 519.3 712.7 689.9 717 686.8 717 519.3"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-94",
    attrs: {
      "points": "702.6 519.3 702.6 689.9 712.8 689.9 712.8 519.3"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-94",
    attrs: {
      "x": "386.9",
      "y": "509.3",
      "width": "332.4",
      "height": "15.27"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "773.2 490.1 719.5 523.7 719.3 509.3 773.3 474.7"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-101"
  }, [_c('g', {
    staticClass: "cls-182"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.01, 0.02, -0.06, -0.02, 788.2, 495.4)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "paper_sheet",
      "data-name": "paper sheet"
    }
  }, [_c('g', [_c('polygon', {
    staticClass: "cls-94",
    attrs: {
      "points": "551.9 492.6 583.3 476.6 677.4 481.2 654 501.9 551.9 492.6"
    }
  }), _vm._v(" "), _c('image', {
    staticClass: "cls-136",
    attrs: {
      "width": "1011",
      "height": "805",
      "transform": "matrix(0, -0.02, 0.1, 0.01, 577.54, 492.25)",
      "xlink:href": require("../assets/img/textures/dots.png")
    }
  })])]), _vm._v(" "), _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.woodblock),
      expression: "woodblock"
    }],
    staticClass: "lift",
    attrs: {
      "id": "woodblock"
    }
  }, [_c('g', [_c('g', {
    staticClass: "cls-183",
    attrs: {
      "clip-path": "url(#clip-path-51)"
    }
  }, [_c('image', {
    attrs: {
      "width": "1284",
      "height": "1024",
      "transform": "translate(420.9 448.7) scale(0.11 0.07)",
      "xlink:href": require("../assets/img/textures/wood.png")
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-184",
    attrs: {
      "x": "422.9",
      "y": "499.1",
      "width": "93.7",
      "height": "4.91"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-185",
    attrs: {
      "points": "516.6 499.1 556.8 474.1 556.8 478.7 516.6 504 516.6 499.1"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "pencil-animation",
    attrs: {
      "id": "pencil"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-186",
    attrs: {
      "d": "M555,501.9h53.3c0,.5,0,1,0,1.6H555A1.7,1.7,0,0,0,555,501.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-187",
    attrs: {
      "d": "M608.3,506.5H555a1.6,1.6,0,0,0,0-1.5h53.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M555,504.9a1.6,1.6,0,0,1,0,1.5h-.1l-5.4-1.3c0-.3,0-.7,0-1a7.6,7.6,0,0,0-.1-1l5.7-1.3a1.7,1.7,0,0,1,0,1.6A1.1,1.1,0,0,1,555,504.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-189",
    attrs: {
      "d": "M612.4,506.5v-4.6h2c.9,0,1.4.7,1.5,1.9s0,.6,0,1-.6,1.8-1.4,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-190",
    attrs: {
      "d": "M549.3,503.2a1.3,1.3,0,0,1,.3,1,2.7,2.7,0,0,1-.2,1l-3.8-1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M610.9,501.9c0,.7,0,1.4,0,2.1s-.3.6-.7.6-.3-.4-.3-.6,0-1.4,0-2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M611.6,501.9c0,.7,0,1.4,0,2.1s0,.3-.1.3-.2-.2-.2-.3,0-1.4,0-2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M609.4,501.9v2.9h-.3q0-1.4,0-2.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-191",
    attrs: {
      "d": "M554.9,506.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-192",
    attrs: {
      "d": "M608.4,503.4q0,.7,0,1.5H555a1.1,1.1,0,0,0,0-1.4h53.4Z"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-193",
    attrs: {
      "x": "608.3",
      "y": "501.6",
      "width": "4.2",
      "height": "5.07"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "bottle_black",
      "data-name": "bottle black"
    }
  }, [_c('g', [_c('rect', {
    staticClass: "cls-8",
    attrs: {
      "x": "705.4",
      "y": "465.2",
      "width": "31.4",
      "height": "32.7",
      "rx": "8",
      "ry": "8"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-25",
    attrs: {
      "x": "716.4",
      "y": "459.6",
      "width": "8.8",
      "height": "5.84"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-194",
    attrs: {
      "x": "721.7",
      "y": "459.6",
      "width": "3.4",
      "height": "5.84"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-94",
    attrs: {
      "x": "707.5",
      "y": "476.2",
      "width": "27",
      "height": "7.5"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-195",
    attrs: {
      "x": "707.5",
      "y": "483.2",
      "width": "27",
      "height": "3.17"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', {
    staticClass: "cls-196"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, 0.01, -0.02, 0.06, 731.93, 425.22)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "vase_pencilsh",
      "data-name": "vase pencilsh"
    }
  }, [_c('g', [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-197",
    attrs: {
      "d": "M691.7,485.6l20.1-33.9.2-.4,1,.6L693,485.8l-.2.4A1.3,1.3,0,0,0,691.7,485.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-197",
    attrs: {
      "d": "M715,453.1l-.2.4-19.9,33.6-.2.3h0c-.2-.4-.6-.5-1-.6l.4-.6,20-33.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M693.6,486.8c.4.1.8.2,1,.6h0l-2.9,3-.6-.4-.7-.3,1.3-4.2a1.3,1.3,0,0,1,1,.6A.9.9,0,0,1,693.6,486.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-190",
    attrs: {
      "d": "M690.4,489.8a.9.9,0,0,1,.8.2l.6.5-2.2,2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-191",
    attrs: {
      "d": "M694.6,487.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-197",
    attrs: {
      "d": "M713.1,451.9l.9.6-20,33.7-.4.6a.9.9,0,0,0-.9-.5l.2-.4Z"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-198",
    attrs: {
      "points": "716.3 450.2 715 453.1 711.9 451.4 713.9 448.9 716.3 450.2"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-199",
    attrs: {
      "points": "714.5 449.2 713 452 711.9 451.4 713.9 448.9 714.5 449.2"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-198",
    attrs: {
      "d": "M713.8,448.9a1.3,1.3,0,0,1,1.7-.1c1.1.6.7,1.4.7,1.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-199",
    attrs: {
      "d": "M713.8,449l.5-.3h.8l-.3.2-.2.2c0,.1,0,.2-.1.2h-.3Z"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "cls-200",
    attrs: {
      "d": "M693.4,484.1l-2.8-39.3v-.4h1.2l2.8,39.3v.5A1.3,1.3,0,0,0,693.4,484.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-201",
    attrs: {
      "d": "M694.1,444.1v.4l2.7,39v.3h0a1.2,1.2,0,0,0-1.1.1v-.7l-2.7-39.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M695.7,483.9a1.2,1.2,0,0,1,1.1-.1h.1l-.7,4.1h-.7l-.7.2-1.3-4.2a1.3,1.3,0,0,1,1.2,0A.9.9,0,0,1,695.7,483.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-189",
    attrs: {
      "d": "M693.9,441l-3.4.3c0-.5-.1-1-.1-1.5s.5-1.1,1.3-1.2h.7c.8,0,1.3.3,1.4,1S693.8,440.5,693.9,441Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-190",
    attrs: {
      "d": "M694.7,488.2a.9.9,0,0,1,.7-.3h.8l-.6,2.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M690.5,442.4h1.6c.5-.1.5.2.5.5s-.3.2-.5.2h-1.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M690.5,441.8h1.8c0,.1-.1.2-.2.2h-1.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M690.6,443.5h2.1v.2h-2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-191",
    attrs: {
      "d": "M696.9,483.9h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-202",
    attrs: {
      "d": "M691.8,444.2h1.1l2.7,39.1v.7a.9.9,0,0,0-1.1.1v-.5Z"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-193",
    attrs: {
      "x": "690.4",
      "y": "441.1",
      "width": "3.8",
      "height": "3.15",
      "transform": "translate(-29.3 49.5) rotate(-4)"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "cls-203",
    attrs: {
      "d": "M695.7,490.4l.9-33.6v-.4h1.2l-.9,33.6c0,.1,0,.3,0,.4A1.5,1.5,0,0,0,695.7,490.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-198",
    attrs: {
      "d": "M700.1,456.5c0,.1,0,.3,0,.4l-.9,33.4v.3h0a1.3,1.3,0,0,0-1.1,0v-.6l.9-33.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M698,490.5a1.3,1.3,0,0,1,1.1,0h.1l-1.1,3.4h-1.5l-.9-3.7a1.5,1.5,0,0,1,1.2.1A1,1,0,0,1,698,490.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-189",
    attrs: {
      "d": "M700.2,453.9h-3.4c0-.4,0-.8,0-1.3s.6-.9,1.4-.9h.7c.8,0,1.3.4,1.3,1S700.2,453.4,700.2,453.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-190",
    attrs: {
      "d": "M696.6,494a1,1,0,0,1,.8-.2h.8l-.9,2.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M696.7,454.8h1.6c.5,0,.5.2.5.4s-.3.2-.5.2h-1.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M696.7,454.3h1.8c0,.1-.1.1-.2.1h-1.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M696.7,455.7h2.1c0,.1,0,.1,0,.2h-2.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-191",
    attrs: {
      "d": "M699.2,490.6h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-199",
    attrs: {
      "d": "M697.8,456.4h1.1l-.9,33.4v.6a1,1,0,0,0-1.1,0c0-.1,0-.3,0-.4Z"
    }
  })]), _vm._v(" "), _c('rect', {
    staticClass: "cls-193",
    attrs: {
      "x": "697.1",
      "y": "453.2",
      "width": "2.7",
      "height": "3.79",
      "transform": "translate(224 1140.6) rotate(-88.4)"
    }
  })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
    staticClass: "cls-204",
    attrs: {
      "d": "M699.1,485l4.9-39.1v-.4h1.2l-4.9,39.1v.5A1.3,1.3,0,0,0,699.1,485Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-205",
    attrs: {
      "d": "M707.4,445.9v.4l-4.8,38.8v.3h0a1.2,1.2,0,0,0-1.1-.1v-.7l4.8-38.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-188",
    attrs: {
      "d": "M701.3,485.3a1.2,1.2,0,0,1,1.1.1h.1l-1.5,3.9h-1.5l-.4-4.3a1.3,1.3,0,0,1,1.2.2A.9.9,0,0,1,701.3,485.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-190",
    attrs: {
      "d": "M699.6,489.3a.9.9,0,0,1,.8-.2l.7.2-1.2,2.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-191",
    attrs: {
      "d": "M702.5,485.5h0Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-206",
    attrs: {
      "d": "M705.2,445.6h1.1l-4.8,38.9v.7a.9.9,0,0,0-1.1-.1v-.5Z"
    }
  })]), _vm._v(" "), _c('polygon', {
    staticClass: "cls-207",
    attrs: {
      "points": "707.5 442.7 707.4 445.9 704 445.6 704.7 442.4 707.5 442.7"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-208",
    attrs: {
      "points": "705.5 442.5 705.2 445.7 704 445.6 704.7 442.4 705.5 442.5"
    }
  })]), _vm._v(" "), _c('g', [_c('path', {
    staticClass: "cls-89",
    attrs: {
      "d": "M687.8,464.5h22.4v39c0,2.6-1.2,4.8-2.7,4.8H690.5c-1.5,0-2.7-2.2-2.7-4.8Z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-209"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, 0, 0, 0.06, 695.69, 432.16)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "lamp_strings",
      "data-name": "lamp strings"
    }
  }, [_c('g', [_c('rect', {
    staticClass: "cls-210",
    attrs: {
      "x": "124",
      "y": "135.9",
      "width": "24.7",
      "height": "9.82"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-210",
    attrs: {
      "cx": "124.2",
      "cy": "140.7",
      "r": "3.5"
    }
  })]), _vm._v(" "), _c('g', [_c('rect', {
    staticClass: "cls-210",
    attrs: {
      "x": "475.7",
      "y": "135.9",
      "width": "24.7",
      "height": "9.82"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-210",
    attrs: {
      "cx": "500.2",
      "cy": "140.7",
      "r": "3.5"
    }
  })]), _vm._v(" "), _c('polyline', {
    staticClass: "cls-211",
    attrs: {
      "points": "135.3 137 309.2 16 486.3 135.5"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-211",
    attrs: {
      "cx": "309.3",
      "cy": "11.7",
      "r": "4"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-211",
    attrs: {
      "cx": "309.3",
      "cy": "2.7",
      "r": "4"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "lamp"
    }
  }, [_c('path', {
    staticClass: "cls-94",
    attrs: {
      "d": "M491.4,141.1a7.7,7.7,0,0,1-7.8,7.7H140.1a7.7,7.7,0,0,1-7.8-7.7h0a7.7,7.7,0,0,1,7.8-7.7H483.6a7.7,7.7,0,0,1,7.8,7.7Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "screen_light",
      "data-name": "screen light"
    }
  }, [_c('polygon', {
    staticClass: "cls-212",
    attrs: {
      "points": "309.9 410.2 -28.8 410.2 139.3 146.1 483.6 146.1 309.9 410.2"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sh_litho_overlay",
      "data-name": "sh litho overlay"
    }
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-213"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.03, -0.03, 0.36, -0.03, 23, 838.29)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('pagos-litho'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sink"
    }
  }, [_c('g', [_c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "567 834.5 567 1024 580.5 1023.4 580.5 867.8"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-94",
    attrs: {
      "points": "548.3 834.5 548.3 1024 567.2 1024 567.2 825.7"
    }
  })]), _vm._v(" "), _c('polyline', {
    staticClass: "cls-75",
    attrs: {
      "points": "436.6 899.5 436.6 1024 450.6 1024.1 450.6 899.5"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-94",
    attrs: {
      "x": "-3.7",
      "y": "875",
      "width": "440.5",
      "height": "149.43"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-69",
    attrs: {
      "points": "0 752 580.4 752 436 889.5 0 889.5"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-257",
    attrs: {
      "d": "M268.5,859.4c-4.1,3.6-3,6.6,2.5,6.7l149,.9c5.5,0,13.3-3,17.4-6.7l93.8-84.9c4.1-3.7,2.9-6.7-2.6-6.7H381.6c-5.5,0-13.4,3-17.5,6.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-75",
    attrs: {
      "points": "580.4 752 580.4 868.6 568 865.3 567.3 825.3 525.3 865.3 436.7 950 436 889.5 580.4 752"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-6",
    attrs: {
      "points": "0 867 0 829.6 67.3 781.5 338.1 781.5 241.5 866 0 867"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-258",
    attrs: {
      "d": "M463.2,821.7c0,2.4-3.1,4.3-7,4.3H327.3c-3.9,0-7-1.9-7-4.3h0c0-2.4,3.1-4.3,7-4.3H456.2c3.9,0,7,1.9,7,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-258",
    attrs: {
      "d": "M477.2,805.7c0,2.4-3.1,4.3-7,4.3H341.3c-3.9,0-7-1.9-7-4.3h0c0-2.4,3.1-4.3,7-4.3H470.2c3.9,0,7,1.9,7,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-258",
    attrs: {
      "d": "M491.9,790.4c0,2.4-3.1,4.3-7,4.3H356c-3.9,0-7-1.9-7-4.3h0c0-2.4,3.1-4.3,7-4.3H484.9c3.9,0,7,1.9,7,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-258",
    attrs: {
      "d": "M446.8,837.7c0,2.7-3.1,4.8-7,4.8H310.9c-3.9,0-7-2.2-7-4.8h0c0-2.7,3.1-4.8,7-4.8H439.8c3.9,0,7,2.2,7,4.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-258",
    attrs: {
      "d": "M428.2,855.7c0,2.5-3.1,4.6-7,4.6H292.3c-3.9,0-7-2.1-7-4.6h0c0-2.5,3.1-4.6,7-4.6H421.2c3.9,0,7,2.1,7,4.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-6",
    attrs: {
      "d": "M428.2,855.7c0,2.5-3.1,4.6-7,4.6H292.3c-3.9,0-7-2.1-7-4.6H428.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-6",
    attrs: {
      "d": "M447.2,838.7c0,2.5-3.1,4.6-7,4.6H311.3c-3.9,0-7-2.1-7-4.6H447.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-6",
    attrs: {
      "d": "M463.2,821.5c0,2.5-3.1,4.6-7,4.6H327.3c-3.9,0-7-2.1-7-4.6H463.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-6",
    attrs: {
      "d": "M477.2,805.3c0,2.5-3.1,4.6-7,4.6H341.3c-3.9,0-7-2.1-7-4.6H477.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-6",
    attrs: {
      "d": "M491.9,790.3c0,2.5-3.1,4.6-7,4.6H355.9c-3.9,0-7-2.1-7-4.6H491.9Z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', {
    staticClass: "cls-259"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.07, 0.32, 0.01, -96.15, 865.5)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-260"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.05, -0.05, 0.24, 0.2, 22.23, 631.38)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-261"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.07, 0.32, 0.01, -373.15, 864.5)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-262"
  }, [_c('g', {
    staticClass: "cls-263"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, -0.04, -0.2, 0.01, 626.62, 879.24)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', {
    staticClass: "cls-264"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, -0.04, -0.2, 0.01, 541.96, 870.02)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-265"
  }, [_c('g', {
    staticClass: "cls-266"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.01, -0.09, 0.32, 0, -16.36, 969.67)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-99"
  }, [_c('g', {
    staticClass: "cls-267"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.08, -0.02, 0.05, -0.32, 554.73, 1142.09)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "tap"
    }
  }, [_c('path', {
    staticClass: "cls-268",
    attrs: {
      "d": "M116.5,846c0,5.3-1.9,9.6-7.1,9.6H92.1c-5.2,0-7.1-4.3-7.1-9.6v-.4c0-5.3,1.9-9.6,7.1-9.6h17.3c5.2,0,7.1,4.3,7.1,9.6Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-268",
    attrs: {
      "d": "M109.8,846c0,5.8-3.1,10.5-8.8,10.5H85.6c-5.8,0-7.8-4.7-7.8-10.5v-.4c0-5.8,2.1-10.5,7.8-10.5H102c5.8,0,7.7,4.7,7.7,10.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-73",
    attrs: {
      "d": "M91,811.1a2.9,2.9,0,0,0-2.9-2.9h0a2.9,2.9,0,0,0-2.9,2.9v24.5a2.9,2.9,0,0,0,2.9,2.9h0a2.9,2.9,0,0,0,2.9-2.9Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-268",
    attrs: {
      "d": "M92.8,797.8c0-1-2.1-1.8-4.7-1.8h0c-2.6,0-4.7.8-4.7,1.8v15.7c0,1,2.1,1.8,4.7,1.8h0c2.6,0,4.7-.8,4.7-1.8Z"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-268",
    attrs: {
      "cx": "121.3",
      "cy": "875.5",
      "rx": "17.5",
      "ry": "6.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-269",
    attrs: {
      "d": "M126.3,868.5c0,5.2-2.5,5-5.7,5h0c-3.1,0-5.7.2-5.7-5v-122c0-5.2,2.5-9.5,5.7-9.5h0c3.1,0,5.7,4.3,5.7,9.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-73",
    attrs: {
      "d": "M130.5,872.9c0,2.3-4.3,2.1-9.5,2.1h0c-5.3,0-9.5.1-9.5-2.1V820.5c0-2.3,4.3-4.1,9.5-4.1h0c5.3,0,9.5,1.8,9.5,4.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-270",
    attrs: {
      "d": "M120.7,745c0-28.7,13-52,29-52s29,23.3,29,52"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-74",
    attrs: {
      "x": "171.3",
      "y": "736",
      "width": "14",
      "height": "12.33"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-271"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.05, -0.01, 0.02, -0.16, 131.67, 911.5)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('path', {
    staticClass: "cls-272",
    attrs: {
      "d": "M183.9,736c-2.5-27.9-16.7-48.7-34.2-48.7-19.4,0-34.6,25.3-34.6,57.7h.1c0,.5-.1,1-.1,1.5v70.8c-2.2.7-3.6,1.9-3.6,3.2v15.7l-2-.2H106a7.4,7.4,0,0,0-3.9-1H91V814.9c1.1-.3,1.8-.9,1.8-1.4V797.8c0-1-2.1-1.8-4.7-1.8s-4.7.8-4.7,1.8v15.7c0,.6.7,1.1,1.8,1.4V835c-5.5.2-7.5,4.8-7.5,10.5v.4c0,5.8,2.1,10.5,7.8,10.5h15.4a8.5,8.5,0,0,0,4.1-1h4.4l2-.2v15.1c-4.6,1.1-7.6,3-7.6,5.2s7.8,6.3,17.5,6.3,17.5-2.8,17.5-6.2-3.3-4.2-8.3-5.3V820.5c0-1.4-1.6-2.6-4.1-3.4V746.5c0-.5,0-1-.1-1.5h.1c0-12.9,2.8-25,7.8-34s10-12.3,15.6-12.3,11.2,4.5,15.6,12.3,6.3,15.5,7.3,25h-1.2v12.3h14V736Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "wash_basin",
      "data-name": "wash basin"
    }
  }, [_c('polyline', {
    staticClass: "cls-273",
    attrs: {
      "points": "564.8 705.4 553.6 758.4 459.5 839.4 461.2 796.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-274",
    attrs: {
      "d": "M307.6,796.5c-.3.9,15.2,43.5,15.2,43.5H459.3l3.3-45.6"
    }
  }), _vm._v(" "), _c('polyline', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.wash_basin),
      expression: "wash_basin"
    }],
    staticClass: "cls-16",
    attrs: {
      "points": "417.2 688.3 572.3 688.9 468.1 782.2 299.9 781.6"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-16",
    attrs: {
      "points": "318 774.9 417.6 695.5 553.3 696.8 465.9 775.4 318 774.9"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-275"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, -0.05, 0.16, 0.01, 331.96, 754.52)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-275"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, -0.05, 0.16, 0.01, 331.96, 754.52)",
      "xlink:href": "#image-2"
    }
  })])]), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-276"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, -0.04, 0.21, 0.17, 326.42, 626.1)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-7"
  }, [_c('g', {
    staticClass: "cls-277"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.02, -0.03, 0.12, 0.1, 351.68, 736.67)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('path', {
    staticClass: "cls-278",
    attrs: {
      "d": "M383.4,773.6s37.2-28,37.2-26.3-4.6-2.9,8-2.3,71,0,71,0l-35.1,29Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "cls-279",
    attrs: {
      "x": "299.9",
      "y": "781.6",
      "width": "167.6",
      "height": "21.18"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "cls-274",
    attrs: {
      "points": "572.3 688.9 573 707.9 467.4 802.8 467.4 781.6 570.9 689.9"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-136"
  }, [_c('circle', {
    staticClass: "cls-280",
    attrs: {
      "cx": "425.3",
      "cy": "761.2",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-281",
    attrs: {
      "cx": "438",
      "cy": "765.5",
      "r": "1.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-282",
    attrs: {
      "cx": "422.1",
      "cy": "752.6",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-283",
    attrs: {
      "cx": "411",
      "cy": "763.5",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-284",
    attrs: {
      "cx": "400",
      "cy": "764.2",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-285",
    attrs: {
      "cx": "461.4",
      "cy": "750.7",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-286",
    attrs: {
      "cx": "453",
      "cy": "760.3",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-287",
    attrs: {
      "cx": "448.1",
      "cy": "750.2",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-288",
    attrs: {
      "cx": "435.2",
      "cy": "742.5",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-289",
    attrs: {
      "cx": "414.8",
      "cy": "752.2",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-290",
    attrs: {
      "cx": "456.9",
      "cy": "740.6",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-291",
    attrs: {
      "cx": "468.1",
      "cy": "758.2",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-292",
    attrs: {
      "cx": "485.4",
      "cy": "742.5",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-293",
    attrs: {
      "cx": "476.6",
      "cy": "750.2",
      "r": "0.8"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-294",
    attrs: {
      "cx": "471.3",
      "cy": "742.7",
      "r": "0.8"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-262"
  }, [_c('g', {
    staticClass: "cls-295"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, -0.04, 0.15, -0.01, 259.08, 848.45)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-262"
  }, [_c('g', {
    staticClass: "cls-296"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.07, -0.02, 0.04, -0.27, 565.5, 1001.63)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "acid_multiply",
      "data-name": "acid multiply"
    }
  }, [_c('path', {
    staticClass: "cls-297",
    attrs: {
      "d": "M372.5,772.5l37.8-28.7s9.7-8.5,18.3-8.5l78.4.6-41.1,36.1Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "bubbles_overlay",
      "data-name": "bubbles overlay"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-298",
    attrs: {
      "cx": "465",
      "cy": "761.6",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-299",
    attrs: {
      "cx": "455.1",
      "cy": "767.5",
      "r": "1.3"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-300",
    attrs: {
      "cx": "472.9",
      "cy": "758.3",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-301",
    attrs: {
      "cx": "417.8",
      "cy": "768.2",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-302",
    attrs: {
      "cx": "482.4",
      "cy": "747.9",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-303",
    attrs: {
      "cx": "433.6",
      "cy": "756.4",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-304",
    attrs: {
      "cx": "442",
      "cy": "766",
      "r": "1.7"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-305",
    attrs: {
      "cx": "447",
      "cy": "756",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-306",
    attrs: {
      "cx": "459.8",
      "cy": "748.2",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-307",
    attrs: {
      "cx": "452.1",
      "cy": "744.4",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-308",
    attrs: {
      "cx": "438.2",
      "cy": "746.3",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-309",
    attrs: {
      "cx": "427",
      "cy": "763.9",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-310",
    attrs: {
      "cx": "409.6",
      "cy": "748.2",
      "r": "1.1"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-311",
    attrs: {
      "cx": "418.4",
      "cy": "756",
      "r": "0.8"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "cls-312",
    attrs: {
      "cx": "423.8",
      "cy": "748.4",
      "r": "0.8"
    }
  })]), _vm._v(" "), _c('circle', {
    staticClass: "cls-313",
    attrs: {
      "cx": "472",
      "cy": "753.6",
      "r": "1.1"
    }
  })]), _vm._v(" "), _c('g', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.brush),
      expression: "brush"
    }],
    staticClass: "brush-animation",
    attrs: {
      "id": "brush"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "cls-314",
    attrs: {
      "d": "M279.7,824.9l-18.9,24.6.3,6.1s-8.1-1.5-12.7-3.4a74.5,74.5,0,0,1-9-4.5l-1.4-7.8,21.2-24a30.4,30.4,0,0,0,13,7.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-19",
    attrs: {
      "d": "M282.6,859l5.3-1.2,18.3-12.6,15.6,4.4,23.9.9,18.7-.4,10.9-4.8-1.3-4.1-11.2-3.7-28.5-2.1s-25.9,1.6-25.9,1.9l-6.1-11.7-6.2-1.3c-4.3,0-21.5,25.1-21.5,25.1l2.8,7.6Z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-315",
    attrs: {
      "points": "282.6 859 287.9 857.8 306.1 845.2 321.8 849.6 345.7 850.5 364.4 850.1 373.9 848 375.2 845.4 363.3 846.7 331.3 845.7 307.2 842 288.1 850.6 281.5 852.2 277 851.9 274.4 849.5 277.2 857.1 282.6 859"
    }
  }), _vm._v(" "), _c('ellipse', {
    staticClass: "cls-316",
    attrs: {
      "cx": "362.6",
      "cy": "842.5",
      "rx": "1.7",
      "ry": "3.7",
      "transform": "translate(-496.8 1163.3) rotate(-87.2)"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-164",
    attrs: {
      "points": "262.6 856.4 260.9 849.4 280.5 823.6 297.7 824.3 281.7 852.3 282.6 859 262.6 856.4"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "cls-74",
    attrs: {
      "points": "260.8 856 260.9 849.4 260.9 849.4 281.7 852.3 281.7 852.3 282.6 859 260.8 856"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "cls-21"
  }, [_c('g', {
    staticClass: "cls-317"
  }, [_c('use', {
    staticClass: "cls-99",
    attrs: {
      "transform": "matrix(-0.09, -0.01, -0.01, 0.05, 392.4, 842.12)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "sponge"
    }
  }, [_c('g', {
    staticClass: "lift"
  }, [_c('g', [_c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M413.8,827.4a4.3,4.3,0,0,1-4.3,4.3h0a4.3,4.3,0,0,1-4.3-4.3h0a4.3,4.3,0,0,1,4.3-4.3h0a4.3,4.3,0,0,1,4.3,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M434,815a4.3,4.3,0,0,1-4.3,4.3h0a4.3,4.3,0,0,1-4.3-4.3h0a4.3,4.3,0,0,1,4.3-4.3h0A4.3,4.3,0,0,1,434,815Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M443.1,838.5a4.3,4.3,0,0,1-4.3,4.3h0a4.3,4.3,0,0,1-4.3-4.3h0a4.3,4.3,0,0,1,4.3-4.3h0a4.3,4.3,0,0,1,4.3,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M427.6,855.5a9.3,9.3,0,0,0-4.7-1.3h0a5.6,5.6,0,0,0-3.8,1.4h0c0-2.4,1.9-3.8,4.2-3.8h0c2.4,0,4.2,1.3,4.2,3.7Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M406.9,855.7a3.1,3.1,0,0,0-2.4-1.1h0a2.3,2.3,0,0,0-2,.8l-.8-1.2a3.3,3.3,0,0,1,3.1-3.1h0c2.4-.2,3.1,2,3.1,3.5Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M426.9,841.7a2.8,2.8,0,0,1-2.8,2.8h0a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8h0a2.8,2.8,0,0,1,2.8,2.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M454.7,815.9a1.8,1.8,0,0,1-1.8,1.8h0a1.8,1.8,0,0,1-1.8-1.8h0a1.8,1.8,0,0,1,1.8-1.8h0a1.8,1.8,0,0,1,1.8,1.8Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M397.3,847.4a4.3,4.3,0,0,1-4.3,4.3h0a4.3,4.3,0,0,1-4.3-4.3h0a4.3,4.3,0,0,1,4.3-4.3h0a4.3,4.3,0,0,1,4.3,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M407.6,840.6a2.3,2.3,0,0,1-2.3,2.3h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M414.9,815.4a2.3,2.3,0,0,1-2.3,2.3h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M401.6,833a2.3,2.3,0,0,1-2.3,2.3h0A2.3,2.3,0,0,1,397,833h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M450.2,821.2a2.3,2.3,0,0,1-2.3,2.3h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M438.9,825.9a2.3,2.3,0,0,1-2.3,2.3h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M457.8,837.3a2.3,2.3,0,0,1-2.3,2.3h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M457.9,827.7a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M428.9,829.5a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M421.1,820.6a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M405.5,819.6a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M394.4,828a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M417,838.3a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M410,847.1a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M416,846.6a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M390,832.5a4.5,4.5,0,0,1-4.4,4.4h.1s2.5-2,2.5-4.4h0c0-2.4.1-3.3.1-3.3h0c2.4,0,1.7,1,1.7,3.4Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M398.8,820.4a3,3,0,0,1-3,3h0a2.8,2.8,0,0,1-2.4-1.3,5.1,5.1,0,0,0,3-1.5,6,6,0,0,0,1.4-2.6,2.6,2.6,0,0,1,1.1,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M446.7,855.5a8.7,8.7,0,0,0-4.5-1.6h0a6.7,6.7,0,0,0-4.1,1.7v-.4a4.3,4.3,0,0,1,4.3-4.3h0a4.3,4.3,0,0,1,4.3,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M462.2,849a4.3,4.3,0,0,1-4.3,4.3h0a4.3,4.3,0,0,1-4.3-4.3h0a4.3,4.3,0,0,1,4.3-4.3h0a4.3,4.3,0,0,1,4.3,4.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M472.2,842.1c0,1.3-.6,2.4-1.9,2.4h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0c1.3,0,1.9.9,1.9,2.2Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M434.5,848.3a2.3,2.3,0,0,1-2.3,2.3h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M466.5,834.7a2.3,2.3,0,0,1-2.3,2.3h0a2.3,2.3,0,0,1-2.3-2.3h0a2.3,2.3,0,0,1,2.3-2.3h0a2.3,2.3,0,0,1,2.3,2.3Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M422.6,829.6a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M450.3,832.6a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M449.5,844.1a1.1,1.1,0,0,1-1.1,1.1h0a1.1,1.1,0,0,1-1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1h0a1.1,1.1,0,0,1,1.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M463.8,822.1a3,3,0,0,1-3,3h0a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3h0a4.3,4.3,0,0,0,1,1.9,7.3,7.3,0,0,0,2.1,1.1Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "cls-318",
    attrs: {
      "d": "M446.9,811c.3,1.9-1.3,3.1-3,3.1h0c-1.7,0-4.7-1.7-2.5-4.7h0a4.1,4.1,0,0,0,2.7,1.8,3.8,3.8,0,0,0,2.8-.2h0Z"
    }
  })]), _vm._v(" "), _c('path', {
    staticClass: "cls-16",
    attrs: {
      "d": "M470.3,844.5a2.3,2.3,0,1,1,2-3.3c0-.2,0-.4,0-.6,0-7.1-3.2-13.9-8.7-19.4a3,3,0,0,1,.1.8,3,3,0,1,1-3-3h.5a46,46,0,0,0-14.4-8.1h0a3,3,0,1,1-5.5-1.7,55.5,55.5,0,0,0-12.8-1.5,50.3,50.3,0,0,0-30.9,10.2,3,3,0,1,1-4.4,4,33.8,33.8,0,0,0-5.1,6.9,4.3,4.3,0,0,1-2.6,7.7h-.3a24,24,0,0,0-.5,4.7c0,10.4,6.9,13.4,17.6,14.1a2.7,2.7,0,0,1-.5-1.6,2.8,2.8,0,1,1,4.9,1.8c3.8.1,7.9,0,12.2-.1a4.3,4.3,0,0,1,8.5-.1h10.5c0-.1,0-.3,0-.4a4.3,4.3,0,1,1,8.6,0c0,.1,0,.3,0,.4,13.9-.1,23.8-2,25.3-12.2A2.1,2.1,0,0,1,470.3,844.5Zm-77-17.6a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,393.3,826.8Zm-.3,24.8a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,393,851.6Zm6.3-16.4a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,399.3,835.3Zm37.3-11.6a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,436.6,823.7Zm-23.9-10.6a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,412.7,813.1Zm-8.3,5.5a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,404.3,818.5Zm1,24.3a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,405.4,842.8Zm3.5,5.4a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,408.9,848.2Zm.7-16.5a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,409.6,831.7Zm5.4,16a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,414.9,847.7Zm1-8.3a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,415.9,839.4Zm2.9-18.7a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,418.9,820.6Zm1.5,8.9a1.1,1.1,0,1,1,1.1,1.1A1.1,1.1,0,0,1,420.4,829.6Zm3.8,15a2.8,2.8,0,1,1,2.8-2.8A2.8,2.8,0,0,1,424.2,844.5Zm3.6-13.9a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,427.8,830.6ZM425.4,815a4.3,4.3,0,1,1,4.3,4.3A4.3,4.3,0,0,1,425.4,815Zm6.8,35.5a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,432.3,850.5Zm6.5-7.8a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,438.8,842.8Zm18-16.2a1.1,1.1,0,1,1-1.1,1.1A1.1,1.1,0,0,1,456.8,826.6Zm-11.1-5.4a2.3,2.3,0,1,1,2.3,2.3A2.3,2.3,0,0,1,445.7,821.2Zm2.8,24a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,448.4,845.2Zm.8-11.4a1.1,1.1,0,1,1,1.1-1.1A1.1,1.1,0,0,1,449.2,833.8Zm2-17.9a1.8,1.8,0,1,1,1.8,1.8A1.8,1.8,0,0,1,451.2,815.9Zm4.3,19.1a2.3,2.3,0,1,1-2.3,2.3A2.3,2.3,0,0,1,455.5,835Zm2.5,18.3a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,458,853.3Zm6.3-16.4a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,464.3,836.9Z"
    }
  }), _vm._v(" "), _c('g', {
    staticClass: "cls-319"
  }, [_c('g', {
    staticClass: "cls-320"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0, 0.07, -0.25, 0, 594.88, 811.66)",
      "xlink:href": "#image-2"
    }
  })])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-321"
  }, [_c('g', {
    staticClass: "cls-319"
  }, [_c('g', {
    staticClass: "cls-320"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(0.04, 0.06, -0.2, 0.14, 529.98, 737.18)",
      "xlink:href": "#image-2"
    }
  })])])])])]), _vm._v(" "), _c('g', {
    staticClass: "cls-322"
  }, [_c('g', {
    staticClass: "cls-323"
  }, [_c('g', {
    staticClass: "cls-21"
  }, [_c('use', {
    attrs: {
      "transform": "matrix(-0.05, -0.06, 0.24, -0.23, 390.66, 1039.99)",
      "xlink:href": "#image-2"
    }
  })])])])]), _vm._v(" "), _c('cat'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "tooltips"
    }
  }, [_c('rect', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.pan),
      expression: "pan"
    }],
    staticClass: "tooltip-rect",
    attrs: {
      "id": "wash",
      "x": "350.9",
      "y": "689",
      "width": "273.9",
      "height": "145.16"
    }
  }), _vm._v(" "), _c('rect', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.sponge),
      expression: "sponge"
    }],
    staticClass: "tooltip-rect",
    attrs: {
      "id": "sfougari",
      "x": "383.3",
      "y": "810.1",
      "width": "92.5",
      "height": "45.61"
    }
  }), _vm._v(" "), _c('polygon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.lith_crayons),
      expression: "lith_crayons"
    }],
    staticClass: "tooltip-rect",
    attrs: {
      "id": "crayon-2",
      "data-name": "crayon",
      "points": "862.4 679.4 831.7 728.6 830.7 736 873.7 741.9 911 683.1 862.4 679.4"
    },
    on: {
      "mouseover": function($event) {
        _vm.crayon_active = true
      },
      "mouseleave": function($event) {
        _vm.crayon_active = false
      }
    }
  }), _vm._v(" "), _c('polygon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.burin),
      expression: "burin"
    }],
    staticClass: "tooltip-rect",
    attrs: {
      "id": "kalemia",
      "points": "957.4 741.9 898.3 761.1 873.7 762 870.8 803 975.1 803 981 752 957.4 741.9"
    },
    on: {
      "mouseover": function($event) {
        _vm.kalemi_active = true
      },
      "mouseleave": function($event) {
        _vm.kalemi_active = false
      }
    }
  }), _vm._v(" "), _c('polygon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.papers),
      expression: "papers"
    }],
    staticClass: "tooltip-rect",
    attrs: {
      "id": "papers",
      "points": "1156.8 679.9 1112.9 731.1 1062.9 730.8 1059.1 708.9 1050.6 691.5 1041.4 694 1028.2 732.1 1010.1 731.3 999.3 716 1035.3 683.7 1156.8 679.9"
    },
    on: {
      "mouseover": function($event) {
        _vm.paper_active = true
      },
      "mouseleave": function($event) {
        _vm.paper_active = false
      }
    }
  }), _vm._v(" "), _c('polygon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.gouges),
      expression: "gouges"
    }],
    staticClass: "tooltip-rect",
    attrs: {
      "id": "gouzes_tooltip",
      "points": "1212.1 759.2 1183 737 1151.2 726.7 1071.1 743.9 1091.1 797.2 1191.2 797.2 1212.1 759.2"
    },
    on: {
      "mouseover": function($event) {
        _vm.gouzes_active = true
      },
      "mouseleave": function($event) {
        _vm.gouzes_active = false
      }
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-288f7a33"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeSvg.vue
// module id = 560
// module chunks = 1